import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { OverlayModule } from '@angular/cdk/overlay';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RteNotificationCenterModule } from 'rte-notification-center';
import { DomSanitizer } from '@angular/platform-browser';
import { ColorPickerModule } from 'ngx-color-picker';
import { NestedTreeControl } from '@angular/cdk/tree';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { of, Subject, Subscription, fromEvent } from 'rxjs';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CdkTableModule } from '@angular/cdk/table';
import { FormsModule, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { __awaiter, __generator, __values } from 'tslib';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatFormFieldModule, MatPaginatorModule, MatProgressSpinnerModule, MatToolbarModule, MatSortModule, MatTableModule, MatSidenavModule, MatListModule, MatGridListModule, MatCardModule, MatMenuModule, MatExpansionModule, MatSnackBarModule, MatTreeModule, MatTabsModule, MatChipsModule, MatTooltipModule, MatProgressBarModule, MatDialogModule, MatCheckboxModule, MatStepperModule, MatIconModule, MatRippleModule, MatSelectModule, MatOptionModule, MatAutocompleteModule, MatInputModule, MatDividerModule, MatButtonModule, MatSort, MatPaginator, MatDialogConfig, MatButtonToggleModule, MatDatepickerModule, MatNativeDateModule, MatRadioModule, MatSliderModule, MatSlideToggleModule, MAT_DIALOG_DEFAULT_OPTIONS, MatIconRegistry, MatBadgeModule, MatTreeNestedDataSource, MatTableDataSource } from '@angular/material';
import '@angular/cdk/text-field';
import { catchError, map, filter, take, switchMapTo } from 'rxjs/operators';
import { Injectable, Inject, NgModule, Component, Input, ViewChild, NgZone, ElementRef, ContentChild, Output, EventEmitter, Directive, TemplateRef, HostListener, InjectionToken, defineInjectable, inject } from '@angular/core';
import { RTE_INTERCEPTOR_SKIP_HEADER, RteSnackbarService, RTE_APP_SERVICE_DATA, RTE_COOKIE_SERVICE_DATA, Company, CurrentUser, HttpHelper, RteMaterialModule, RteToolbarStatusEnum, RTEAlertService, RteDialog, EnumListService, RteLocalDataToolbarViewModel, RteToolbarDataSource, RteToolbarModule, RteAppTitleModule, RteToolbarMinorModule, ShowButton, RteToolbarViewModel, RteDialogRef, RteSortDirective, TabComponent, ShowToolbarMinorButton, RteLibraryModule, RteAutoCompleteModule, TabService, RteTabModule, TabParameter, RTE_COLOR_SERVICE_DATA, System } from 'rte-library';
import _ from 'lodash';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteCoreAppService = /** @class */ (function () {
    function RteCoreAppService() {
    }
    RteCoreAppService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    RteCoreAppService.ctorParameters = function () { return []; };
    /** @nocollapse */ RteCoreAppService.ngInjectableDef = defineInjectable({ factory: function RteCoreAppService_Factory() { return new RteCoreAppService(); }, token: RteCoreAppService, providedIn: "root" });
    return RteCoreAppService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteCoreAppComponent = /** @class */ (function () {
    function RteCoreAppComponent() {
    }
    /**
     * @return {?}
     */
    RteCoreAppComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    RteCoreAppComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-rte-core-app',
                    template: "\n    <p>\n      rte-core-app works!\n    </p>\n  "
                }] }
    ];
    /** @nocollapse */
    RteCoreAppComponent.ctorParameters = function () { return []; };
    return RteCoreAppComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteCoreAppModule = /** @class */ (function () {
    function RteCoreAppModule() {
    }
    RteCoreAppModule.decorators = [
        { type: NgModule, args: [{
                    imports: [],
                    declarations: [RteCoreAppComponent],
                    exports: [RteCoreAppComponent]
                },] }
    ];
    return RteCoreAppModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoginService = /** @class */ (function () {
    function LoginService(http, environment) {
        this.http = http;
        this.environment = environment;
    }
    /**
     * @param {?} username
     * @param {?} password
     * @param {?} companyId
     * @return {?}
     */
    LoginService.prototype.authenticate = /**
     * @param {?} username
     * @param {?} password
     * @param {?} companyId
     * @return {?}
     */
    function (username, password, companyId) {
        /** @type {?} */
        var data = 'username=' + username + '&password=' + password + '&grant_type=password' + '&auth_type=TMS' + '&CompanyId=' + companyId;
        /** @type {?} */
        var httpHeaders = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'No-Auth': 'True' });
        return this.http.post(this.environment.apiUrl + 'token', data, { headers: httpHeaders.set(RTE_INTERCEPTOR_SKIP_HEADER, '') });
    };
    /**
     * @return {?}
     */
    LoginService.prototype.getCompanies = /**
     * @return {?}
     */
    function () {
        return this.http.get(this.environment.apiCore + 'webapi/company/getall');
    };
    /**
     * @param {?} username
     * @return {?}
     */
    LoginService.prototype.getCompaniesByUser = /**
     * @param {?} username
     * @return {?}
     */
    function (username) {
        return this.http.get(this.environment.apiUrl + 'api/user/getcompanies?username=' + username);
    };
    /**
     * @return {?}
     */
    LoginService.prototype.getCompany = /**
     * @return {?}
     */
    function () {
        return this.http.get(this.environment.apiUrl + 'api/user/getcurrentusercompany');
    };
    /**
     * @param {?} userCompanyId
     * @param {?} userId
     * @param {?} newPassword
     * @param {?} confirmNewPassword
     * @return {?}
     */
    LoginService.prototype.saveNewPassword = /**
     * @param {?} userCompanyId
     * @param {?} userId
     * @param {?} newPassword
     * @param {?} confirmNewPassword
     * @return {?}
     */
    function (userCompanyId, userId, newPassword, confirmNewPassword) {
        return this.http.post(this.environment.apiUrl + "api/user/savenewpassword", {
            userCompanyId: userCompanyId,
            userId: userId,
            newPassword: newPassword,
            confirmNewPassword: confirmNewPassword
        });
    };
    LoginService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    LoginService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['environment',] }] }
    ]; };
    /** @nocollapse */ LoginService.ngInjectableDef = defineInjectable({ factory: function LoginService_Factory() { return new LoginService(inject(HttpClient), inject("environment")); }, token: LoginService, providedIn: "root" });
    return LoginService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DialogPasswordComponent = /** @class */ (function () {
    function DialogPasswordComponent(cookieService, appService, userService, rteSnackBarService, dialogRef, data) {
        this.cookieService = cookieService;
        this.appService = appService;
        this.userService = userService;
        this.rteSnackBarService = rteSnackBarService;
        this.dialogRef = dialogRef;
        this.data = data;
    }
    /**
     * @return {?}
     */
    DialogPasswordComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.newPasswordInput.nativeElement.focus();
        this.personalReadonlyDialogMode = true;
        this.companyId = this.data.companyId;
        this.userId = this.data.userId;
        this.username = this.data.username;
        this.password = this.data.password;
    };
    /**
     * @return {?}
     */
    DialogPasswordComponent.prototype.onSaveClick = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.userService.saveNewPassword(this.companyId, this.userId, this.newPassword, this.confirmNewPassword).subscribe(function (data) {
            if (data === true) {
                _this.rteSnackBarService.showSuccessMessage('Senha alterada com sucesso', 'OK');
                _this.appService.currentUser = _this.appService.currentUserNewPassword;
                _this.cookieService.setCookie('auth', JSON.stringify(_this.appService.currentUserNewPassword));
                _this.dialogRef.close();
            }
            else {
                _this.rteSnackBarService.showErrorMessage('Erro ao alterar senha', 'OK');
            }
        });
    };
    /**
     * @return {?}
     */
    DialogPasswordComponent.prototype.onCancelClick = /**
     * @return {?}
     */
    function () {
        this.dialogRef.close();
    };
    /**
     * @return {?}
     */
    DialogPasswordComponent.prototype.checkSizeNewPassword = /**
     * @return {?}
     */
    function () {
        if (this.newPassword.length < 5) {
            this.rteSnackBarService.showWarningMessage('A senha deve conter no mínimo 5 caracteres!', 'OK');
            this.newPasswordInput.nativeElement.focus();
        }
    };
    /**
     * @return {?}
     */
    DialogPasswordComponent.prototype.checkSizeAndPassword = /**
     * @return {?}
     */
    function () {
        if (this.confirmNewPassword.length < 5) {
            this.rteSnackBarService.showWarningMessage('A senha deve conter no mínimo 5 caracteres!', 'OK');
            this.confirmNewPasswordInput.nativeElement.focus();
        }
        else {
            if (this.newPassword !== this.confirmNewPassword) {
                this.rteSnackBarService.showWarningMessage('A nova senha e confirmação devem ser iguais!', 'OK');
                this.confirmNewPasswordInput.nativeElement.focus();
            }
        }
    };
    DialogPasswordComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-dialog-password',
                    template: "<div id=\"login-container\">\r\n  <div id=\"login-card\">\r\n\r\n    <div id=\"login-logo-container\">\r\n      <img src=\"assets/img_rodonaves.png\" id=\"login-logo\" />\r\n    </div>\r\n\r\n    <div id=\"login-fields-container\">\r\n      <mat-form-field>\r\n        <input matInput placeholder=\"Usu\u00E1rio\" [(ngModel)]=\"username\" [readonly]='personalReadonlyDialogMode' [ngClass]=\"{'personal-backgroud-readonly': personalReadonlyDialogMode}\" style=\"text-transform: uppercase\" />\r\n      </mat-form-field>\r\n\r\n      <mat-form-field>\r\n        <input matInput type=\"password\" placeholder=\"Senha Atual\" [(ngModel)]=\"password\" [readonly]='personalReadonlyDialogMode' [ngClass]=\"{'personal-backgroud-readonly': personalReadonlyDialogMode}\"/>\r\n      </mat-form-field>\r\n\r\n      <mat-form-field>\r\n        <input #newpassword matInput type=\"password\" placeholder=\"Nova Senha\" [(ngModel)]=\"newPassword\" (change)=\"checkSizeNewPassword()\"  />\r\n      </mat-form-field>\r\n\r\n      <mat-form-field>\r\n        <input #confirmnewpassword matInput type=\"password\" placeholder=\"Confirmar Senha\" [(ngModel)]=\"confirmNewPassword\" (change)=\"checkSizeAndPassword()\" />\r\n      </mat-form-field>\r\n\r\n      <mat-dialog-actions>\r\n        <button mat-button (click)=\"onSaveClick()\">Salvar</button>\r\n        <span class=\"spaceBetweenButton\"></span>\r\n        <button mat-button (click)=\"onCancelClick()\">Cancelar</button>\r\n      </mat-dialog-actions>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                    styles: ["#login-container{width:100%;text-align:center}#login-card{width:320px;display:inline-block}#login-logo-container{background-color:#0054a6;padding-bottom:10px;padding-top:10px}#login-logo-container img{width:226px;height:41px}#login-fields-container{padding:24px}.mat-form-field{display:block}.mat-button{background-color:#0054a6;color:#fff}.mat-dialog-actions{display:block}.spaceBetweenButton{padding-right:40px}.personal-backgroud-readonly{padding-top:5px;padding-bottom:3px;background-color:#d0cccc;padding-left:6px}button{border-radius:6px}"]
                }] }
    ];
    /** @nocollapse */
    DialogPasswordComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [RTE_COOKIE_SERVICE_DATA,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [RTE_APP_SERVICE_DATA,] }] },
        { type: LoginService },
        { type: RteSnackbarService },
        { type: MatDialogRef },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
    ]; };
    DialogPasswordComponent.propDecorators = {
        newPasswordInput: [{ type: ViewChild, args: ['newpassword', { read: ElementRef },] }],
        confirmNewPasswordInput: [{ type: ViewChild, args: ['confirmnewpassword', { read: ElementRef },] }]
    };
    return DialogPasswordComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoginComponent = /** @class */ (function () {
    function LoginComponent(appService, loginService, cookieService, dialog, currentRoute) {
        var _this = this;
        this.appService = appService;
        this.loginService = loginService;
        this.cookieService = cookieService;
        this.dialog = dialog;
        this.currentRoute = currentRoute;
        this.showContent = false;
        this.disableSelectCompany = false;
        this.httpHelper = new HttpHelper();
        this.passwordChanged = false;
        this.logoSrc = 'assets/img_rodonaves.png';
        this.hide = true;
        this.selectedCompany = null;
        document.body.classList.add('login-background');
        this.currentRoute.queryParams.subscribe(function (params) {
            /** @type {?} */
            var token = params.token;
            if (token != null) {
                window.location.href = window.location.href.substring(0, window.location.href.indexOf('?'));
                _this.fillCurrentUser(JSON.parse(token));
            }
            else {
                _this.showContent = true;
            }
        });
    }
    /**
     * @return {?}
     */
    LoginComponent.prototype.getSubDomain = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var splitdDomain = window.location.hostname.split('.');
        if (splitdDomain[1]) {
            return splitdDomain[1].toLowerCase();
        }
        return '';
    };
    /**
     * @return {?}
     */
    LoginComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var subDomain;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.appService.currentCompany = null;
                        subDomain = this.getSubDomain();
                        return [4 /*yield*/, this.getCompanies(subDomain)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @private
     * @param {?} subDomain
     * @return {?}
     */
    LoginComponent.prototype.getCompanies = /**
     * @private
     * @param {?} subDomain
     * @return {?}
     */
    function (subDomain) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, companyBySubDomain;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.loginService.getCompanies().toPromise()];
                    case 1:
                        _a.companies = _b.sent();
                        companyBySubDomain = this.companies.find(function (x) { return x.Acronym.toLowerCase() === subDomain.toLowerCase(); });
                        if (companyBySubDomain) {
                            // this.disableSelectCompany = true;
                            this.company = companyBySubDomain.Id.toString();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    LoginComponent.prototype.getLogo = /**
     * @return {?}
     */
    function () {
        if (this.companies) {
            return this.logoSrc;
        }
    };
    /**
     * @param {?} companyId
     * @param {?} userId
     * @return {?}
     */
    LoginComponent.prototype.openDialogNewPassword = /**
     * @param {?} companyId
     * @param {?} userId
     * @return {?}
     */
    function (companyId, userId) {
        /** @type {?} */
        var dialogRef = this.dialog.open(DialogPasswordComponent, {
            position: { top: '0' },
            panelClass: 'my-panel-password',
            data: {
                companyId: companyId,
                userId: userId,
                username: this.username.toUpperCase(),
                password: this.password.toUpperCase()
            }
        });
    };
    /**
     * @return {?}
     */
    LoginComponent.prototype.clickTrue = /**
     * @return {?}
     */
    function () {
        this.passwordChanged = !this.passwordChanged;
    };
    /**
     * @param {?} loginResult
     * @return {?}
     */
    LoginComponent.prototype.fillCurrentUser = /**
     * @param {?} loginResult
     * @return {?}
     */
    function (loginResult) {
        this.appService.currentUser = new CurrentUser();
        this.appService.currentUser.id = loginResult.userId;
        this.appService.currentUser.name = loginResult.name;
        this.appService.currentUser.companyId = loginResult.companyId;
        this.appService.currentUser.userCompanyId = loginResult.userCompanyId;
        this.appService.currentUser.accessToken = loginResult.access_token;
        this.appService.currentUser.isMaster = loginResult.isMaster;
        this.cookieService.setCookie('auth', JSON.stringify(this.appService.currentUser));
        document.body.style.background = 'none';
        document.body.classList.remove('login-background');
    };
    /**
     * @param {?} company
     * @return {?}
     */
    LoginComponent.prototype.fillCurrentCompany = /**
     * @param {?} company
     * @return {?}
     */
    function (company) {
        this.appService.currentCompany = new Company();
        this.appService.currentCompany.Id = company.Id;
        this.appService.currentCompany.Description = company.Description;
        this.appService.currentCompany.CompanyBackColor = company.CompanyBackColor;
        this.appService.currentCompany.CompanyForeColor = company.CompanyForeColor;
        this.appService.currentCompany.IconForeColor = company.IconForeColor;
        this.appService.currentCompany.SelectedBackColor = company.SelectedBackColor;
        this.appService.currentCompany.SelectedForeColor = company.SelectedForeColor;
        this.appService.currentCompany.RequiredFieldBackColor = company.RequiredFieldBackColor;
        this.appService.currentCompany.RequiredFieldForeColor = company.RequiredFieldForeColor;
        this.appService.currentCompany.ValidationFieldColor = company.ValidationFieldColor;
        this.appService.currentCompany.MenuColor = company.MenuColor;
        this.appService.currentCompany.PrimaryActionColor = company.PrimaryActionColor;
        this.appService.currentCompany.SecundaryActionColor = company.SecundaryActionColor;
        this.appService.currentCompany.InputColor = company.InputColor;
        this.appService.currentCompany.HoverMenuColor = company.HoverMenuColor;
        this.appService.currentCompany.LineMenuColor = company.LineMenuColor;
        this.appService.currentCompany.LogoWeb = company.LogoWeb;
        this.appService.currentCompany.WellcomeSystemMessage = company.WellcomeSystemMessage;
        this.appService.CompanyBackColor = this.appService.currentCompany.CompanyBackColor;
        this.appService.CompanyForeColor = this.appService.currentCompany.CompanyForeColor;
        this.appService.IconForeColor = this.appService.currentCompany.IconForeColor;
        this.appService.InputColor = this.appService.currentCompany.InputColor;
        this.appService.SelectedBackColor = this.appService.currentCompany.SelectedBackColor;
        this.appService.SelectedForeColor = this.appService.currentCompany.SelectedForeColor;
        this.appService.RequiredFieldBackColor = this.appService.currentCompany.RequiredFieldBackColor;
        this.appService.RequiredFieldForeColor = this.appService.currentCompany.RequiredFieldForeColor;
        this.cookieService.setCookie('company', JSON.stringify(this.appService.currentCompany));
        this.appService.currentCompany.BackgroundImage = company.BackgroundImage;
    };
    /**
     * @return {?}
     */
    LoginComponent.prototype.login = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.password) {
            this.passwordModel.control.setErrors({ 'errors': true });
            return;
        }
        this.errorMessage = null;
        this.loginService.authenticate(this.username.toUpperCase(), this.password.toUpperCase(), +this.company)
            .subscribe(function (loginResult) {
            _this.passwordWillChange = true;
            _this.passwordChanged = true;
            if (_this.passwordWillChange && !_this.passwordChanged) {
                _this.appService.currentUserNewPassword = new CurrentUser();
                _this.appService.currentUserNewPassword.id = loginResult.userId;
                _this.appService.currentUserNewPassword.name = loginResult.name;
                _this.appService.currentUserNewPassword.companyId = loginResult.companyId;
                _this.appService.currentUserNewPassword.userCompanyId = loginResult.userCompanyId;
                _this.appService.currentUserNewPassword.accessToken = loginResult.access_token;
                _this.appService.currentUserNewPassword.isMaster = loginResult.isMaster;
                _this.openDialogNewPassword(loginResult.companyId, loginResult.userId);
            }
            else {
                if (loginResult.access_token !== undefined) {
                    _this.fillCurrentUser(loginResult);
                }
            }
            //this.fillCurrentCompany();
        }, function (error) { return catchError(_this.handleError('login')); });
    };
    /**
     * @param {?} stepper
     * @return {?}
     */
    LoginComponent.prototype.setUser = /**
     * @param {?} stepper
     * @return {?}
     */
    function (stepper) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.username) {
                    this.usernameModel.control.setErrors({ 'errors': true });
                    return [2 /*return*/];
                }
                this.loginService.getCompaniesByUser(this.username.toUpperCase())
                    .subscribe(function (result) {
                    _this.userCompanies = result;
                    if (_this.userCompanies.length === 1) {
                        _this.company = _this.userCompanies[0].Id.toString();
                        _this.setCompany(stepper);
                        return;
                    }
                    stepper.next();
                    setTimeout(function () { return _this.companySelect.focus(); }, 100);
                }, function (error) { return catchError(_this.handleError('user')); });
                return [2 /*return*/];
            });
        });
    };
    /**
     * @param {?} stepper
     * @return {?}
     */
    LoginComponent.prototype.backToSelectUser = /**
     * @param {?} stepper
     * @return {?}
     */
    function (stepper) {
        var _this = this;
        stepper.previous();
        this.company = null;
        this.selectedCompany = null;
        this.companyModel.control.reset();
        this.userCompanies = [];
        this.usernameModel.control.setErrors({ 'errors': false });
        setTimeout(function () { return _this.usernameInput.nativeElement.focus(); }, 100);
    };
    /**
     * @param {?} stepper
     * @return {?}
     */
    LoginComponent.prototype.backToCompany = /**
     * @param {?} stepper
     * @return {?}
     */
    function (stepper) {
        var _this = this;
        this.passwordModel.control.reset();
        this.fillCurrentCompany(new Company());
        stepper.previous();
        if (this.selectedCompany) {
            if (this.selectedCompany.BackgroundImage) {
                document.body.style.background = 'url(assets/background_login.jpg) no-repeat center center fixed';
            }
            if (this.selectedCompany.WellcomeSystemMessage) {
                document.getElementsByClassName('rte-wellcome-msg')[0].innerHTML = 'Sistema �gil como a sua entrega.';
            }
            if (this.selectedCompany.LogoWeb) {
                document.getElementById('login-logo').setAttribute('src', this.logoSrc);
            }
            if (this.selectedCompany.MenuColor) {
                document.getElementById('login-logo-container').style.backgroundColor = '#0054a6';
            }
        }
        if (this.userCompanies.length === 1) {
            this.passwordModel.control.setErrors({ 'errors': false });
            this.backToSelectUser(stepper);
            return;
        }
        setTimeout(function () { return _this.companySelect.focus(); }, 100);
    };
    /**
     * @param {?} stepper
     * @return {?}
     */
    LoginComponent.prototype.setCompany = /**
     * @param {?} stepper
     * @return {?}
     */
    function (stepper) {
        var _this = this;
        if (!this.company) {
            this.companyModel.control.setErrors({ 'errors': true });
            return;
        }
        this.companySelect.close();
        stepper.next();
        this.selectedCompany = this.userCompanies.find(function (x) { return x.Id.toString() === _this.company; });
        this.fillCurrentCompany(this.selectedCompany);
        if (this.selectedCompany) {
            if (this.selectedCompany.BackgroundImage) {
                document.body.style.background = 'url(\'data:image/png;base64,'
                    + this.selectedCompany.BackgroundImage + '\') no-repeat center center fixed';
            }
            if (this.selectedCompany.WellcomeSystemMessage) {
                document.getElementsByClassName('rte-wellcome-msg')[0].innerHTML = this.selectedCompany.WellcomeSystemMessage;
            }
            if (this.selectedCompany.LogoWeb) {
                document.getElementById('login-logo').setAttribute('src', 'data:image/jpeg;base64,' + this.selectedCompany.LogoWeb);
            }
            if (this.selectedCompany.MenuColor) {
                document.getElementById('login-logo-container').style.backgroundColor = this.selectedCompany.MenuColor;
            }
        }
        setTimeout(function () { return _this.passwordInput.nativeElement.focus(); }, 100);
    };
    /**
     * @return {?}
     */
    LoginComponent.prototype.getUserErrorMessage = /**
     * @return {?}
     */
    function () {
        if (!this.username) {
            return 'Digite um login.';
        }
        else {
            return 'Login incorreto. Tente novamente.';
        }
    };
    /**
     * @return {?}
     */
    LoginComponent.prototype.getCompanyErrorMessage = /**
     * @return {?}
     */
    function () {
        if (!this.company) {
            return 'Escolha uma empresa.';
        }
    };
    /**
     * @return {?}
     */
    LoginComponent.prototype.getPasswordErrorMessage = /**
     * @return {?}
     */
    function () {
        if (!this.password) {
            return 'Digite sua senha.';
        }
        else {
            return 'Senha incorreta. Tente novamente.';
        }
    };
    /**
     * @template T
     * @param {?=} operation
     * @param {?=} result
     * @return {?}
     */
    LoginComponent.prototype.handleError = /**
     * @template T
     * @param {?=} operation
     * @param {?=} result
     * @return {?}
     */
    function (operation, result) {
        if (operation === void 0) { operation = 'operation'; }
        if (operation === 'user') {
            this.usernameModel.control.setErrors({ 'errors': true });
        }
        else if (operation === 'login') {
            this.passwordModel.control.setErrors({ 'errors': true });
        }
        return function (error) {
            return of((/** @type {?} */ (result)));
        };
    };
    LoginComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-login',
                    template: "<div id=\"login-container\" *ngIf=\"showContent\">\r\n  <div id=\"login-card\">\r\n    <mat-card>\r\n      <div id=\"login-logo-container\">\r\n        <img *ngIf=\"getLogo()\" [src]=\"getLogo()\" id=\"login-logo\" />\r\n      </div>\r\n      <div id=\"login-fields-container\">\r\n        <mat-horizontal-stepper #stepper>\r\n          <mat-step>\r\n            <ng-template matStepLabel>Login</ng-template>\r\n            <div class=\"row-form\">\r\n              <div class=\"column-form login-title\">\r\n                <p class=\"mat-h2\">Login</p>\r\n                <p class=\"mat-body1\">Entre com seu usu\u00E1rio</p>\r\n              </div>\r\n            </div>\r\n            <div class=\"row-form\">\r\n              <div class=\"column-form\">\r\n                <rte-form-field>\r\n                  <input (keyup.enter)=\"setUser(stepper)\" autofocus #usernameInput rteInput placeholder=\"Usu\u00E1rio\"\r\n                    [(ngModel)]=\"username\" style=\"text-transform: uppercase\" #usernameModel=\"ngModel\" />\r\n                  <mat-error>{{getUserErrorMessage()}}</mat-error>\r\n                </rte-form-field>\r\n              </div>\r\n            </div>\r\n            <div class=\"row-form\">\r\n              <div class=\"column-form\">\r\n              </div>\r\n              <div class=\"column-form\">\r\n                <button rtebutton (click)=\"setUser(stepper)\">Pr\u00F3ximo</button>\r\n              </div>\r\n            </div>\r\n          </mat-step>\r\n          <mat-step>\r\n            <ng-template matStepLabel>Empresa</ng-template>\r\n            <div class=\"row-form\">\r\n              <div class=\"column-form login-title\">\r\n                <p class=\"mat-h2\">Bem-vindo(a)</p>\r\n                <p class=\"mat-body1\">Identifique sua empresa</p>\r\n              </div>\r\n            </div>\r\n            <div class=\"row-form\">\r\n              <div class=\"column-form\">\r\n                <rte-form-field>\r\n                  <input autofocus #usernameInputReadOnly rteInput placeholder=\"Usu\u00E1rio\" [readonly]=\"true\"\r\n                    [(ngModel)]=\"username\" style=\"text-transform: uppercase\" />\r\n                </rte-form-field>\r\n              </div>\r\n            </div>\r\n            <div class=\"row-form\">\r\n              <div class=\"column-form\">\r\n                <rte-form-field>\r\n                  <rte-select (keyup.enter)=\"setCompany(stepper)\" #companySelect placeholder=\"Empresa\" \r\n                    [(ngModel)]=\"company\" [disabled]='disableSelectCompany' #companyModel=\"ngModel\" >\r\n                    <rte-option>\r\n                    </rte-option>\r\n                    <rte-option value=\"{{company.Id}}\" *ngFor=\"let company of companies\">{{company.Description}}\r\n                    </rte-option>\r\n                  </rte-select>\r\n                  <mat-error>{{getCompanyErrorMessage()}}</mat-error>\r\n                </rte-form-field>\r\n              </div>\r\n            </div>\r\n            <div class=\"row-form\">\r\n              <div class=\"column-form\">\r\n                <button rtebutton-stroked (click)=\"backToSelectUser(stepper)\">Voltar</button>\r\n              </div>\r\n              <div class=\"column-form\">\r\n                <button rtebutton (click)=\"setCompany(stepper)\">Pr\u00F3ximo</button>\r\n              </div>\r\n            </div>\r\n          </mat-step>\r\n          <mat-step>\r\n            <ng-template matStepLabel>Senha</ng-template>\r\n            <div class=\"row-form\">\r\n              <div class=\"column-form login-title\">\r\n                <p class=\"mat-h2\">Bem-vindo(a)</p>\r\n                <p class=\"mat-body1\">Informe sua senha.</p>\r\n              </div>\r\n            </div>\r\n            <div class=\"row-form\">\r\n              <div class=\"column-form\">\r\n                <rte-form-field>\r\n                  <input autofocus #usernameInput rteInput placeholder=\"Usu\u00E1rio\" [readonly]=\"true\"\r\n                    [(ngModel)]=\"username\" style=\"text-transform: uppercase\" />\r\n                </rte-form-field>\r\n              </div>\r\n            </div>\r\n            <div class=\"row-form\">\r\n              <div class=\"column-form\">\r\n                <rte-form-field>\r\n                  <input #passwordInput rteInput [type]=\"hide ? 'password' : 'text'\" placeholder=\"Senha\"\r\n                    [(ngModel)]=\"password\" #passwordModel=\"ngModel\" (keyup.enter)=\"login()\"/>\r\n                    <mat-icon  matSuffix class=\"material-icons\"(click)=\"hide = !hide\" >{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>\r\n                    <mat-error>{{getPasswordErrorMessage()}}</mat-error>\r\n                  </rte-form-field>\r\n              </div>\r\n            </div>\r\n            <div class=\"row-form\">\r\n              <div class=\"column-form\">\r\n                <button rtebutton-stroked (click)=\"backToCompany(stepper)\">Voltar</button>\r\n              </div>\r\n              <div class=\"column-form\">\r\n                <button rtebutton (click)=\"login()\">Entrar</button>\r\n              </div>\r\n            </div>\r\n          </mat-step>\r\n        </mat-horizontal-stepper>\r\n      </div>\r\n    </mat-card>\r\n  </div>\r\n  <div class=\"title\">\r\n    <p class=\"mat-display-4 rte-wellcome-msg\">Sistema \u00E1gil como a sua entrega.</p>\r\n  </div>\r\n</div>",
                    styles: [":host{font-size:16px}#login-logo-container{background-color:#0054a6;height:71px}#login-logo-container img{width:226px;height:41px}#login-fields-container{height:calc(100vh - 125px);display:flex;flex-direction:column;justify-content:center}.login-title{align-items:center}#login-logo{margin-bottom:15px;margin-top:15px}.mat-card{padding:0!important;height:100vh;width:400px}#login-container{width:100%;text-align:center;display:flex;flex-direction:row-reverse}#login-card{padding-right:15%}.mat-form-field{display:block}.mat-button{background-color:#0054a6;color:#fff}#login-error{color:red;margin-bottom:15px}button{border-radius:6px}p{text-align:left;margin:0}.title{color:#fff;display:flex;flex-direction:column;justify-content:center;padding-left:10%}.material-icons{cursor:pointer;margin-top:-18px;position:absolute;margin-left:-38px!important}"]
                }] }
    ];
    /** @nocollapse */
    LoginComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [RTE_APP_SERVICE_DATA,] }] },
        { type: LoginService },
        { type: undefined, decorators: [{ type: Inject, args: [RTE_COOKIE_SERVICE_DATA,] }] },
        { type: MatDialog },
        { type: ActivatedRoute }
    ]; };
    LoginComponent.propDecorators = {
        usernameInput: [{ type: ViewChild, args: ['usernameInput',] }],
        passwordInput: [{ type: ViewChild, args: ['passwordInput',] }],
        companySelect: [{ type: ViewChild, args: ['companySelect',] }],
        stepper: [{ type: ViewChild, args: ['stepper',] }],
        usernameModel: [{ type: ViewChild, args: ['usernameModel',] }],
        passwordModel: [{ type: ViewChild, args: ['passwordModel',] }],
        companyModel: [{ type: ViewChild, args: ['companyModel',] }]
    };
    return LoginComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteLoginModule = /** @class */ (function () {
    function RteLoginModule() {
    }
    /**
     * @param {?} environment
     * @return {?}
     */
    RteLoginModule.forRoot = /**
     * @param {?} environment
     * @return {?}
     */
    function (environment) {
        return {
            ngModule: RteLoginModule,
            providers: [
                LoginService,
                {
                    provide: 'environment',
                    useValue: environment
                }
            ]
        };
    };
    RteLoginModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        FormsModule,
                        CommonModule,
                        MatFormFieldModule,
                        RteMaterialModule,
                        MatPaginatorModule,
                        MatProgressSpinnerModule,
                        MatToolbarModule,
                        MatSortModule,
                        MatTableModule,
                        MatSidenavModule,
                        MatListModule,
                        MatGridListModule,
                        MatCardModule,
                        MatMenuModule,
                        MatExpansionModule,
                        MatSnackBarModule,
                        MatTreeModule,
                        MatTabsModule,
                        MatChipsModule,
                        MatTooltipModule,
                        MatProgressBarModule,
                        MatDialogModule,
                        MatCheckboxModule,
                        MatStepperModule,
                        MatIconModule
                    ],
                    exports: [LoginComponent],
                    declarations: [LoginComponent, DialogPasswordComponent]
                },] }
    ];
    return RteLoginModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UserService = /** @class */ (function () {
    function UserService(http, rteSnackBarService, environment) {
        this.http = http;
        this.rteSnackBarService = rteSnackBarService;
        this.environment = environment;
    }
    /**
     * @param {?} id
     * @return {?}
     */
    UserService.prototype.generatePassword = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        return this.http.get(this.environment.apiUrl + "api/user/createnewpassword?userId=" + id)
            .pipe(catchError(this.handleError('generatePassword')));
    };
    /**
     * @param {?} id
     * @return {?}
     */
    UserService.prototype.sendPassword = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        return this.http.post(this.environment.apiUrl + "api/user/sendnewpassword?userId=" + id, null)
            .pipe(catchError(this.handleError('sendPassword')));
    };
    /**
     * @param {?} id
     * @return {?}
     */
    UserService.prototype.getUserById = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        return this.http.get(this.environment.apiUrl + "api/user/getusersbyid?id=" + id)
            .pipe(catchError(this.handleError('getUserById')));
    };
    /**
     * @param {?} description
     * @return {?}
     */
    UserService.prototype.getUserByDescription = /**
     * @param {?} description
     * @return {?}
     */
    function (description) {
        return this.http.get(this.environment.apiUrl + "api/user/getusersbydescription?description=" + description)
            .pipe(catchError(this.handleError('getUserByDescription', [])));
    };
    /**
     * @param {?} id
     * @param {?} description
     * @param {?} login
     * @param {?} companyId
     * @param {?} page
     * @return {?}
     */
    UserService.prototype.getUsers = /**
     * @param {?} id
     * @param {?} description
     * @param {?} login
     * @param {?} companyId
     * @param {?} page
     * @return {?}
     */
    function (id, description, login, companyId, page) {
        if (id === undefined)
            id = 0;
        if (description === undefined)
            description = '';
        if (login === undefined)
            login = '';
        if (companyId === undefined)
            companyId = 0;
        return this.http.get(this.environment.apiUrl + "api/user/getusers?Id=" + id + "&description=" + description + "&login=" + login + "&companyId=" + companyId + "&page=" + page)
            .pipe(catchError(this.handleError('getUsers', [])));
    };
    /**
     * @param {?} user
     * @param {?} permissions
     * @param {?=} parameters
     * @return {?}
     */
    UserService.prototype.save = /**
     * @param {?} user
     * @param {?} permissions
     * @param {?=} parameters
     * @return {?}
     */
    function (user, permissions, parameters) {
        return this.http.post(this.environment.apiUrl + "api/user/save", {
            user: user,
            permissions: permissions,
            DeveloperParameters: parameters
        })
            .pipe(catchError(this.handleError('save')));
    };
    /**
     * @param {?} userCompanyId
     * @param {?} userId
     * @param {?} newPassword
     * @param {?} confirmNewPassword
     * @return {?}
     */
    UserService.prototype.saveNewPassword = /**
     * @param {?} userCompanyId
     * @param {?} userId
     * @param {?} newPassword
     * @param {?} confirmNewPassword
     * @return {?}
     */
    function (userCompanyId, userId, newPassword, confirmNewPassword) {
        return this.http.post(this.environment.apiUrl + "api/user/savenewpassword", {
            userCompanyId: userCompanyId,
            userId: userId,
            newPassword: newPassword,
            confirmNewPassword: confirmNewPassword
        });
    };
    /**
     * @param {?} userId
     * @param {?=} isDeveloper
     * @return {?}
     */
    UserService.prototype.delete = /**
     * @param {?} userId
     * @param {?=} isDeveloper
     * @return {?}
     */
    function (userId, isDeveloper) {
        if (userId === undefined) {
            userId = 0;
        }
        return this.http.delete(this.environment.apiUrl + 'api/user/delete?userId=' + userId + '&isDeveloper=' + isDeveloper)
            .pipe(catchError(this.handleError('delete')));
    };
    /**
     * @return {?}
     */
    UserService.prototype.getObjectGroup = /**
     * @return {?}
     */
    function () {
        return this.http.get(this.environment.apiUrl + "api/user/getallobjectsgroups")
            .pipe(catchError(this.handleError('getObjectGroup', [])));
    };
    /**
     * @param {?} userId
     * @param {?} companyId
     * @return {?}
     */
    UserService.prototype.getUserPermission = /**
     * @param {?} userId
     * @param {?} companyId
     * @return {?}
     */
    function (userId, companyId) {
        return this.http.get(this.environment.apiUrl + "api/user/getuserpermission?userId=" + userId + "&companyId=" + companyId)
            .pipe(catchError(this.handleError('getUserPermission', [])));
    };
    /**
     * @return {?}
     */
    UserService.prototype.getCompany = /**
     * @return {?}
     */
    function () {
        return this.http.get(this.environment.apiUrl + "api/user/getcurrentusercompany")
            .pipe(catchError(this.handleError('getCompany')));
    };
    /**
     * @template T
     * @param {?=} operation
     * @param {?=} result
     * @return {?}
     */
    UserService.prototype.handleError = /**
     * @template T
     * @param {?=} operation
     * @param {?=} result
     * @return {?}
     */
    function (operation, result) {
        var _this = this;
        if (operation === void 0) { operation = 'operation'; }
        return function (error) {
            if (error.error.Message !== undefined) {
                _this.rteSnackBarService.showErrorMessage("" + error.error.Message, "OK");
            }
            else {
                _this.rteSnackBarService.showErrorMessage("Não foi possível concluir a solicitação.", "OK");
            }
            return of((/** @type {?} */ (result)));
        };
    };
    UserService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    UserService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: RteSnackbarService },
        { type: undefined, decorators: [{ type: Inject, args: ['environment',] }] }
    ]; };
    /** @nocollapse */ UserService.ngInjectableDef = defineInjectable({ factory: function UserService_Factory() { return new UserService(inject(HttpClient), inject(RteSnackbarService), inject("environment")); }, token: UserService, providedIn: "root" });
    return UserService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var User = /** @class */ (function () {
    function User() {
        this.Revision = 0;
        this.objectGroups = [];
    }
    return User;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UserComponent = /** @class */ (function () {
    function UserComponent(userService) {
        this.userService = userService;
        this.user = new User();
    }
    UserComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-user',
                    template: "<rte-app-userform [user]=\"user\"></rte-app-userform>\r\n",
                    styles: [".grid-container{margin:20px}.dashboard-card{position:absolute;top:15px;left:15px;right:15px;bottom:15px}.more-button{position:absolute;top:5px;right:10px}.dashboard-card-content{text-align:center}"]
                }] }
    ];
    /** @nocollapse */
    UserComponent.ctorParameters = function () { return [
        { type: UserService }
    ]; };
    return UserComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActionUserButton = /** @class */ (function () {
    function ActionUserButton() {
        this.subject = new Subject();
    }
    /**
     * @return {?}
     */
    ActionUserButton.prototype.click = /**
     * @return {?}
     */
    function () {
        this.subject.next();
    };
    /**
     * @return {?}
     */
    ActionUserButton.prototype.afterClick = /**
     * @return {?}
     */
    function () {
        return this.subject.asObservable();
    };
    return ActionUserButton;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UserActionsComponent = /** @class */ (function () {
    function UserActionsComponent(userService, rteSnackBarService) {
        this.userService = userService;
        this.rteSnackBarService = rteSnackBarService;
    }
    /**
     * @return {?}
     */
    UserActionsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.userActions = new Array();
        /** @type {?} */
        var sendPasswordButton = new ActionUserButton();
        sendPasswordButton.description = "Enviar Senha";
        sendPasswordButton.disabled = true;
        sendPasswordButton.afterClick().subscribe(function (x) {
            _this.sendPassword();
        });
        /** @type {?} */
        var generatePasswordButton = new ActionUserButton();
        generatePasswordButton.description = "Gerar nova Senha";
        generatePasswordButton.disabled = true;
        generatePasswordButton.afterClick().subscribe(function (x) {
            _this.generatePassword();
        });
        this.userActions.push(sendPasswordButton);
        this.userActions.push(generatePasswordButton);
    };
    /**
     * @return {?}
     */
    UserActionsComponent.prototype.sendPassword = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.user.Id != null && this.user.Description && this.user.AmountPages >= 1) {
            this.userService.sendPassword(this.user.Id).subscribe(function (data) {
                if (data != null) {
                    _this.rteSnackBarService.showSuccessMessage(_this.user.Description + "\n" + data, "OK");
                }
            });
        }
        else {
            this.rteSnackBarService.showErrorMessage("Por favor, realizar a pesquisar do usuário.", "OK");
        }
    };
    /**
     * @return {?}
     */
    UserActionsComponent.prototype.generatePassword = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.user.Id != null && this.user.Description && this.user.AmountPages >= 1) {
            this.userService.generatePassword(this.user.Id).subscribe(function (data) {
                if (data != null) {
                    _this.rteSnackBarService.showSuccessMessage(_this.user.Description + "\n" + data, "OK");
                }
            });
        }
        else {
            this.rteSnackBarService.showErrorMessage("Por favor, realizar a pesquisar do usuário.", "OK");
        }
    };
    /**
     * @param {?} disable
     * @return {?}
     */
    UserActionsComponent.prototype.setDisabled = /**
     * @param {?} disable
     * @return {?}
     */
    function (disable) {
        this.userActions.forEach(function (x) { return x.disabled = disable; });
    };
    UserActionsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-user-actions',
                    template: "<rte-list-buttons [listButton]=\"userActions\"></rte-list-buttons>\r\n",
                    styles: [".rte-icon{padding:0 2px}.rte-send-password-button{border-top-left-radius:6px}.rte-generate-password-button{border-top-right-radius:6px}"]
                }] }
    ];
    /** @nocollapse */
    UserActionsComponent.ctorParameters = function () { return [
        { type: UserService },
        { type: RteSnackbarService }
    ]; };
    UserActionsComponent.propDecorators = {
        user: [{ type: Input }],
        disabled: [{ type: Input }]
    };
    return UserActionsComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ObjectGroup = /** @class */ (function () {
    function ObjectGroup() {
    }
    return ObjectGroup;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UserformService = /** @class */ (function () {
    function UserformService(userService) {
        this.userService = userService;
    }
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    UserformService.prototype.clear = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        objectCurrent.Id = null;
        objectCurrent.Description = '';
        objectCurrent.Email = '';
        objectCurrent.Login = '';
        objectCurrent.Password = '';
        objectCurrent.SessionControl = false;
        objectCurrent.PasswordExpiration = false;
        objectCurrent.PasswordWillChange = false;
        objectCurrent.Master = false;
        objectCurrent.Active = false;
        objectCurrent.HasChanged = false;
        objectCurrent.Revision = 0;
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    UserformService.prototype.save = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        return this.userService.save(objectCurrent, objectCurrent.objectGroups);
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    UserformService.prototype.delete = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        return this.userService.delete(objectCurrent.Id);
    };
    /**
     * @param {?} objectCurrent
     * @param {?} page
     * @return {?}
     */
    UserformService.prototype.get = /**
     * @param {?} objectCurrent
     * @param {?} page
     * @return {?}
     */
    function (objectCurrent, page) {
        return this.userService.getUsers(objectCurrent.Id, objectCurrent.Description, objectCurrent.Login, objectCurrent.CompanyId, page);
    };
    /**
     * @return {?}
     */
    UserformService.prototype.close = /**
     * @return {?}
     */
    function () {
    };
    UserformService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    UserformService.ctorParameters = function () { return [
        { type: UserService }
    ]; };
    /** @nocollapse */ UserformService.ngInjectableDef = defineInjectable({ factory: function UserformService_Factory() { return new UserformService(inject(UserService)); }, token: UserformService, providedIn: "root" });
    return UserformService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UserformComponent = /** @class */ (function () {
    function UserformComponent(tabComp, userService, route, rteSnackBarService, appService) {
        this.tabComp = tabComp;
        this.userService = userService;
        this.route = route;
        this.rteSnackBarService = rteSnackBarService;
        this.appService = appService;
        this._title = 'Cadastro de usuários';
        this.displayedColumns = [
            'id',
            'description',
            'leitura',
            'insercao',
            'alteracao',
            'exclusao',
            'exportacao'
        ];
        this.loginFormControl = new FormControl('', [Validators.required]);
        this.nomeFormControl = new FormControl('', [Validators.required]);
        this.emailFormControl = new FormControl('', [
            Validators.required,
            Validators.email
        ]);
        this.matcher = new MyErrorStateMatcher();
        this.toolbarObject = new RteToolbarViewModel();
        this.toolbarObject.current = new User();
        this.toolbarObject.current.objectGroups = [];
        this.user = this.toolbarObject.current;
        this.service = new UserformService(userService);
    }
    //#region rte-Toolbar Events
    //#region rte-Toolbar Events
    /**
     * @return {?}
     */
    UserformComponent.prototype.customizeAfterClear = 
    //#region rte-Toolbar Events
    /**
     * @return {?}
     */
    function () {
        this.user.Id = null;
        this.user.Description = '';
        this.user.Email = '';
        this.user.Login = '';
        this.user.Password = '';
        this.user.Revision = 0;
        this.clearPermissions();
        this.errorMessageNome = null;
        this.errorMessageLogin = null;
        this.errorMessageEmail = null;
        this.userIdInput.nativeElement.focus();
        this.user.SessionControl = false;
        this.user.PasswordExpiration = false;
        this.user.PasswordWillChange = false;
        this.user.Master = false;
        this.user.Active = false;
        this.user.HasChanged = false;
        this.userAction.setDisabled(true);
    };
    /**
     * @return {?}
     */
    UserformComponent.prototype.customizeBeforeGet = /**
     * @return {?}
     */
    function () {
        this.toolbarObject.current = this.user;
    };
    /**
     * @param {?} afterGet
     * @return {?}
     */
    UserformComponent.prototype.customizeAfterGet = /**
     * @param {?} afterGet
     * @return {?}
     */
    function (afterGet) {
        if (!afterGet.data || afterGet.data.length === 0) {
            this.rteSnackBarService.showWarningMessage('Usuário não encontrado.', 'OK');
            return;
        }
        this.users = afterGet.data;
        this.user = afterGet.data.length > 0 ? afterGet.data[0] : new User();
        this.userAction.setDisabled(!afterGet.data);
        if (this.user.Active === false) {
            this.showMessageInactiveUser();
        }
        if (!afterGet.success) {
            this.clearPermissions();
        }
        else {
            this.user.objectGroups = this.objectGroups;
            this.getUserPermission();
        }
    };
    /**
     * @param {?} beforeSave
     * @return {?}
     */
    UserformComponent.prototype.validateBeforeSave = /**
     * @param {?} beforeSave
     * @return {?}
     */
    function (beforeSave) {
        /** @type {?} */
        var servicePermission = false;
        if (this.user.Email === undefined || this.user.Email === '') {
            this.errorMessageEmail = 'Por favor, preencher endereço de email.';
            this.rteSnackBarService.showWarningMessage('Por favor, preencher endereço de email!', 'OK');
            this.userEmailInput.nativeElement.focus();
            servicePermission = false;
        }
        if (this.user.Login === undefined || this.user.Login === '') {
            this.errorMessageLogin = 'Por favor, preencher o login.';
            this.rteSnackBarService.showWarningMessage(this.errorMessageLogin, 'OK');
            this.userLoginInput.nativeElement.focus();
            servicePermission = false;
        }
        if (this.user.Description === undefined || this.user.Description === '') {
            this.errorMessageNome = 'Por favor, preencher o nome.';
            this.rteSnackBarService.showWarningMessage(this.errorMessageNome, 'OK');
            this.userNomeInput.nativeElement.focus();
            servicePermission = false;
        }
        this.toolbarObject.current = this.user;
        beforeSave.cancelSave = servicePermission;
    };
    /**
     * @param {?} afterSave
     * @return {?}
     */
    UserformComponent.prototype.customizeAfterSave = /**
     * @param {?} afterSave
     * @return {?}
     */
    function (afterSave) {
        if (afterSave.success) {
            this.toolbarObject.current.Revision++;
            if (afterSave.oldId === afterSave.newId && afterSave.newId > 0) {
                this.rteSnackBarService.showSuccessMessage('Usuário ' + this.user.Description + ' alterado com sucesso!', 'OK');
            }
            if (afterSave.oldId == null && afterSave.newId > 0) {
                this.rteSnackBarService.showSuccessMessage('Usuário ' + this.user.Description + ' inserido com sucesso!', 'OK');
            }
        }
        this.user = this.toolbarObject.current;
    };
    /**
     * @param {?} option
     * @return {?}
     */
    UserformComponent.prototype.customizeAfterInsertMode = /**
     * @param {?} option
     * @return {?}
     */
    function (option) {
        this.activeDisabledCheckbox = true;
        if (option) {
            this.activeDisabledCheckbox = false;
            this.userNomeInput.nativeElement.focus();
            this.user.Active = true;
            this.user.PasswordExpiration = true;
            this.user.PasswordWillChange = true;
        }
    };
    /**
     * @param {?} option
     * @return {?}
     */
    UserformComponent.prototype.customizeAfertEditMode = /**
     * @param {?} option
     * @return {?}
     */
    function (option) {
        this.activeDisabledCheckbox = true;
        if (option) {
            if (this.user.Active === false) {
                this.showMessageInactiveUser();
            }
            this.userNomeInput.nativeElement.focus();
            this.activeDisabledCheckbox = false;
        }
    };
    /**
     * @param {?} data
     * @return {?}
     */
    UserformComponent.prototype.customizeAfterDelete = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        if (data) {
            this.rteSnackBarService.showSuccessMessage('Registro excluido com sucesso!', 'OK');
        }
        else {
            this.rteSnackBarService.showErrorMessage('Não foi possível excluir o registro!', 'OK');
        }
    };
    //#endregion
    //#endregion
    /**
     * @return {?}
     */
    UserformComponent.prototype.getError = 
    //#endregion
    /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var string = 'Login';
        return string;
    };
    /**
     * @param {?} $event
     * @param {?} espaco
     * @param {?} inputText
     * @return {?}
     */
    UserformComponent.prototype.checkType = /**
     * @param {?} $event
     * @param {?} espaco
     * @param {?} inputText
     * @return {?}
     */
    function ($event, espaco, inputText) {
        /** @type {?} */
        var type = $event.key;
        /** @type {?} */
        var regex = /[\W]/;
        if (type === ' ' && espaco === false && inputText.indexOf(' ') === -1) {
            return true;
        }
        if (regex.test(type)) {
            if (type === '.' && espaco === true) {
                return true;
            }
            else {
                return false;
            }
        }
        return true;
    };
    /**
     * @return {?}
     */
    UserformComponent.prototype.clearPermissions = /**
     * @return {?}
     */
    function () {
        for (var i = 0; i < this.objectGroups.length; i++) {
            this.objectGroups[i].Read = false;
            this.objectGroups[i].Insert = false;
            this.objectGroups[i].Update = false;
            this.objectGroups[i].Delete = false;
            this.objectGroups[i].Export = false;
            this.objectGroups[i].PermissionInfoId = null;
            this.objectGroups[i].Changed = false;
        }
    };
    /**
     * @return {?}
     */
    UserformComponent.prototype.getObjectGroup = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.userService.getObjectGroup().subscribe(function (data) {
            _this.objectGroups = data;
        });
    };
    /**
     * @return {?}
     */
    UserformComponent.prototype.getUserPermission = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.userService
            .getUserPermission(this.user.Id, this.user.CompanyId)
            .subscribe(function (data) {
            _this.clearPermissions();
            _this.userPermission = data;
            for (var i = 0; i < _this.objectGroups.length; i++) {
                for (var j = 0; j < _this.userPermission.length; j++) {
                    if (_this.objectGroups[i].Id === _this.userPermission[j].ObjectModelId) {
                        _this.objectGroups[i].Read = _this.userPermission[j].Read;
                        _this.objectGroups[i].Insert = _this.userPermission[j].Insert;
                        _this.objectGroups[i].Update = _this.userPermission[j].Update;
                        _this.objectGroups[i].Delete = _this.userPermission[j].Delete;
                        _this.objectGroups[i].Export = _this.userPermission[j].Export;
                        _this.objectGroups[i].PermissionInfoId = _this.userPermission[j].Id;
                    }
                }
            }
        });
    };
    /**
     * @return {?}
     */
    UserformComponent.prototype.getCompany = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.userService.getCompany().subscribe(function (data) {
            _this.companies = data;
            _this.user.CompanyId = _this.companies.Id;
            _this.companyDescription = _this.companies.Description;
        });
    };
    /**
     * @param {?} $event
     * @param {?} objectGroupsId
     * @return {?}
     */
    UserformComponent.prototype.checkChangeEvent = /**
     * @param {?} $event
     * @param {?} objectGroupsId
     * @return {?}
     */
    function ($event, objectGroupsId) {
        /** @type {?} */
        var index = this.objectGroups.findIndex(function (x) { return x.Id === objectGroupsId; });
        this.objectGroups[index].Changed = true;
    };
    /**
     * @param {?} $event
     * @param {?} userLogin
     * @return {?}
     */
    UserformComponent.prototype.userLoginReplace = /**
     * @param {?} $event
     * @param {?} userLogin
     * @return {?}
     */
    function ($event, userLogin) {
        /** @type {?} */
        var string = userLogin.replace(' ', '');
        string = string.replace('_', '');
        // string = string.replace(/[\W]/g,"");
        this.user.Login = string;
        this.hasChange();
    };
    /**
     * @return {?}
     */
    UserformComponent.prototype.hasChange = /**
     * @return {?}
     */
    function () {
        this.user.HasChanged = true;
    };
    /**
     * @return {?}
     */
    UserformComponent.prototype.showMessageInactiveUser = /**
     * @return {?}
     */
    function () {
        this.rteSnackBarService.showWarningMessage('Usuário ' + this.user.Description + ' com registro inativo!', 'OK');
    };
    /**
     * @return {?}
     */
    UserformComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.getObjectGroup();
        this.getCompany();
        if (this.appService.currentUser.isMaster === 'N') {
            this.activeDisabledCheckboxIsMaster = true;
        }
    };
    UserformComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-userform',
                    template: "<div #divUserForm class=\"mat-grid-list\" *ngIf=\"user\">\r\n  <mat-card class=\"mat-card-grupo-objeto\">\r\n    <mat-card-title>\r\n      <rte-toolbar\r\n        [title]=\"_title\"\r\n        [toolbarObject]=\"toolbarObject\"\r\n        [service]=\"service\"\r\n        [KeyDownElementArea]=\"divUserForm\"\r\n        (customizeBeforeGet)=\"customizeBeforeGet()\"\r\n        (customizeAfterGet)=\"customizeAfterGet($event)\"\r\n        (validateBeforeSave)=\"validateBeforeSave($event)\"\r\n        (customizeAfterSave)=\"customizeAfterSave($event)\"\r\n        (customizeAfterInsertMode)=\"customizeAfterInsertMode($event)\"\r\n        (customizeAfertEditMode)=\"customizeAfertEditMode($event)\"\r\n        (customizeAfterClear)=\"customizeAfterClear()\"\r\n        (customizeAfterDelete)=\"customizeAfterDelete($event)\"\r\n      ></rte-toolbar>\r\n    </mat-card-title>\r\n    <mat-card-content>\r\n      <div class=\"app-user-actions\">\r\n        <rte-app-user-actions #userAction [user]=\"user\"></rte-app-user-actions>\r\n      </div>\r\n      <mat-grid-list cols=\"10\" rowHeight=\"118px\" class=\"rte-mat-grid-list-tile\">\r\n        <mat-grid-tile [colspan]=\"1\" [rowspan]=\"1\">\r\n          <rte-form-field class=\"rte-form-field-user\">\r\n            <span\r\n              [ngClass]=\"{\r\n                'personal-backgroud-readonly':\r\n                  toolbarObject.readonlyInsertMode ||\r\n                  toolbarObject.readonlyBrowserMode ||\r\n                  toolbarObject.readonlyEditMode\r\n              }\"\r\n            >\r\n              <input\r\n                #input\r\n                id=\"id\"\r\n                rteInput\r\n                type=\"number\"\r\n                placeholder=\"C\u00F3d. Usu\u00E1rio\"\r\n                [(ngModel)]=\"user.Id\"\r\n                [readonly]=\"\r\n                  toolbarObject.readonlyInsertMode ||\r\n                  toolbarObject.readonlyBrowserMode ||\r\n                  toolbarObject.readonlyEditMode\r\n                \"\r\n                autofocus\r\n              />\r\n            </span>\r\n            <button\r\n              rtebutton\r\n              *ngIf=\"user.Id && toolbarObject.readonlyFirstMode\"\r\n              matSuffix\r\n              mat-icon-button\r\n              aria-label=\"Clear\"\r\n              (click)=\"user.Id = null\"\r\n            >\r\n              <rte-icon>close</rte-icon>\r\n            </button>\r\n          </rte-form-field>\r\n        </mat-grid-tile>\r\n\r\n        <mat-grid-tile [colspan]=\"4\" [rowspan]=\"1\" class=\"mat-option-select\">\r\n          <rte-form-field class=\"rte-form-field-company\">\r\n            <span\r\n              [ngClass]=\"{\r\n                'personal-backgroud-readonly':\r\n                  toolbarObject.readonlyInsertMode ||\r\n                  toolbarObject.readonlyFirstMode ||\r\n                  toolbarObject.readonlyBrowserMode ||\r\n                  toolbarObject.readonlyEditMode\r\n              }\"\r\n            >\r\n              <input\r\n                rteInput\r\n                type=\"text\"\r\n                placeholder=\"Empresa\"\r\n                value=\"{{ companyDescription }}\"\r\n                [readonly]=\"\r\n                  toolbarObject.readonlyInsertMode ||\r\n                  toolbarObject.readonlyFirstMode ||\r\n                  toolbarObject.readonlyBrowserMode ||\r\n                  toolbarObject.readonlyEditMode\r\n                \"\r\n              />\r\n            </span>\r\n          </rte-form-field>\r\n        </mat-grid-tile>\r\n\r\n        <div class=\"text-inside-grid\">\r\n          <mat-grid-tile [colspan]=\"3\" [rowspan]=\"1\">\r\n            <div\r\n              fxLayout=\"column\"\r\n              fxLayoutAlign=\"start start\"\r\n              fxLayoutGap=\"0px\"\r\n              class=\"rte-content-tile\"\r\n            >\r\n              <div>\r\n                <rte-checkbox\r\n                  [(ngModel)]=\"user.SessionControl\"\r\n                  color=\"primary\"\r\n                  class=\"rte-checkbox-control\"\r\n                  [disabled]=\"activeDisabledCheckbox\"\r\n                  (change)=\"hasChange()\"\r\n                >\r\n                  Possuir controle de sess\u00E3o\r\n                </rte-checkbox>\r\n              </div>\r\n              <div>\r\n                <rte-checkbox\r\n                  [(ngModel)]=\"user.PasswordExpiration\"\r\n                  color=\"primary\"\r\n                  class=\"rte-checkbox-control\"\r\n                  [disabled]=\"activeDisabledCheckbox\"\r\n                  (change)=\"hasChange()\"\r\n                >\r\n                  Senha Expira\r\n                </rte-checkbox>\r\n              </div>\r\n              <div>\r\n                <rte-checkbox\r\n                  [(ngModel)]=\"user.PasswordWillChange\"\r\n                  color=\"primary\"\r\n                  class=\"rte-checkbox-control\"\r\n                  [disabled]=\"activeDisabledCheckbox\"\r\n                  (change)=\"hasChange()\"\r\n                >\r\n                  Alterar senha no primeiro acesso\r\n                </rte-checkbox>\r\n              </div>\r\n              <div>\r\n                <rte-checkbox\r\n                  [(ngModel)]=\"user.Master\"\r\n                  color=\"primary\"\r\n                  class=\"rte-checkbox-control\"\r\n                  [disabled]=\"\r\n                    activeDisabledCheckbox || activeDisabledCheckboxIsMaster\r\n                  \"\r\n                  (change)=\"hasChange()\"\r\n                >\r\n                  Super usu\u00E1rio\r\n                </rte-checkbox>\r\n              </div>\r\n              <div>\r\n                <rte-checkbox\r\n                  [(ngModel)]=\"user.Active\"\r\n                  color=\"primary\"\r\n                  class=\"rte-checkbox-control\"\r\n                  [disabled]=\"activeDisabledCheckbox\"\r\n                  (change)=\"hasChange()\"\r\n                >\r\n                  Ativo\r\n                </rte-checkbox>\r\n              </div>\r\n            </div>\r\n          </mat-grid-tile>\r\n        </div>\r\n      </mat-grid-list>\r\n\r\n      <mat-grid-list cols=\"10\" rowHeight=\"100px\" class=\"rte-mat-grid-list-tile\">\r\n        <mat-grid-tile [colspan]=\"5\" [rowspan]=\"1\">\r\n          <rte-form-field class=\"rte-form-field\">\r\n            <span\r\n              [ngClass]=\"{\r\n                'personal-backgroud-readonly': toolbarObject.readonlyBrowserMode\r\n              }\"\r\n            >\r\n              <input\r\n                #input1\r\n                rteInput\r\n                type=\"text\"\r\n                style=\"text-transform: uppercase\"\r\n                placeholder=\"Nome\"\r\n                [formControl]=\"nomeFormControl\"\r\n                [(ngModel)]=\"user.Description\"\r\n                (keypress)=\"checkType($event, false, user.Description)\"\r\n                [readonly]=\"toolbarObject.readonlyBrowserMode\"\r\n                (change)=\"hasChange()\"\r\n              />\r\n            </span>\r\n            <mat-error>{{ errorMessageNome }}</mat-error>\r\n            <button\r\n              rtebutton\r\n              *ngIf=\"user.Description && !toolbarObject.readonlyBrowserMode\"\r\n              matSuffix\r\n              mat-icon-button\r\n              aria-label=\"Clear\"\r\n              (click)=\"user.Description = ''\"\r\n            >\r\n              <rte-icon>close</rte-icon>\r\n            </button>\r\n          </rte-form-field>\r\n        </mat-grid-tile>\r\n\r\n        <mat-grid-tile [colspan]=\"5\" [rowspan]=\"1\">\r\n          <rte-form-field class=\"rte-form-field-email\">\r\n            <span\r\n              [ngClass]=\"{\r\n                'personal-backgroud-readonly':\r\n                  toolbarObject.readonlyFirstMode ||\r\n                  toolbarObject.readonlyBrowserMode\r\n              }\"\r\n            >\r\n              <input\r\n                #input3\r\n                rteInput\r\n                placeholder=\"Email\"\r\n                [formControl]=\"emailFormControl\"\r\n                [errorStateMatcher]=\"matcher\"\r\n                [(ngModel)]=\"user.Email\"\r\n                [readonly]=\"\r\n                  toolbarObject.readonlyFirstMode ||\r\n                  toolbarObject.readonlyBrowserMode\r\n                \"\r\n                (change)=\"hasChange()\"\r\n              />\r\n            </span>\r\n            <mat-error\r\n              *ngIf=\"\r\n                emailFormControl.hasError('email') &&\r\n                !emailFormControl.hasError('required')\r\n              \"\r\n            >\r\n              \"Por favor, inserir endere\u00E7o de email v\u00E1lido.\r\n            </mat-error>\r\n            <mat-error>{{ errorMessageEmail }}</mat-error>\r\n          </rte-form-field>\r\n        </mat-grid-tile>\r\n      </mat-grid-list>\r\n\r\n      <mat-grid-list cols=\"10\" rowHeight=\"100px\" class=\"rte-mat-grid-list-tile\">\r\n        <mat-grid-tile [colspan]=\"5\" [rowspan]=\"1\">\r\n          <rte-form-field class=\"rte-form-field\">\r\n            <span\r\n              [ngClass]=\"{\r\n                'personal-backgroud-readonly': toolbarObject.readonlyBrowserMode\r\n              }\"\r\n            >\r\n              <input\r\n                #input2\r\n                rteInput\r\n                type=\"text\"\r\n                placeholder=\"Login\"\r\n                style=\"text-transform: uppercase\"\r\n                [formControl]=\"loginFormControl\"\r\n                [(ngModel)]=\"user.Login\"\r\n                (keypress)=\"checkType($event, true, '')\"\r\n                (change)=\"userLoginReplace($event, user.Login)\"\r\n                [readonly]=\"toolbarObject.readonlyBrowserMode\"\r\n              />\r\n            </span>\r\n            <mat-error>{{ errorMessageLogin }}</mat-error>\r\n            <button\r\n              rtebutton\r\n              *ngIf=\"user.Login && !toolbarObject.readonlyBrowserMode\"\r\n              matSuffix\r\n              mat-icon-button\r\n              aria-label=\"Clear\"\r\n              (click)=\"user.Login = ''\"\r\n            >\r\n              <rte-icon>close</rte-icon>\r\n            </button>\r\n          </rte-form-field>\r\n        </mat-grid-tile>\r\n\r\n        <mat-grid-tile [colspan]=\"5\" [rowspan]=\"1\">\r\n          <rte-form-field class=\"rte-form-field-password\">\r\n            <span\r\n              [ngClass]=\"{\r\n                'personal-backgroud-readonly':\r\n                  toolbarObject.readonlyFirstMode ||\r\n                  toolbarObject.readonlyInsertMode ||\r\n                  toolbarObject.readonlyBrowserMode ||\r\n                  toolbarObject.readonlyEditMode\r\n              }\"\r\n            >\r\n              <input\r\n                rteInput\r\n                type=\"Password\"\r\n                placeholder=\"Senha\"\r\n                [(ngModel)]=\"user.Password\"\r\n                [readonly]=\"\r\n                  toolbarObject.readonlyFirstMode ||\r\n                  toolbarObject.readonlyInsertMode ||\r\n                  toolbarObject.readonlyBrowserMode ||\r\n                  toolbarObject.readonlyEditMode\r\n                \"\r\n              />\r\n              <button\r\n                rtebutton\r\n                *ngIf=\"\r\n                  user.Password &&\r\n                  (!toolbarObject.readonlyFirstMode ||\r\n                    !toolbarObject.readonlyInsertMode ||\r\n                    !toolbarObject.readonlyBrowserMode)\r\n                \"\r\n                matSuffix\r\n                mat-icon-button\r\n                aria-label=\"Clear\"\r\n                (click)=\"user.Password = ''\"\r\n              >\r\n                <rte-icon>close</rte-icon>\r\n              </button>\r\n            </span>\r\n          </rte-form-field>\r\n        </mat-grid-tile>\r\n      </mat-grid-list>\r\n    </mat-card-content>\r\n  </mat-card>\r\n</div>\r\n\r\n<div class=\"mat-table\">\r\n  <mat-card class=\"mat-card-grupo-objeto\">\r\n    <mat-card-header>\r\n      <mat-card-title>Grupo de objetos</mat-card-title>\r\n    </mat-card-header>\r\n    <mat-card-content>\r\n      <mat-table [dataSource]=\"objectGroups\" class=\"mat-elevation-z8\">\r\n        <ng-container rteColumnDef=\"id\">\r\n          <rte-header-cell *rteHeaderCellDef> Grupo </rte-header-cell>\r\n          <rte-cell *rteCellDef=\"let object\">{{ object.Id }}</rte-cell>\r\n        </ng-container>\r\n\r\n        <ng-container rteColumnDef=\"description\">\r\n          <rte-header-cell *rteHeaderCellDef> Nome </rte-header-cell>\r\n          <rte-cell *rteCellDef=\"let object\">\r\n            {{ object.Description }}\r\n          </rte-cell>\r\n        </ng-container>\r\n\r\n        <ng-container rteColumnDef=\"leitura\">\r\n          <rte-header-cell *rteHeaderCellDef>Leitura</rte-header-cell>\r\n          <rte-cell class=\"mat-column\" *rteCellDef=\"let object\">\r\n            <rte-checkbox\r\n              [(ngModel)]=\"object.Read\"\r\n              color=\"primary\"\r\n              (change)=\"checkChangeEvent($event, object.Id)\"\r\n              [disabled]=\"activeDisabledCheckbox\"\r\n            >\r\n            </rte-checkbox>\r\n          </rte-cell>\r\n        </ng-container>\r\n\r\n        <ng-container rteColumnDef=\"insercao\">\r\n          <rte-header-cell *rteHeaderCellDef>Inser\u00E7\u00E3o</rte-header-cell>\r\n          <rte-cell class=\"mat-column\" *rteCellDef=\"let object\">\r\n            <rte-checkbox\r\n              [(ngModel)]=\"object.Insert\"\r\n              color=\"primary\"\r\n              (change)=\"checkChangeEvent($event, object.Id)\"\r\n              [disabled]=\"activeDisabledCheckbox\"\r\n            >\r\n            </rte-checkbox>\r\n          </rte-cell>\r\n        </ng-container>\r\n\r\n        <ng-container rteColumnDef=\"alteracao\">\r\n          <rte-header-cell *rteHeaderCellDef>Altera\u00E7\u00E3o</rte-header-cell>\r\n          <rte-cell class=\"mat-column\" *rteCellDef=\"let object\">\r\n            <rte-checkbox\r\n              [(ngModel)]=\"object.Update\"\r\n              color=\"primary\"\r\n              (change)=\"checkChangeEvent($event, object.Id)\"\r\n              [disabled]=\"activeDisabledCheckbox\"\r\n            >\r\n            </rte-checkbox>\r\n          </rte-cell>\r\n        </ng-container>\r\n\r\n        <ng-container rteColumnDef=\"exclusao\">\r\n          <rte-header-cell *rteHeaderCellDef>Exclus\u00E3o</rte-header-cell>\r\n          <rte-cell class=\"mat-column\" *rteCellDef=\"let object\">\r\n            <rte-checkbox\r\n              [(ngModel)]=\"object.Delete\"\r\n              color=\"primary\"\r\n              (change)=\"checkChangeEvent($event, object.Id)\"\r\n              [disabled]=\"activeDisabledCheckbox\"\r\n            >\r\n            </rte-checkbox>\r\n          </rte-cell>\r\n        </ng-container>\r\n\r\n        <ng-container rteColumnDef=\"exportacao\">\r\n          <rte-header-cell *rteHeaderCellDef>Exporta\u00E7\u00E3o</rte-header-cell>\r\n          <rte-cell class=\"mat-column\" *rteCellDef=\"let object\">\r\n            <rte-checkbox\r\n              [(ngModel)]=\"object.Export\"\r\n              color=\"primary\"\r\n              (change)=\"checkChangeEvent($event, object.Id)\"\r\n              [disabled]=\"activeDisabledCheckbox\"\r\n            >\r\n            </rte-checkbox>\r\n          </rte-cell>\r\n        </ng-container>\r\n\r\n        <mat-header-row *matHeaderRowDef=\"displayedColumns\"></mat-header-row>\r\n        <mat-row *matRowDef=\"let row; columns: displayedColumns\"></mat-row>\r\n      </mat-table>\r\n    </mat-card-content>\r\n  </mat-card>\r\n</div>\r\n",
                    styles: [".mat-mini-fab{box-shadow:none!important}.mat-checkbox-select{width:100%!important;left:2%!important}.mat-grid-title-checkbox{padding-left:9px;overflow:visible}.mat-checkbox-control,.mat-grid-list{width:100%}.mat-card{margin:16px}.rte-form-field{width:100%;padding-right:10%}.rte-form-field-name,.rte-form-field-user{width:100%}.rte-form-field-company{margin-left:20px;padding-right:12%}.rte-form-field-email,.rte-form-field-password{width:100%}.personal-backgroud-readonly{padding-top:5px;padding-bottom:3px;background-color:#d0cccc;padding-left:6px;display:flex;font-weight:500}.personal-backgroud-readonly label{padding-left:10px}.personal-backgroud{padding-top:10px;padding-bottom:3px}.mat-grid-tile{float:left}.rte-icon{padding:0 2px}.rte-spacer{flex:1 1 auto}.mat-table mat-table{box-shadow:none}.mat-column{padding-left:15px}.mat-option-select rte-form-field{width:96%}.mat-option-select{font-size:14px}.rte-label{padding-left:10px;padding-right:10px}.app-user-actions{text-align:right;padding-top:0;margin-bottom:15px}.rte-mat-vertical_line{height:88px!important;padding-bottom:27px}.mat-table{margin:0!important}.mat-card-grupo-objeto{padding-left:0;padding-right:0;padding-bottom:0;background-color:#f5f5f5}.mat-card-grupo-objeto mat-card-title{font-size:22px;color:#7f7979}mat-error{font-size:13px}.parameter-register{background-color:#fff;padding-left:15px}.mat-tree{width:98%;padding-left:20px;min-height:90px;height:-webkit-fill-available}.parameter-content{width:100%}.inside-table-field{width:90%;margin-top:10px;margin-bottom:10px}.rte-content-tile{position:absolute;left:5px}"]
                }] }
    ];
    /** @nocollapse */
    UserformComponent.ctorParameters = function () { return [
        { type: TabComponent },
        { type: UserService },
        { type: ActivatedRoute },
        { type: RteSnackbarService },
        { type: undefined, decorators: [{ type: Inject, args: [RTE_APP_SERVICE_DATA,] }] }
    ]; };
    UserformComponent.propDecorators = {
        userIdInput: [{ type: ViewChild, args: ['input', { read: ElementRef },] }],
        userNomeInput: [{ type: ViewChild, args: ['input1', { read: ElementRef },] }],
        userLoginInput: [{ type: ViewChild, args: ['input2', { read: ElementRef },] }],
        userEmailInput: [{ type: ViewChild, args: ['input3', { read: ElementRef },] }],
        userAction: [{ type: ViewChild, args: ['userAction', { read: UserActionsComponent },] }],
        user: [{ type: Input }],
        objectGroup: [{ type: Input }],
        company: [{ type: Input }]
    };
    return UserformComponent;
}());
var MyErrorStateMatcher = /** @class */ (function () {
    function MyErrorStateMatcher() {
    }
    /**
     * @param {?} control
     * @param {?} form
     * @return {?}
     */
    MyErrorStateMatcher.prototype.isErrorState = /**
     * @param {?} control
     * @param {?} form
     * @return {?}
     */
    function (control, form) {
        /** @type {?} */
        var isSubmitted = form && form.submitted;
        return !!(control &&
            control.invalid &&
            (control.dirty || control.touched || isSubmitted));
    };
    return MyErrorStateMatcher;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteUserModule = /** @class */ (function () {
    function RteUserModule() {
    }
    /**
     * @param {?} environment
     * @return {?}
     */
    RteUserModule.forRoot = /**
     * @param {?} environment
     * @return {?}
     */
    function (environment) {
        return {
            ngModule: RteUserModule,
            providers: [
                UserService,
                {
                    provide: 'environment',
                    useValue: environment
                }
            ]
        };
    };
    RteUserModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        RteLibraryModule,
                        FormsModule,
                        MatFormFieldModule,
                        RteMaterialModule,
                        MatPaginatorModule,
                        MatProgressSpinnerModule,
                        MatToolbarModule,
                        MatSortModule,
                        MatTableModule,
                        MatSidenavModule,
                        MatListModule,
                        MatGridListModule,
                        MatCardModule,
                        MatMenuModule,
                        MatExpansionModule,
                        MatSnackBarModule,
                        MatTreeModule,
                        MatTabsModule,
                        MatChipsModule,
                        MatTooltipModule,
                        MatProgressBarModule,
                        MatDialogModule,
                        MatCheckboxModule,
                        RteToolbarModule,
                        ReactiveFormsModule
                    ],
                    declarations: [UserComponent, UserActionsComponent, UserformComponent],
                    exports: [UserComponent, UserActionsComponent, UserformComponent]
                },] }
    ];
    return RteUserModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SearchApplicationComponent = /** @class */ (function () {
    function SearchApplicationComponent(appService, tabService) {
        this.appService = appService;
        this.tabService = tabService;
    }
    /**
     * @return {?}
     */
    SearchApplicationComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} e
     * @return {?}
     */
    SearchApplicationComponent.prototype.onSelectedApplication = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.tabService.openTab(e.Description, e.Id, true, e.Breadcrumb);
    };
    SearchApplicationComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-search-application',
                    template: "<div fxFlex=\"1 1 100%\" fxFlex.lg=\"1 1 100%\" fxFlex.md=\"1 1 100%\" fxFlex.sm=\"1 1 100%\" class=\"rte-search-card\">\r\n  <div fxLayout=\"column\" fxFlex fxLayoutAlign=\"center\">\r\n    <div class=\"search-container-autocomplete\" fxLayoutAlign=\"center center\">\r\n      <rte-auto-complete class=\"application-autocomplete\" placeholder=\"Digite a tela que deseja abrir\" \r\n      (onSelectedOption)=\"onSelectedApplication($event)\" [options]=\"appService.applicationsToSearch\" ngDefaultControl>\r\n      </rte-auto-complete>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                    styles: [".search-container-autocomplete{width:100%;margin-top:5%}.application-autocomplete{width:50%}"]
                }] }
    ];
    /** @nocollapse */
    SearchApplicationComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [RTE_APP_SERVICE_DATA,] }] },
        { type: TabService }
    ]; };
    return SearchApplicationComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteSearchApplicationModule = /** @class */ (function () {
    function RteSearchApplicationModule() {
    }
    RteSearchApplicationModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        RteAutoCompleteModule,
                        FormsModule,
                        RteMaterialModule,
                        ReactiveFormsModule,
                        MatFormFieldModule,
                        MatPaginatorModule,
                        MatProgressSpinnerModule,
                        MatToolbarModule,
                        MatSortModule,
                        MatTableModule,
                        MatSidenavModule,
                        MatListModule,
                        MatGridListModule,
                        MatCardModule,
                        MatMenuModule,
                        MatExpansionModule,
                        MatSnackBarModule,
                        MatTreeModule,
                        MatTabsModule,
                        MatChipsModule,
                        MatTooltipModule,
                        MatProgressBarModule,
                        MatDialogModule,
                        MatCheckboxModule,
                        FlexLayoutModule
                    ],
                    declarations: [SearchApplicationComponent]
                },] }
    ];
    return RteSearchApplicationModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AssemblyInfo = /** @class */ (function () {
    function AssemblyInfo() {
        this.Revision = 0;
    }
    return AssemblyInfo;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AssemblyService = /** @class */ (function () {
    function AssemblyService(http, rteSnackBarService, environment) {
        this.http = http;
        this.rteSnackBarService = rteSnackBarService;
        this.environment = environment;
    }
    /**
     * @param {?} id
     * @param {?} description
     * @param {?} name
     * @param {?} page
     * @return {?}
     */
    AssemblyService.prototype.getAssemblies = /**
     * @param {?} id
     * @param {?} description
     * @param {?} name
     * @param {?} page
     * @return {?}
     */
    function (id, description, name, page) {
        if (id === undefined) {
            id = 0;
        }
        if (description === undefined) {
            description = '';
        }
        if (name === undefined) {
            name = '';
        }
        return this.http
            .get(this.environment.apiUrl +
            'api/assembly/getassemblies?Id=' +
            id +
            '&description=' +
            description +
            '&name=' +
            name +
            '&page=' +
            page)
            .pipe(catchError(this.handleError('getassemblies', [])));
    };
    /**
     * @param {?} assembly
     * @return {?}
     */
    AssemblyService.prototype.save = /**
     * @param {?} assembly
     * @return {?}
     */
    function (assembly) {
        return this.http
            .post(this.environment.apiUrl + 'api/assembly/save', assembly)
            .pipe(catchError(this.handleError('save')));
    };
    /**
     * @param {?} assemblyId
     * @return {?}
     */
    AssemblyService.prototype.delete = /**
     * @param {?} assemblyId
     * @return {?}
     */
    function (assemblyId) {
        if (assemblyId === undefined) {
            assemblyId = 0;
        }
        return this.http
            .delete(this.environment.apiUrl + 'api/assembly/delete?assemblyId=' + assemblyId)
            .pipe(catchError(this.handleError('delete')));
    };
    /**
     * @return {?}
     */
    AssemblyService.prototype.getAll = /**
     * @return {?}
     */
    function () {
        return this.http
            .get(this.environment.apiUrl + 'api/assembly/all')
            .pipe(catchError(this.handleError('getAll', []))).toPromise();
    };
    /**
     * @private
     * @template T
     * @param {?=} operation
     * @param {?=} result
     * @return {?}
     */
    AssemblyService.prototype.handleError = /**
     * @private
     * @template T
     * @param {?=} operation
     * @param {?=} result
     * @return {?}
     */
    function (operation, result) {
        var _this = this;
        if (operation === void 0) { operation = 'operation'; }
        return function (error) {
            if (error.error.Message !== undefined) {
                _this.rteSnackBarService.showErrorMessage('' + error.error.Message, 'OK');
            }
            else {
                _this.rteSnackBarService.showErrorMessage('Não foi possível concluir a solicitação.', 'OK');
            }
            return of((/** @type {?} */ (result)));
        };
    };
    AssemblyService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    AssemblyService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: RteSnackbarService },
        { type: undefined, decorators: [{ type: Inject, args: ['environment',] }] }
    ]; };
    /** @nocollapse */ AssemblyService.ngInjectableDef = defineInjectable({ factory: function AssemblyService_Factory() { return new AssemblyService(inject(HttpClient), inject(RteSnackbarService), inject("environment")); }, token: AssemblyService, providedIn: "root" });
    return AssemblyService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AssemblyRegisterService = /** @class */ (function () {
    function AssemblyRegisterService(assemblyService) {
        this.assemblyService = assemblyService;
    }
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    AssemblyRegisterService.prototype.save = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        return this.assemblyService.save(objectCurrent);
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    AssemblyRegisterService.prototype.delete = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        return this.assemblyService.delete(objectCurrent.Id);
    };
    /**
     * @param {?} objectCurrent
     * @param {?} page
     * @return {?}
     */
    AssemblyRegisterService.prototype.get = /**
     * @param {?} objectCurrent
     * @param {?} page
     * @return {?}
     */
    function (objectCurrent, page) {
        return this.assemblyService.getAssemblies(objectCurrent.Id, objectCurrent.Description, objectCurrent.Name, page);
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    AssemblyRegisterService.prototype.clear = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        objectCurrent.Id = null;
        objectCurrent.Description = '';
        objectCurrent.Name = '';
        objectCurrent.Revision = 0;
        objectCurrent.HasChanged = false;
    };
    /**
     * @return {?}
     */
    AssemblyRegisterService.prototype.close = /**
     * @return {?}
     */
    function () {
    };
    AssemblyRegisterService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    AssemblyRegisterService.ctorParameters = function () { return [
        { type: AssemblyService }
    ]; };
    /** @nocollapse */ AssemblyRegisterService.ngInjectableDef = defineInjectable({ factory: function AssemblyRegisterService_Factory() { return new AssemblyRegisterService(inject(AssemblyService)); }, token: AssemblyRegisterService, providedIn: "root" });
    return AssemblyRegisterService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AssemblyRegisterComponent = /** @class */ (function () {
    function AssemblyRegisterComponent(assemblyService, route, rteSnackBarService) {
        this.assemblyService = assemblyService;
        this.route = route;
        this.rteSnackBarService = rteSnackBarService;
        this._title = 'Cadastro de Módulos';
        this.matcher = new MyErrorStateMatcher$1();
        this.assemblyInfo = new AssemblyInfo();
        this.toolbarObject = new RteToolbarViewModel();
        this.toolbarObject.current = this.assemblyInfo;
        this.service = new AssemblyRegisterService(assemblyService);
    }
    /**
     * @return {?}
     */
    AssemblyRegisterComponent.prototype.getError = /**
     * @return {?}
     */
    function () {
        return 'Login';
    };
    /**
     * @return {?}
     */
    AssemblyRegisterComponent.prototype.hasChange = /**
     * @return {?}
     */
    function () {
        this.toolbarObject.current.HasChanged = true;
    };
    /**
     * @param {?} beforeSave
     * @return {?}
     */
    AssemblyRegisterComponent.prototype.validateBeforeSave = /**
     * @param {?} beforeSave
     * @return {?}
     */
    function (beforeSave) {
        beforeSave.cancelSave = false;
        if (this.toolbarObject.current.Name === undefined || this.toolbarObject.current.Name === '') {
            this.errorMessageEmail = 'Por favor, preencher o módulo.';
            this.rteSnackBarService.showWarningMessage('Por favor, preencher o módulo!', 'OK');
            beforeSave.cancelSave = true;
            this.assemblyNameInput.nativeElement.focus();
            return;
        }
        if (this.toolbarObject.current.Description === undefined || this.toolbarObject.current.Description === '') {
            this.errorMessageNome = 'Por favor, preencher a descrição.';
            this.rteSnackBarService.showWarningMessage('Por favor, preencher a descrição!', "OK");
            this.assemblyDescriptionInput.nativeElement.focus();
            beforeSave.cancelSave = true;
            return;
        }
    };
    /**
     * @param {?} afterSave
     * @return {?}
     */
    AssemblyRegisterComponent.prototype.customizeAfterSave = /**
     * @param {?} afterSave
     * @return {?}
     */
    function (afterSave) {
        if (afterSave.success) {
            this.toolbarObject.current.Revision++;
            if (afterSave.oldId == afterSave.newId && afterSave.newId > 0) {
                this.rteSnackBarService.showSuccessMessage('Módulo ' + this.toolbarObject.current.Description + ' alterado com sucesso!', 'OK');
            }
            if (afterSave.oldId == null && afterSave.newId > 0) {
                this.rteSnackBarService.showSuccessMessage('Módulo ' + this.toolbarObject.current.Description + ' inserido com sucesso!', 'OK');
            }
        }
    };
    /**
     * @param {?} data
     * @return {?}
     */
    AssemblyRegisterComponent.prototype.customizeAfterDelete = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        if (data) {
            this.rteSnackBarService.showSuccessMessage('Registro excluido com sucesso!', 'OK');
        }
        else {
            this.rteSnackBarService.showErrorMessage('Não foi possível excluir o registro!', 'OK');
        }
    };
    /**
     * @return {?}
     */
    AssemblyRegisterComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.assemblyIdInput.nativeElement.focus();
    };
    AssemblyRegisterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-assembly-register',
                    template: "<div #divAssembly class=\"mat-grid-list\" *ngIf=\"toolbarObject.current\">\r\n  <mat-card class=\"mat-card-grupo-objeto\">\r\n    <mat-card-title>\r\n      <rte-toolbar [title]=\"_title\"\r\n                       [toolbarObject]=\"toolbarObject\"\r\n                       [service]=\"service\"\r\n                       [KeyDownElementArea]=\"divAssembly\"\r\n                       (validateBeforeSave)=\"validateBeforeSave($event)\"\r\n                       (customizeAfterSave)=\"customizeAfterSave($event)\"\r\n                       (customizeAfterDelete)=\"customizeAfterDelete($event)\"></rte-toolbar>\r\n    </mat-card-title>\r\n      <mat-card-content>\r\n        <mat-grid-list cols=\"10\" rowHeight=\"110px\" class=\"rte-mat-grid-list-tile\">\r\n          <mat-grid-tile [colspan]=\"1\" [rowspan]=\"1\">\r\n            <rte-form-field class=\"rte-form-field\">\r\n              <span [ngClass]=\"{'personal-backgroud-readonly': toolbarObject.readonlyInsertMode || toolbarObject.readonlyBrowserMode || toolbarObject.readonlyEditMode}\">\r\n                <input #inputId id=\"id\" rteInput type=\"number\" placeholder=\"C\u00F3digo\" [(ngModel)]=\"toolbarObject.current.Id\"\r\n                       [readonly]='toolbarObject.readonlyInsertMode || toolbarObject.readonlyBrowserMode || toolbarObject.readonlyEditMode'\r\n                       autofocus />\r\n              </span>\r\n              <button rtebutton *ngIf=\"toolbarObject.current.Id && toolbarObject.readonlyFirstMode\" matSuffix rtebutton-icon aria-label=\"Clear\" (click)=\"toolbarObject.current.Id=0\">\r\n                <rte-icon>close</rte-icon>\r\n              </button>\r\n            </rte-form-field>\r\n          </mat-grid-tile>\r\n\r\n          <mat-grid-tile [colspan]=\"4\" [rowspan]=\"1\">\r\n            <rte-form-field class=\"rte-form-field\">\r\n              <span [ngClass]=\"{'personal-backgroud-readonly': toolbarObject.readonlyBrowserMode }\">\r\n                <input #inputName id=\"description\" rteInput type=\"text\" placeholder=\"M\u00F3dulo\" [(ngModel)]=\"toolbarObject.current.Name\"\r\n                       [readonly]='toolbarObject.readonlyBrowserMode'\r\n                       (change)=\"hasChange()\" />\r\n              </span>\r\n              <button rtebutton *ngIf=\"toolbarObject.current.Name && !toolbarObject.readonlyBrowserMode\" matSuffix rtebutton-icon aria-label=\"Clear\" (click)=\"toolbarObject.current.Name=''\">\r\n                <rte-icon>close</rte-icon>\r\n              </button>\r\n            </rte-form-field>\r\n          </mat-grid-tile>\r\n\r\n          <mat-grid-tile [colspan]=\"4\" [rowspan]=\"1\">\r\n            <rte-form-field class=\"rte-form-field\">\r\n              <span [ngClass]=\"{'personal-backgroud-readonly': toolbarObject.readonlyBrowserMode }\">\r\n                <input #inputDescription id=\"description\" rteInput type=\"text\" placeholder=\"Descri\u00E7\u00E3o\" [(ngModel)]=\"toolbarObject.current.Description\"\r\n                       style=\"text-transform: uppercase\"\r\n                       [readonly]='toolbarObject.readonlyBrowserMode'\r\n                       (change)=\"hasChange()\" />\r\n              </span>\r\n              <button rtebutton *ngIf=\"toolbarObject.current.Description && !toolbarObject.readonlyBrowserMode\" matSuffix rtebutton-icon aria-label=\"Clear\" (click)=\"toolbarObject.current.Description=''\">\r\n                <rte-icon>close</rte-icon>\r\n              </button>\r\n            </rte-form-field>\r\n          </mat-grid-tile>\r\n\r\n          <mat-grid-tile [colspan]=\"1\" [rowspan]=\"1\">\r\n            <rte-checkbox [(ngModel)]=\"toolbarObject.current.IsPrivate\" color=\"primary\" class=\"mat-checkbox-control\"\r\n                          [disabled]='toolbarObject.readonlyBrowserMode'\r\n                          (change)=\"hasChange()\">\r\n              Privado\r\n            </rte-checkbox>\r\n          </mat-grid-tile>\r\n\r\n        </mat-grid-list>\r\n\r\n\r\n      </mat-card-content>\r\n  </mat-card>\r\n</div>\r\n\r\n\r\n",
                    styles: [".mat-mini-fab{box-shadow:none!important}.mat-checkbox-select{width:100%!important;left:2%!important}.mat-checkbox-control,.mat-grid-list{width:100%}.mat-card{margin:16px}.rte-form-field{width:100%;padding-right:5%;padding-left:5%}.personal-backgroud-readonly{padding-top:5px;padding-bottom:3px;background-color:#d0cccc;padding-left:6px;display:flex}.personal-backgroud-readonly label{padding-left:10px}.personal-backgroud{padding-top:10px;padding-bottom:3px}.mat-grid-tile{float:left}.mat-table mat-table{box-shadow:none}.mat-column{padding-left:15px}.mat-option-select mat-form-field{width:96%}.mat-option-select{font-size:14px}.rte-label{padding-left:10px;padding-right:10px}.rte-app-user-actions{text-align:right;padding-top:7px}.rte-mat-vertical_line{height:88px!important;padding-bottom:27px}.mat-table{margin:0!important}.mat-card-grupo-objeto{padding-left:0;padding-right:0;padding-bottom:0;background-color:#f5f5f5}.mat-card-grupo-objeto mat-card-title{font-size:22px;color:#7f7979}mat-error{text-align:right}"]
                }] }
    ];
    /** @nocollapse */
    AssemblyRegisterComponent.ctorParameters = function () { return [
        { type: AssemblyService },
        { type: ActivatedRoute },
        { type: RteSnackbarService }
    ]; };
    AssemblyRegisterComponent.propDecorators = {
        assemblyIdInput: [{ type: ViewChild, args: ['inputId', { read: ElementRef },] }],
        assemblyDescriptionInput: [{ type: ViewChild, args: ['inputDescription', { read: ElementRef },] }],
        assemblyNameInput: [{ type: ViewChild, args: ['inputName', { read: ElementRef },] }]
    };
    return AssemblyRegisterComponent;
}());
var MyErrorStateMatcher$1 = /** @class */ (function () {
    function MyErrorStateMatcher() {
    }
    /**
     * @param {?} control
     * @param {?} form
     * @return {?}
     */
    MyErrorStateMatcher.prototype.isErrorState = /**
     * @param {?} control
     * @param {?} form
     * @return {?}
     */
    function (control, form) {
        /** @type {?} */
        var isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    };
    return MyErrorStateMatcher;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteAssemblyRegisterModule = /** @class */ (function () {
    function RteAssemblyRegisterModule() {
    }
    /**
     * @param {?} environment
     * @return {?}
     */
    RteAssemblyRegisterModule.forRoot = /**
     * @param {?} environment
     * @return {?}
     */
    function (environment) {
        return {
            ngModule: RteAssemblyRegisterModule,
            providers: [
                AssemblyService,
                {
                    provide: 'environment',
                    useValue: environment
                }
            ]
        };
    };
    RteAssemblyRegisterModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        RteLibraryModule,
                        FormsModule,
                        MatFormFieldModule,
                        RteMaterialModule,
                        MatPaginatorModule,
                        MatProgressSpinnerModule,
                        MatToolbarModule,
                        MatSortModule,
                        MatTableModule,
                        MatSidenavModule,
                        MatListModule,
                        MatGridListModule,
                        MatCardModule,
                        MatMenuModule,
                        MatExpansionModule,
                        MatSnackBarModule,
                        MatTreeModule,
                        MatTabsModule,
                        MatChipsModule,
                        MatTooltipModule,
                        MatProgressBarModule,
                        MatDialogModule,
                        MatCheckboxModule,
                        RteToolbarModule,
                        ReactiveFormsModule
                    ],
                    declarations: [AssemblyRegisterComponent]
                },] }
    ];
    return RteAssemblyRegisterModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var PermissionType = {
    None: 0,
    Read: 1,
    Insert: 16,
    Update: 256,
    Delete: 4096,
    Export: 65536,
    Special: 1048576,
};
PermissionType[PermissionType.None] = 'None';
PermissionType[PermissionType.Read] = 'Read';
PermissionType[PermissionType.Insert] = 'Insert';
PermissionType[PermissionType.Update] = 'Update';
PermissionType[PermissionType.Delete] = 'Delete';
PermissionType[PermissionType.Export] = 'Export';
PermissionType[PermissionType.Special] = 'Special';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AssemblyCoreModel = /** @class */ (function () {
    function AssemblyCoreModel() {
    }
    return AssemblyCoreModel;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ObjectModel = /** @class */ (function () {
    function ObjectModel() {
        this.Id = null;
        this.Name = '';
        this.Description = '';
        this.Namespace = '';
        this.Revision = null;
        this.AssemblyCore = new AssemblyCoreModel();
        this.AmountByPage = 1;
        this.AccessibleInMenu = false;
        this.SessionControl = false;
        this.Read = false;
        this.Insert = false;
        this.Update = false;
        this.Delete = false;
        this.Export = false;
        this.Permissions = PermissionType.None;
    }
    return ObjectModel;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ObjectService = /** @class */ (function () {
    function ObjectService(http, assemblyService, environment) {
        var _this = this;
        this.http = http;
        this.assemblyService = assemblyService;
        this.environment = environment;
        this.getAll = function () {
            return _this.http.get(_this.baseUrl + 'webapi/object/all');
        };
        this.baseUrl = this.environment.apiCore;
    }
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    ObjectService.prototype.clear = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        if (objectCurrent != null) {
            objectCurrent = new ObjectModel();
        }
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    ObjectService.prototype.save = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        if (objectCurrent != null) {
            if (objectCurrent.Id <= 0) {
                objectCurrent.Id = 0;
                return this.http.post(this.baseUrl + 'object', objectCurrent);
            }
            else {
                return this.http.put(this.baseUrl + 'webapi/object', objectCurrent);
            }
        }
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    ObjectService.prototype.delete = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        /** @type {?} */
        var params = new HttpParams().set('id', objectCurrent.Id.toString());
        return this.http.delete(this.baseUrl + 'webapi/object', {
            params: params
        });
    };
    /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    ObjectService.prototype.get = /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    function (objectCurrent, page, pageSize) {
        page++;
        /** @type {?} */
        var params = new HttpParams()
            .set('page', page.toString())
            .set('amountByPage', pageSize.toString());
        if (objectCurrent) {
            params = this.appendHttpParams('Id', objectCurrent.Id, params);
            params = this.appendHttpParams('Description', objectCurrent.Description, params);
            params = this.appendHttpParams('Name', objectCurrent.Name, params);
            params = this.appendHttpParams('Namespace', objectCurrent.Namespace, params);
            if (objectCurrent.AssemblyCore && objectCurrent.AssemblyCore.Id) {
                params = this.appendHttpParams('AssemblyCore.Id', objectCurrent.AssemblyCore.Id, params);
            }
        }
        return this.http.get(this.baseUrl + 'webapi/object/getbyfilters', { params: params });
    };
    /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    ObjectService.prototype.appendHttpParams = /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    function (name, value, params) {
        return params.append(name, !value ? '' : value);
    };
    /**
     * @param {?} id
     * @return {?}
     */
    ObjectService.prototype.getById = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        return this.http.get(this.environment.apiCore + 'webapi/object/' + id);
    };
    ObjectService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    ObjectService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: AssemblyService },
        { type: undefined, decorators: [{ type: Inject, args: ['environment',] }] }
    ]; };
    /** @nocollapse */ ObjectService.ngInjectableDef = defineInjectable({ factory: function ObjectService_Factory() { return new ObjectService(inject(HttpClient), inject(AssemblyService), inject("environment")); }, token: ObjectService, providedIn: "root" });
    return ObjectService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ObjectComponent = /** @class */ (function () {
    function ObjectComponent(service) {
        this.service = service;
        this.toolbarObject = new RteToolbarViewModel();
        this.toolbarObject = new RteToolbarViewModel();
        this.toolbarObject.current = new ObjectModel();
        this.toolbarObject.searchObject = {};
        this.toolbarObject.searchObject.AssemblyCore = {};
    }
    /**
     * @return {?}
     */
    ObjectComponent.prototype.customizeAfterCancelOperation = /**
     * @return {?}
     */
    function () {
        this.toolbarObject.searchObject = {};
        this.toolbarObject.searchObject.AssemblyCore = {};
    };
    /**
     * @return {?}
     */
    ObjectComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    ObjectComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-object',
                    template: "<rte-toolbar [toolbarObject]=\"toolbarObject\" [service]=\"service\" [KeyDownElementArea]=\"form\"\r\n(customizeAfterCancelOperation)=\"customizeAfterCancelOperation()\">\r\n\r\n</rte-toolbar>\r\n\r\n<div class=\"wrapper\">\r\n  <rte-app-title></rte-app-title>\r\n\r\n  <div #form>\r\n    <rte-app-object-search [toolbarObject]=\"toolbarObject\"\r\n      *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n    </rte-app-object-search>\r\n\r\n    <rte-app-object-table [toolbarObject]=\"toolbarObject\"\r\n      *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n    </rte-app-object-table>\r\n\r\n    <rte-app-object-form #objectGroupForm [toolbarObject]=\"toolbarObject\"\r\n      [hidden]=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n    </rte-app-object-form>\r\n  </div>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ObjectComponent.ctorParameters = function () { return [
        { type: ObjectService }
    ]; };
    return ObjectComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ObjectFormComponent = /** @class */ (function () {
    function ObjectFormComponent(assemblyService) {
        this.assemblyService = assemblyService;
        this.assembliesOptions = new Array();
    }
    /**
     * @return {?}
     */
    ObjectFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.assemblyService.getAll()];
                    case 1:
                        _a.assembliesOptions = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ObjectFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-object-form',
                    template: "<form #formFilterRules=\"ngForm\" autocomplete=\"off\">\r\n  <rte-card>\r\n    <mat-card-content>\r\n\r\n      <div class=\"row-form\">\r\n        <div class=\"column-form\">\r\n          <rte-form-field>\r\n            <input rteInput placeholder=\"C\u00F3digo\" [(ngModel)]=\"toolbarObject.current.Id\" name=\"Id\" readonly>\r\n          </rte-form-field>\r\n        </div>\r\n        <div class=\"column-form\">\r\n          <rte-form-field>\r\n            <input rteInput #Description name=\"Description\" placeholder=\"Descri\u00E7\u00E3o\" required [readonly]=\"toolbarObject.readonlyBrowserMode\"\r\n              [(ngModel)]=\"toolbarObject.current.Description\">\r\n          </rte-form-field>\r\n        </div>\r\n      </div>\r\n      <div class=\"row-form\">\r\n        <div class=\"column-form\">\r\n          <rte-form-field>\r\n            <rte-select name=\"AssemblyId\" required [disabled]=\"toolbarObject.readonlyBrowserMode\" [(ngModel)]=\"toolbarObject.current.AssemblyCore.Id\" placeholder=\"M\u00F3dulo\">\r\n              <rte-option *ngFor=\"let option of assembliesOptions\" [value]=\"option.Id\">\r\n                {{ option.Name }}\r\n              </rte-option>\r\n            </rte-select>\r\n          </rte-form-field>\r\n        </div>\r\n        <div class=\"column-form\">\r\n          <div class=\"input-group\">\r\n            <div class=\"col-2\">\r\n              <rte-checkbox name=\"AccessibleInMenu\" [disabled]=\"toolbarObject.readonlyBrowserMode\" [(ngModel)]=\"toolbarObject.current.AccessibleInMenu\">\r\n                Acess\u00EDvel no menu\r\n              </rte-checkbox>\r\n            </div>\r\n            <div class=\"col-2\">\r\n              <rte-checkbox name=\"SessionControl\" [disabled]=\"toolbarObject.readonlyBrowserMode\" [(ngModel)]=\"toolbarObject.current.SessionControl\">\r\n                Controle de Sess\u00E3o\r\n              </rte-checkbox>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"row-form\">\r\n        <div class=\"column-form\">\r\n          <rte-form-field>\r\n            <input rteInput #Namespace name=\"Namespace\" placeholder=\"Caminho Objeto\" required [readonly]=\"toolbarObject.readonlyBrowserMode\"\r\n              [(ngModel)]=\"toolbarObject.current.Namespace\">\r\n          </rte-form-field>\r\n        </div>\r\n      </div>\r\n      <div class=\"row-form\">\r\n        <div class=\"column-form\">\r\n          <rte-form-field>\r\n            <input rteInput #Name name=\"Name\" placeholder=\"Nome\" required [readonly]=\"toolbarObject.readonlyBrowserMode\" [(ngModel)]=\"toolbarObject.current.Name\">\r\n          </rte-form-field>\r\n        </div>\r\n      </div>\r\n    </mat-card-content>\r\n  </rte-card>\r\n  <rte-card>\r\n    <mat-card-header>\r\n      <mat-card-title>Fun\u00E7\u00F5es</mat-card-title>\r\n    </mat-card-header>\r\n    <div class=\"row-form\">\r\n      <div class=\"column-form\">\r\n        <rte-checkbox name=\"Read\" [disabled]=\"toolbarObject.readonlyBrowserMode\" [(ngModel)]=\"toolbarObject.current.Read\">Leitura</rte-checkbox>\r\n      </div>\r\n      <div class=\"column-form\">\r\n        <rte-checkbox name=\"Insert\" [disabled]=\"toolbarObject.readonlyBrowserMode\" [(ngModel)]=\"toolbarObject.current.Insert\">Insers\u00E3o</rte-checkbox>\r\n      </div>\r\n      <div class=\"column-form\">\r\n        <rte-checkbox name=\"Update\" [disabled]=\"toolbarObject.readonlyBrowserMode\" [(ngModel)]=\"toolbarObject.current.Update\">Altera\u00E7\u00E3o</rte-checkbox>\r\n      </div>\r\n      <div class=\"column-form\">\r\n        <rte-checkbox name=\"Delete\" [disabled]=\"toolbarObject.readonlyBrowserMode\" [(ngModel)]=\"toolbarObject.current.Delete\">Exclus\u00E3o</rte-checkbox>\r\n      </div>\r\n      <div class=\"column-form\">\r\n        <rte-checkbox name=\"Export\" [disabled]=\"toolbarObject.readonlyBrowserMode\" [(ngModel)]=\"toolbarObject.current.Export\">Exporta\u00E7\u00E3o</rte-checkbox>\r\n      </div>\r\n    </div>\r\n  </rte-card>\r\n</form>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ObjectFormComponent.ctorParameters = function () { return [
        { type: AssemblyService }
    ]; };
    ObjectFormComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return ObjectFormComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ObjectSearchComponent = /** @class */ (function () {
    function ObjectSearchComponent(assemblyService) {
        this.assemblyService = assemblyService;
        this.assembliesOptions = new Array();
    }
    /**
     * @return {?}
     */
    ObjectSearchComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.assemblyService.getAll()];
                    case 1:
                        _a.assembliesOptions = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ObjectSearchComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-object-search',
                    template: "<rte-card>\r\n  <mat-card-content>\r\n    <form #formFilterRules=\"ngForm\" autocomplete=\"off\">\r\n      <div class=\"row-form\">\r\n        <div class=\"column-form\">\r\n          <rte-form-field>\r\n            <input rteInput placeholder=\"C\u00F3digo\" [(ngModel)]=\"toolbarObject.searchObject.Id\" name=\"Id\">\r\n          </rte-form-field>\r\n        </div>\r\n        <div class=\"column-form\">\r\n          <rte-form-field>\r\n            <input rteInput #Description name=\"Description\" placeholder=\"Descri\u00E7\u00E3o\"\r\n              [(ngModel)]=\"toolbarObject.searchObject.Description\">\r\n          </rte-form-field>\r\n        </div>\r\n      </div>\r\n      <div class=\"row-form\">\r\n        <div class=\"column-form\">\r\n          <rte-form-field>\r\n            <rte-select name=\"AssemblyId\" [(ngModel)]=\"toolbarObject.searchObject.AssemblyCore.Id\" placeholder=\"M\u00F3dulo\">\r\n                <rte-option *ngFor=\"let option of assembliesOptions\" [value]=\"option.Id\">\r\n                  {{ option.Name }}\r\n                </rte-option>\r\n              </rte-select>\r\n          </rte-form-field>\r\n        </div>\r\n\r\n      </div>\r\n      <div class=\"row-form\">\r\n        <div class=\"column-form\">\r\n          <rte-form-field>\r\n            <input rteInput #Namespace name=\"Namespace\" placeholder=\"Caminho Objeto\"\r\n              [(ngModel)]=\"toolbarObject.searchObject.Namespace\">\r\n          </rte-form-field>\r\n        </div>\r\n      </div>\r\n      <div class=\"row-form\">\r\n        <div class=\"column-form\">\r\n          <rte-form-field>\r\n            <input rteInput #Name name=\"Name\" placeholder=\"Nome\" [(ngModel)]=\"toolbarObject.searchObject.Name\">\r\n          </rte-form-field>\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </mat-card-content>\r\n</rte-card>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ObjectSearchComponent.ctorParameters = function () { return [
        { type: AssemblyService }
    ]; };
    ObjectSearchComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return ObjectSearchComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ObjectTableComponent = /** @class */ (function () {
    function ObjectTableComponent() {
        this.displayedColumns = ['Id', 'Description', 'Name', 'Namespace'];
    }
    /**
     * @return {?}
     */
    ObjectTableComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    ObjectTableComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-object-table',
                    template: "<rte-card>\r\n  <mat-card-content>\r\n    <div class=\"mat-elevation-z4\">\r\n      <rte-table [dataSource]=\"toolbarObject.dataSource\"\r\n        *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n        <ng-container rteColumnDef=\"Id\">\r\n          <rte-header-cell *rteHeaderCellDef>Id</rte-header-cell>\r\n          <rte-cell *rteCellDef=\"let groupObject\">{{groupObject.Id}}</rte-cell>\r\n        </ng-container>\r\n\r\n        <ng-container rteColumnDef=\"Description\">\r\n          <rte-header-cell *rteHeaderCellDef>Descri\u00E7\u00E3o</rte-header-cell>\r\n          <rte-cell *rteCellDef=\"let groupObject\">{{groupObject.Description}}</rte-cell>\r\n        </ng-container>\r\n        \r\n        <ng-container rteColumnDef=\"Name\">\r\n          <rte-header-cell *rteHeaderCellDef>Nome</rte-header-cell>\r\n          <rte-cell *rteCellDef=\"let groupObject\">{{groupObject.Name}}</rte-cell>\r\n        </ng-container>\r\n\r\n        <ng-container rteColumnDef=\"Namespace\">\r\n          <rte-header-cell *rteHeaderCellDef>Namespace</rte-header-cell>\r\n          <rte-cell *rteCellDef=\"let groupObject\">{{groupObject.Namespace}}</rte-cell>\r\n        </ng-container>\r\n\r\n        <rte-header-row *rteHeaderRowDef=\"displayedColumns\"></rte-header-row>\r\n        <rte-row *rteRowDef=\"let row; columns: displayedColumns;\" (click)=\"toolbarObject.setCurrent(row)\"\r\n          (dblclick)=\"toolbarObject.viewMode(row)\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"\r\n          [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted, selected: toolbarObject.selectionModel.isSelected(row)}\">\r\n        </rte-row>\r\n      </rte-table>\r\n    </div>\r\n  </mat-card-content>\r\n</rte-card>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ObjectTableComponent.ctorParameters = function () { return []; };
    ObjectTableComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return ObjectTableComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteObjectModule = /** @class */ (function () {
    function RteObjectModule() {
    }
    /**
     * @param {?} environment
     * @return {?}
     */
    RteObjectModule.forRoot = /**
     * @param {?} environment
     * @return {?}
     */
    function (environment) {
        return {
            ngModule: RteObjectModule,
            providers: [
                ObjectService,
                {
                    provide: 'environment',
                    useValue: environment
                }
            ]
        };
    };
    RteObjectModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        RteLibraryModule,
                        FormsModule,
                        MatFormFieldModule,
                        RteMaterialModule,
                        MatPaginatorModule,
                        MatProgressSpinnerModule,
                        MatToolbarModule,
                        MatSortModule,
                        MatTableModule,
                        MatSidenavModule,
                        MatListModule,
                        MatGridListModule,
                        MatCardModule,
                        MatMenuModule,
                        MatExpansionModule,
                        MatSnackBarModule,
                        MatTreeModule,
                        MatTabsModule,
                        MatChipsModule,
                        MatTooltipModule,
                        MatProgressBarModule,
                        MatDialogModule,
                        MatCheckboxModule,
                        RteToolbarModule,
                        ReactiveFormsModule,
                        RteAppTitleModule
                    ],
                    declarations: [ObjectComponent, ObjectFormComponent, ObjectSearchComponent, ObjectTableComponent]
                },] }
    ];
    return RteObjectModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SystemFormComponent = /** @class */ (function () {
    function SystemFormComponent(rteSnackBarService) {
        this.rteSnackBarService = rteSnackBarService;
    }
    /**
     * @return {?}
     */
    SystemFormComponent.prototype.getDescriptionMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.Description)
            ? 'A descrição deve ser informada.' : '';
    };
    /**
     * @return {?}
     */
    SystemFormComponent.prototype.getExternalCodeMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.ExternalCode) ? 'O código Externo deve ser informado.' : '';
    };
    /**
     * @return {?}
     */
    SystemFormComponent.prototype.getValidation = /**
     * @return {?}
     */
    function () {
        return (this.getDescriptionMessage() || this.getExternalCodeMessage());
    };
    /**
     * @return {?}
     */
    SystemFormComponent.prototype.showErrorMessage = /**
     * @return {?}
     */
    function () {
        return this.toolbarObject.currentStatus === RteToolbarStatusEnum.Creating
            || this.toolbarObject.currentStatus === RteToolbarStatusEnum.Editing;
    };
    /**
     * @param {?} afterSave
     * @return {?}
     */
    SystemFormComponent.prototype.customizeAfterSave = /**
     * @param {?} afterSave
     * @return {?}
     */
    function (afterSave) {
        if (afterSave.success === true) {
            this.rteSnackBarService.showSuccessMessage('Sistema salvo com sucesso', 'Sucesso');
        }
    };
    /**
     * @param {?} option
     * @return {?}
     */
    SystemFormComponent.prototype.customizeAfterDelete = /**
     * @param {?} option
     * @return {?}
     */
    function (option) {
        if (option === true) {
            this.rteSnackBarService.showSuccessMessage('Sistema excluído com sucesso', 'Sucesso');
        }
    };
    /**
     * @return {?}
     */
    SystemFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    SystemFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-system-form',
                    template: "  <rte-card>\r\n    <mat-card-content>\r\n      <form #formFilterRules=\"ngForm\" autocomplete=\"off\">\r\n        <div class='row-form'>\r\n          <div class='column-form'>\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input rteInput placeholder=\"C\u00F3digo\" [(ngModel)]=\"toolbarObject.current.Id\" name=\"Id\" [readonly]=\"true\">\r\n            </rte-form-field>\r\n          </div>\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input rteInput placeholder=\"C\u00F3digo Externo\" name=\"C\u00F3digo Externo\"\r\n                [(ngModel)]=\"toolbarObject.current.ExternalCode\" [readonly]=\"toolbarObject.readonlyBrowserMode\"\r\n                maxlength=\"35\" required>\r\n              <mat-error>{{getExternalCodeMessage()}}</mat-error>\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n        <div class=\"row-form\">\r\n          <div class='column-form'>\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input rteInput #Description name=\"Description\" placeholder=\"Descri\u00E7\u00E3o\"\r\n                [(ngModel)]=\"toolbarObject.current.Description\" [readonly]=\"toolbarObject.readonlyBrowserMode\" required\r\n                maxlength=\"65\">\r\n              <mat-error>{{getDescriptionMessage()}}</mat-error>\r\n            </rte-form-field>\r\n          </div>\r\n          <div class='column-form'>\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input rteInput #Description name=\"Title\" placeholder=\"T\u00EDtulo\" [(ngModel)]=\"toolbarObject.current.Title\"\r\n                [readonly]=\"toolbarObject.readonlyBrowserMode\" maxlength=\"65\">\r\n              <mat-error>{{getDescriptionMessage()}}</mat-error>\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n        <div class=\"row-form\">\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input rteInput placeholder=\"URL\" name=\"URL\" [(ngModel)]=\"toolbarObject.current.Url\" maxlength=\"3000\"\r\n                [readonly]=\"toolbarObject.readonlyBrowserMode\">\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </mat-card-content>\r\n  </rte-card>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    SystemFormComponent.ctorParameters = function () { return [
        { type: RteSnackbarService }
    ]; };
    SystemFormComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return SystemFormComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SystemSearchComponent = /** @class */ (function () {
    function SystemSearchComponent() {
    }
    /**
     * @return {?}
     */
    SystemSearchComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    SystemSearchComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-system-search',
                    template: "  <rte-card>\r\n    <mat-card-content>\r\n      <form #formFilterRules=\"ngForm\" autocomplete=\"off\">\r\n        <div class='row-form'>\r\n          <div class='column-form'>\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input rteInput placeholder=\"C\u00F3digo\" [(ngModel)]=\"toolbarObject.searchObject.Id\" name=\"Id\">\r\n            </rte-form-field>\r\n          </div>\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input rteInput placeholder=\"C\u00F3digo Externo\" name=\"C\u00F3digo Externo\"\r\n                [(ngModel)]=\"toolbarObject.searchObject.ExternalCode\">\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n        <div class=\"row-form\">\r\n          <div class='column-form'>\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input rteInput #Description name=\"Description\" placeholder=\"Descri\u00E7\u00E3o\"\r\n                [(ngModel)]=\"toolbarObject.searchObject.Description\">\r\n            </rte-form-field>\r\n          </div>\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input rteInput placeholder=\"T\u00EDtulo\" name=\"T\u00EDtulo\" [(ngModel)]=\"toolbarObject.searchObject.Title\">\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n        <div class=\"row-form\">\r\n          <div class='column-form'>\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input rteInput placeholder=\"URL\" name=\"URL\" [(ngModel)]=\"toolbarObject.searchObject.Url\">\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </mat-card-content>\r\n  </rte-card>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    SystemSearchComponent.ctorParameters = function () { return []; };
    SystemSearchComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return SystemSearchComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SystemService = /** @class */ (function () {
    function SystemService(http, environment) {
        this.http = http;
        this.environment = environment;
    }
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    SystemService.prototype.clear = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        objectCurrent.Id = null;
        objectCurrent.ExternalCode = '';
        objectCurrent.Description = '';
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    SystemService.prototype.save = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        if (objectCurrent.Id == null || objectCurrent.Id == 0) {
            return this.http.post(this.environment.apiCore + 'system', objectCurrent);
        }
        else {
            return this.http.put(this.environment.apiCore + 'system', objectCurrent);
        }
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    SystemService.prototype.delete = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        return this.http.delete(this.environment.apiCore +
            'system/' +
            objectCurrent.Id);
    };
    /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    SystemService.prototype.get = /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    function (objectCurrent, page, pageSize) {
        page++;
        /** @type {?} */
        var params = new HttpParams()
            .set('page', page.toString())
            .set('amountByPage', pageSize.toString());
        if (objectCurrent) {
            params = this.appendHttpParams('id', objectCurrent.Id, params);
            params = this.appendHttpParams('Description', objectCurrent.Description, params);
            params = this.appendHttpParams('ExternalCode', objectCurrent.ExternalCode, params);
            params = this.appendHttpParams('Url', objectCurrent.Url, params);
            params = this.appendHttpParams('Title', objectCurrent.Title, params);
        }
        return this.http.get(this.environment.apiCore + 'system/getbyfilters', { params: params });
    };
    /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    SystemService.prototype.appendHttpParams = /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    function (name, value, params) {
        return params.append(name, !value ? '' : value);
    };
    /**
     * @return {?}
     */
    SystemService.prototype.getAll = /**
     * @return {?}
     */
    function () {
        return this.http.get(this.environment.apiCore + 'system/getAll');
    };
    SystemService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    SystemService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['environment',] }] }
    ]; };
    /** @nocollapse */ SystemService.ngInjectableDef = defineInjectable({ factory: function SystemService_Factory() { return new SystemService(inject(HttpClient), inject("environment")); }, token: SystemService, providedIn: "root" });
    return SystemService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var System$1 = /** @class */ (function () {
    function System$$1() {
    }
    return System$$1;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SystemComponent = /** @class */ (function () {
    function SystemComponent(service, rteSnackBarService) {
        this.service = service;
        this.rteSnackBarService = rteSnackBarService;
        this.toolbarObject = new RteToolbarViewModel();
        this.toolbarObject = new RteToolbarViewModel();
        this.toolbarObject.searchObject = {};
    }
    /**
     * @return {?}
     */
    SystemComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.toolbarObject.current = new System$1();
    };
    /**
     * @param {?} beforeSave
     * @return {?}
     */
    SystemComponent.prototype.validateBeforeSave = /**
     * @param {?} beforeSave
     * @return {?}
     */
    function (beforeSave) {
        /** @type {?} */
        var validation = this.systemForm.getValidation();
        if (validation) {
            beforeSave.cancelSave = true;
            this.rteSnackBarService.showWarningMessage('Aviso', validation);
        }
    };
    SystemComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-system',
                    template: "<rte-toolbar [toolbarObject]=\"toolbarObject\" [service]=\"service\"\r\n\r\n[KeyDownElementArea]=\"form\"\r\n(validateBeforeSave)=\"validateBeforeSave($event)\"\r\n(customizeAfterSave)=\"systemForm.customizeAfterSave($event)\"\r\n(customizeAfterDelete)=\"systemForm.customizeAfterDelete($event)\">\r\n\r\n</rte-toolbar>\r\n<div class=\"wrapper\">   \r\n<rte-app-title></rte-app-title>\r\n\r\n\r\n<div #form>\r\n<rte-app-system-search [toolbarObject]=\"toolbarObject\" *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n</rte-app-system-search>\r\n\r\n<rte-app-system-grid [toolbarObject]=\"toolbarObject\" *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n</rte-app-system-grid>\r\n\r\n<rte-app-system-form #systemForm  [toolbarObject]=\"toolbarObject\" [hidden]=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n</rte-app-system-form>\r\n</div>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    SystemComponent.ctorParameters = function () { return [
        { type: SystemService },
        { type: RteSnackbarService }
    ]; };
    SystemComponent.propDecorators = {
        systemForm: [{ type: ViewChild, args: ['systemForm', { read: SystemFormComponent },] }]
    };
    return SystemComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SystemGridComponent = /** @class */ (function () {
    function SystemGridComponent() {
        this.displayedColumns = ['Id', 'Description', 'ExternalCode'];
    }
    /**
     * @return {?}
     */
    SystemGridComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    SystemGridComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-system-grid',
                    template: "<rte-card>\r\n  <mat-card-content>\r\n    <div class=\"mat-elevation-z4\">\r\n      <rte-table [dataSource]=\"toolbarObject.dataSource\"\r\n        *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n        <ng-container rteColumnDef=\"Id\">\r\n          <rte-header-cell *rteHeaderCellDef>Id</rte-header-cell>\r\n          <rte-cell *rteCellDef=\"let system\">{{system.Id}}</rte-cell>\r\n        </ng-container>\r\n\r\n        <ng-container rteColumnDef=\"Description\">\r\n          <rte-header-cell *rteHeaderCellDef>Descri\u00E7\u00E3o</rte-header-cell>\r\n          <rte-cell *rteCellDef=\"let system\">{{system.Description}}</rte-cell>\r\n        </ng-container>\r\n\r\n        <ng-container rteColumnDef=\"ExternalCode\">\r\n          <rte-header-cell *rteHeaderCellDef>C\u00F3digo Externo</rte-header-cell>\r\n          <rte-cell *rteCellDef=\"let system\">{{system.ExternalCode}}</rte-cell>\r\n        </ng-container>\r\n        <rte-header-row *rteHeaderRowDef=\"displayedColumns\"></rte-header-row>\r\n        <rte-row *rteRowDef=\"let row; columns: displayedColumns;\" (click)=\"toolbarObject.setCurrent(row)\"\r\n          (dblclick)=\"toolbarObject.viewMode(row)\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"\r\n          [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted, selected: toolbarObject.selectionModel.isSelected(row)}\">\r\n        </rte-row>\r\n      </rte-table>\r\n    </div>\r\n  </mat-card-content>\r\n</rte-card>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    SystemGridComponent.ctorParameters = function () { return []; };
    SystemGridComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return SystemGridComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteSystemModule = /** @class */ (function () {
    function RteSystemModule() {
    }
    /**
     * @param {?} environment
     * @return {?}
     */
    RteSystemModule.forRoot = /**
     * @param {?} environment
     * @return {?}
     */
    function (environment) {
        return {
            ngModule: RteSystemModule,
            providers: [
                SystemService,
                {
                    provide: 'environment',
                    useValue: environment
                }
            ]
        };
    };
    RteSystemModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        RteToolbarModule,
                        RteAppTitleModule,
                        RteMaterialModule,
                        MatRippleModule,
                        MatCheckboxModule,
                        MatSelectModule,
                        MatOptionModule,
                        MatListModule,
                        MatTableModule,
                        MatIconModule,
                        MatAutocompleteModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatProgressSpinnerModule,
                        MatToolbarModule,
                        MatDialogModule,
                        MatCardModule,
                        CdkTableModule,
                        MatDividerModule,
                        FormsModule
                    ],
                    declarations: [SystemFormComponent, SystemSearchComponent, SystemComponent, SystemGridComponent],
                    exports: [SystemComponent]
                },] }
    ];
    return RteSystemModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Menu = /** @class */ (function () {
    function Menu() {
    }
    return Menu;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var RTE_MENU_SERVICE_DATA = new InjectionToken('IMenuServiceToken');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MenuComponent = /** @class */ (function () {
    function MenuComponent(menuService, tabService, appService, rteColorService) {
        this.menuService = menuService;
        this.tabService = tabService;
        this.appService = appService;
        this.rteColorService = rteColorService;
        this.closeMenuEvent = new EventEmitter();
    }
    /**
     * @return {?}
     */
    MenuComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.menus = [];
        this.menuService.getMenus().subscribe(function (menus) {
            _this.menus = menus;
            /** @type {?} */
            var localMenus = _this.menuService.getLocalMenus();
            if (localMenus != null) {
                for (var i = 0; i < localMenus.length; i++) {
                    _this.menus.push(localMenus[i]);
                }
            }
            _this.appService.applicationsToSearch = [];
            _this.menus.forEach(function (menu) {
                menu.SubMenus.forEach(function (subMenu) {
                    subMenu.Parent = menu;
                    subMenu.SubMenus.forEach(function (app) {
                        app.Parent = subMenu;
                        _this.appService.applicationsToSearch.push({
                            Id: app.Url,
                            Description: app.Description,
                            Breadcrumb: menu.Description + ' / ' + subMenu.Description + ' / ' + app.Description
                        });
                    });
                });
            });
        });
    };
    /**
     * @return {?}
     */
    MenuComponent.prototype.closeMenu = /**
     * @return {?}
     */
    function () {
        this.closeMenuEvent.emit();
    };
    /**
     * @param {?} menu
     * @return {?}
     */
    MenuComponent.prototype.openSubMenus = /**
     * @param {?} menu
     * @return {?}
     */
    function (menu) {
        this.subMenus = menu.SubMenus;
    };
    /**
     * @param {?} menu
     * @return {?}
     */
    MenuComponent.prototype.openApplication = /**
     * @param {?} menu
     * @return {?}
     */
    function (menu) {
        /** @type {?} */
        var url = menu.Url.split('?');
        /** @type {?} */
        var parameters = [];
        if (url.length > 1) {
            /** @type {?} */
            var dataAttributes = url[1].split('&');
            dataAttributes.forEach(function (dataAttribute) {
                /** @type {?} */
                var parameter = new TabParameter();
                parameter.PropertyName = dataAttribute.split('=')[0];
                parameter.Value = dataAttribute.split('=')[1];
                parameters.push(parameter);
            });
        }
        this.closeMenuEvent.emit();
        /** @type {?} */
        var breadcrumbMenu = menu;
        /** @type {?} */
        var breadCrumb = breadcrumbMenu.Description;
        breadcrumbMenu = breadcrumbMenu.Parent;
        while (breadcrumbMenu != null) {
            breadCrumb = breadcrumbMenu.Description + ' / ' + breadCrumb;
            breadcrumbMenu = breadcrumbMenu.Parent;
        }
        if (parameters.length > 0) {
            this.tabService.openTab(menu.Description, url[0], false, breadCrumb, parameters);
        }
        else {
            this.tabService.openTab(menu.Description, menu.Url, false, breadCrumb);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MenuComponent.prototype.menuMouseEnter = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        event.target.style.color = this.rteColorService.getMenuColor();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MenuComponent.prototype.menuMouseLeave = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        event.target.style.removeProperty('color');
    };
    MenuComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-menu',
                    template: "<div class=\"background-menu\"></div>\r\n<div class=\"mega-menu\">\r\n  <div class=\"menu-header\">\r\n    <div class=\"left-bar-header \">\r\n\r\n    </div>\r\n    <div class=\"right-bar-header\">\r\n      <span class=\"mat-title\">Escolha uma op\u00E7\u00E3o </span>\r\n      <rte-icon class=\"btn-close\" (click)=\"closeMenu()\">close</rte-icon>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"menu-content\">\r\n    <div class=\"left-bar-content\">\r\n      <div>\r\n        <ul>\r\n          <li *ngFor=\"let menu of menus\" (click)=\"openSubMenus(menu)\"\r\n              (mouseenter)=\"menuMouseEnter($event)\"\r\n              (mouseleave)=\"menuMouseLeave($event)\">\r\n            {{ menu.Description }}\r\n          </li>\r\n        </ul>\r\n      </div>\r\n      <div class=\"left-bar-favorite\">\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"column-content\">\r\n      <div *ngFor=\"let menu of subMenus; let i = index\">\r\n        <h3 class=\"mat-title\" *ngIf=\"i % 2 == 0\">\r\n          <mat-icon [style.color]=\"rteColorService.getMenuColor()\">{{ menu.Icon }}</mat-icon>\r\n          {{ menu.Description }}\r\n        </h3>\r\n        <ul *ngIf=\"i % 2 == 0\">\r\n          <li\r\n            *ngFor=\"let subMenu of menu.SubMenus\"\r\n            (mouseenter)=\"menuMouseEnter($event)\"\r\n            (mouseleave)=\"menuMouseLeave($event)\"\r\n            (click)=\"openApplication(subMenu)\"\r\n          >\r\n            {{ subMenu.Description }}\r\n          </li>\r\n        </ul>\r\n      </div>\r\n    </div>\r\n    <div class=\"column-content\">\r\n      <div *ngFor=\"let menu of subMenus; let i = index\">\r\n        <h3 class=\"mat-title\" *ngIf=\"i % 2 == 1\">\r\n          <mat-icon [style.color]=\"rteColorService.getMenuColor()\">{{ menu.Icon }}</mat-icon>\r\n          {{ menu.Description }}\r\n        </h3>\r\n        <ul *ngIf=\"i % 2 == 1\">\r\n          <li\r\n            *ngFor=\"let subMenu of menu.SubMenus\"\r\n            (mouseenter)=\"menuMouseEnter($event)\"\r\n            (mouseleave)=\"menuMouseLeave($event)\"\r\n            (click)=\"openApplication(subMenu)\"\r\n          >\r\n            {{ subMenu.Description }}\r\n          </li>\r\n        </ul>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                    styles: [".mega-menu{display:flex;flex-direction:column;justify-content:space-between;max-width:1200px;margin-left:auto;margin-right:auto;padding-left:30px;padding-right:30px}.menu-header{display:flex;width:100%;border-bottom:1px solid #e0e0e0}.left-bar-content,.left-bar-header{flex-basis:20%;padding:15px 0;background:#eff2f6}.right-bar-header{justify-content:space-between;display:flex;flex-basis:80%;padding-top:30px;background-color:#fff;align-items:center}.right-bar-header span{padding-left:30px;margin-bottom:5px}.menu-content{background-color:#fff;display:flex;height:calc(100vh - 126px);width:100%;flex-wrap:wrap}.menu-content div ul{list-style:none;font-family:Roboto;font-style:normal;font-weight:400;font-size:16px;line-height:28px;margin:0 0 15px;padding-top:10px;padding-left:30px}.menu-content div ul li:hover{color:#0b56a3;transition:.3s;display:inline-block;cursor:pointer}.menu-content div ul li{transition:.3s}.left-bar-favorite h3{padding-top:20px;padding-left:0}.menu-content div h3{display:flex;align-items:center;margin-bottom:0;margin-top:0;padding-left:30px}.menu-content div h3 .mat-icon{margin-right:5px;color:#1976d2}h3{padding-top:15px}.menu-content div:not(:first-child){flex-direction:column;flex-basis:37.5%}.left-bar-content div,.left-bar-content div ul{padding:0}.left-bar-favorite{border-top:1px solid #e0e0e0}.background-menu{z-index:-1;position:fixed;top:0;bottom:0;left:0;width:50%;background:#eff2f6}.column-content{background:#fff}.btn-close{cursor:pointer}"]
                }] }
    ];
    /** @nocollapse */
    MenuComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [RTE_MENU_SERVICE_DATA,] }] },
        { type: TabService },
        { type: undefined, decorators: [{ type: Inject, args: [RTE_APP_SERVICE_DATA,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [RTE_COLOR_SERVICE_DATA,] }] }
    ]; };
    MenuComponent.propDecorators = {
        closeMenuEvent: [{ type: Output }]
    };
    return MenuComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NavbarComponent = /** @class */ (function () {
    function NavbarComponent(breakpointObserver, appService, cookieService, sanitizer, menuService, rteColorService, tabService, currentRoute) {
        var _this = this;
        this.breakpointObserver = breakpointObserver;
        this.appService = appService;
        this.cookieService = cookieService;
        this.sanitizer = sanitizer;
        this.menuService = menuService;
        this.rteColorService = rteColorService;
        this.tabService = tabService;
        this.currentRoute = currentRoute;
        this.isHandset$ = this.breakpointObserver
            .observe(Breakpoints.Handset)
            .pipe(map(function (result) { return result.matches; }));
        this.title = 'Menus';
        this.showContent = false;
        this.System = new System();
        this.isMenuOpen = false;
        this.currentRoute.queryParams.subscribe(function (params) {
            /** @type {?} */
            var token = params.token;
            if (token == null) {
                _this.showContent = true;
            }
        });
        this.openedFromClosedSidebar = false;
    }
    /**
     * @param {?} ptitle
     * @param {?} plink
     * @return {?}
     */
    NavbarComponent.prototype.callTabComponent = /**
     * @param {?} ptitle
     * @param {?} plink
     * @return {?}
     */
    function (ptitle, plink) {
        this.tabService.openTab(ptitle, plink, false);
    };
    /**
     * @return {?}
     */
    NavbarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.userName = this.appService.currentUser.name.substring(0, 20);
        this.firstCharacterUserName = this.userName.substring(0, 1);
        this.menuService.getSystem().subscribe(function (s) {
            if (s != null) {
                _this.System = s;
            }
            else {
                _this.System = new System();
                _this.System.Id = -1;
                _this.System.Description = 'Sistema não encontrado.';
            }
            _this.appService.getAllSystems().subscribe(function (s) {
                _this.systems = s;
                _this.systems.forEach(function (system) {
                    if (system.Id === _this.System.Id) {
                        system.MenuIcon = 'radio_button_checked';
                    }
                    else {
                        system.MenuIcon = 'radio_button_unchecked';
                    }
                });
            });
        });
    };
    /**
     * @return {?}
     */
    NavbarComponent.prototype.logout = /**
     * @return {?}
     */
    function () {
        this.appService.logout();
    };
    /**
     * @return {?}
     */
    NavbarComponent.prototype.getbackgroundColor = /**
     * @return {?}
     */
    function () {
        if (this.appService.currentCompany) {
            return this.appService.currentCompany.CompanyBackColor;
        }
        else {
            return 'rgb(46,74,143)';
        }
    };
    /**
     * @param {?} selected
     * @return {?}
     */
    NavbarComponent.prototype.getForeColor = /**
     * @param {?} selected
     * @return {?}
     */
    function (selected) {
        if (this.appService.currentCompany) {
            if (selected) {
                return this.appService.currentCompany.SelectedForeColor;
            }
            return this.appService.currentCompany.CompanyForeColor;
        }
        else {
            if (selected) {
                return '#4d4a47';
            }
            return 'white';
        }
    };
    /**
     * @return {?}
     */
    NavbarComponent.prototype.getIconForeColor = /**
     * @return {?}
     */
    function () {
        if (this.appService.currentCompany) {
            return this.appService.currentCompany.IconForeColor;
        }
        else {
            return 'white';
        }
    };
    /**
     * @param {?} selected
     * @return {?}
     */
    NavbarComponent.prototype.getMenuBackColor = /**
     * @param {?} selected
     * @return {?}
     */
    function (selected) {
        if (this.appService.currentCompany) {
            if (selected) {
                return this.appService.currentCompany.SelectedBackColor;
            }
            return this.appService.currentCompany.CompanyBackColor;
        }
        else {
            if (selected) {
                return '#fff';
            }
            return 'rgb(46,74,143)';
        }
    };
    /**
     * @return {?}
     */
    NavbarComponent.prototype.getLogo = /**
     * @return {?}
     */
    function () {
        if (this.appService.currentCompany && this.appService.currentCompany.LogoWeb) {
            return 'data:image/jpeg;base64,' + this.appService.currentCompany.LogoWeb;
        }
        return '/assets/logo_rte.svg';
    };
    /**
     * @param {?} e
     * @return {?}
     */
    NavbarComponent.prototype.onSelectedApplication = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.tabService.openTab(e.Description, e.Id, false, e.Breadcrumb);
    };
    /**
     * @return {?}
     */
    NavbarComponent.prototype.openMenu = /**
     * @return {?}
     */
    function () {
        if (!this.isMenuOpen) {
            this.isMenuOpen = true;
        }
        else {
            this.isMenuOpen = false;
        }
    };
    /**
     * @return {?}
     */
    NavbarComponent.prototype.closeMenu = /**
     * @return {?}
     */
    function () {
        this.isMenuOpen = false;
    };
    NavbarComponent.decorators = [
        { type: Component, args: [{
                    // tslint:disable-next-line: component-selector
                    selector: 'rte-navbar',
                    template: "<mat-toolbar [style.border-color]=\"rteColorService.getLineMenuColor()\" [style.background]=\"rteColorService.getMenuColor()\">\r\n  <div class=\"flex-container-toolbar\">\r\n    <div>\r\n      <button rtenavbutton class=\"btn-apps\" [matMenuTriggerFor]=\"system\">\r\n        <mat-icon>apps</mat-icon>\r\n      </button>\r\n      <mat-menu #system=\"matMenu\" [class]=\"'menu-system-container'\">\r\n        <div class=\"arrow\"></div>\r\n        <div [class]=\"'menu-system-container-body'\">\r\n          <div class=\"menu-system-title mat-title\"> Sistemas </div>\r\n          <mat-divider></mat-divider>\r\n          <div class=\"content-scroll\">\r\n            <div *ngFor=\"let system of systems\">\r\n              <div class=\"menu-system-item\">\r\n                <a mat-menu-item href=\"{{system.Url}}\" title=\"{{system.Description}}\">\r\n                  <mat-icon>{{system.MenuIcon}}</mat-icon>\r\n                  {{system.Description}}\r\n                </a>\r\n                <mat-divider></mat-divider>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </mat-menu>\r\n    </div>\r\n    <div class=\"menu\">\r\n      <img [src]=\"getLogo()\" id=\"login-logo\" />\r\n      <button rtenavbutton (click)=\"openMenu()\">Menu</button>\r\n    </div>\r\n    <div class=\"auto-complete\">\r\n      <!-- <rte-auto-complete class=\"rte-autocomplete\" icon=\"fa-search fa-3x\" placeholder=\"O que voc\u00EA est\u00E1 procurando?\"\r\n        (onSelectedOption)=\"onSelectedApplication($event)\" [options]=\"appService.applicationsToSearch\" ngDefaultControl>\r\n      </rte-auto-complete> -->\r\n    </div>\r\n    <div class=\"profile\">\r\n      <rte-nc-notification>\r\n        <button rtenavbutton class=\"no-notify\">\r\n            <mat-icon class=\"btn-notifications\">notifications</mat-icon>\r\n        </button>\r\n        <button rtenavbutton class=\"notify-in-progress\">\r\n          <div class=\"spinner-notification\">\r\n            <mat-spinner class=\"index-spinner\" mode=\"indeterminate\" strokeWidth=\"4\" [diameter]=\"30\" [value]=\"100\"></mat-spinner>\r\n            <mat-icon class=\"load-icon lens\">lens</mat-icon>\r\n          </div>\r\n        </button>\r\n        <button rtenavbutton class=\"notify-finish\">\r\n          <div class=\"spinner-notification\">\r\n            <mat-spinner class=\"index-spinner\" mode=\"determinate\" strokeWidth=\"4\" [diameter]=\"30\" [value]=\"100\"></mat-spinner>\r\n            <mat-icon class=\"load-icon lens\">lens</mat-icon>\r\n          </div>\r\n        </button>\r\n      </rte-nc-notification>\r\n\r\n      <button rtenavbutton class=\"btn-user\" [matMenuTriggerFor]=\"profile\">\r\n        <mat-icon>account_circle</mat-icon>\r\n      </button>\r\n      <mat-menu #profile=\"matMenu\" yPosition=\"below\" xPosition=\"before\" [class]=\"'user-menu-container'\">\r\n        <div class=\"arrow\"></div>\r\n        <div [class]=\"'user-menu-container-body'\">\r\n          <div class=\"user-menu-item\">\r\n            <div class=\"picture\">\r\n              <img src=\"/assets/user_default.png\" />\r\n            </div>\r\n            <div class=\"user-menu-title mat-title\"> {{ userName }} </div>\r\n\r\n          </div>\r\n\r\n          <mat-divider></mat-divider>\r\n          <div class=\"content-scroll\">\r\n            <button mat-menu-item (click)=\"logout()\" title=\"Logout\">Logout</button>\r\n          </div>\r\n        </div>\r\n      </mat-menu>\r\n    </div>\r\n  </div>\r\n</mat-toolbar>\r\n\r\n<rte-menu [hidden]=\"isMenuOpen == false\" (closeMenuEvent)=\"closeMenu()\"></rte-menu>\r\n<rte-tab [hidden]=\"isMenuOpen\"></rte-tab>",
                    providers: [MenuComponent],
                    styles: [".mat-toolbar{height:50px;left:0;top:0;border-top:2px solid;padding:0}.mat-spinner circle,.spinner-notification ::ng-deep .mat-progress-spinner circle{stroke:#00bcd4!important}.lens{margin-top:3px;font-size:25px!important}.index-spinner{z-index:1}.notification{margin-top:8px;font-size:24px!important}.load-icon{cursor:pointer;max-width:100%;position:absolute;max-height:100%;top:0;height:100%;width:100%;-webkit-clip-path:circle(45% at 50% 49%);clip-path:circle(50% at 51% 40%);left:0;z-index:0}.spinner-notification{display:inline-block;position:relative}.menu{display:flex;max-width:300px}.menu button{padding-left:20px!important;padding-right:20px!important}.auto-complete{display:flex;flex-grow:1;justify-content:center}.rte-autocomplete{width:auto;min-width:400px;flex-grow:1;margin-top:2px}.btn-user .mat-icons{background:#0670e0}.profile{display:flex;margin-left:5px}.profile .mat-icons{background:#fff}#login-logo{max-width:200px;max-height:40px;margin:0 10px;padding:0;align-self:center}.flex-container-toolbar{display:flex;justify-content:space-between;align-items:center;flex-direction:row;width:100%;text-decoration:none;color:#fff;margin-left:0}.flex-container-toolbar a{text-decoration:none;color:#fff}.mat-menu-item{padding:0 10px}.mat-button{font-family:Roboto!important;font-style:normal!important;font-weight:400!important;font-size:16px!important;line-height:48px!important;padding-left:10px!important;padding-right:10px!important;min-width:64px!important}.mat-button:hover{background:#1976d2;border-radius:0!important}"]
                }] }
    ];
    /** @nocollapse */
    NavbarComponent.ctorParameters = function () { return [
        { type: BreakpointObserver },
        { type: undefined, decorators: [{ type: Inject, args: [RTE_APP_SERVICE_DATA,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [RTE_COOKIE_SERVICE_DATA,] }] },
        { type: DomSanitizer },
        { type: undefined, decorators: [{ type: Inject, args: [RTE_MENU_SERVICE_DATA,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [RTE_COLOR_SERVICE_DATA,] }] },
        { type: TabService },
        { type: ActivatedRoute }
    ]; };
    NavbarComponent.propDecorators = {
        sidenav: [{ type: ViewChild, args: ['drawer',] }]
    };
    return NavbarComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteMenuModule = /** @class */ (function () {
    function RteMenuModule() {
    }
    RteMenuModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        MatProgressSpinnerModule,
                        MatCardModule,
                        MatGridListModule,
                        MatTableModule,
                        RouterModule,
                        MatSidenavModule,
                        MatTreeModule,
                        MatMenuModule,
                        OverlayModule,
                        MatRippleModule,
                        MatCheckboxModule,
                        MatSelectModule,
                        MatFormFieldModule,
                        MatOptionModule,
                        MatListModule,
                        MatButtonModule,
                        MatIconModule,
                        MatAutocompleteModule,
                        MatExpansionModule,
                        MatTooltipModule,
                        RteMaterialModule,
                        RteTabModule,
                        FlexLayoutModule,
                        MatToolbarModule,
                        RteAutoCompleteModule,
                        RteNotificationCenterModule
                    ],
                    declarations: [MenuComponent, NavbarComponent],
                    exports: [MenuComponent, NavbarComponent]
                },] }
    ];
    return RteMenuModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Smtp = /** @class */ (function () {
    function Smtp() {
        this.SSL = false;
        this.Authentication = false;
    }
    return Smtp;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SmtpService = /** @class */ (function () {
    function SmtpService(http, environment) {
        this.http = http;
        this.environment = environment;
    }
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    SmtpService.prototype.clear = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        objectCurrent.Id = null;
        objectCurrent.Description = '';
        objectCurrent.Port = null;
        objectCurrent.Server = '';
        objectCurrent.Authentication = false;
        objectCurrent.SSL = false;
        objectCurrent.User = '';
        objectCurrent.Password = '';
        objectCurrent.Email = '';
        objectCurrent.Category = '';
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    SmtpService.prototype.save = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        console.log(objectCurrent);
        if (objectCurrent.Id) {
            return this.http.put(this.environment.apiCore + 'smtp', objectCurrent);
        }
        else {
            return this.http.post(this.environment.apiCore + 'smtp', objectCurrent);
        }
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    SmtpService.prototype.delete = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        return this.http.delete(this.environment.apiCore +
            'smtp/' +
            objectCurrent.Id);
    };
    /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    SmtpService.prototype.get = /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    function (objectCurrent, page, pageSize) {
        page++;
        /** @type {?} */
        var params = new HttpParams()
            .set('page', page.toString())
            .set('amountByPage', pageSize.toString());
        if (objectCurrent) {
            params = this.appendHttpParams('Description', objectCurrent.Description, params);
            params = this.appendHttpParams('Server', objectCurrent.Server, params);
            params = this.appendHttpParams('Port', objectCurrent.Port, params);
            params = this.appendHttpParams('User', objectCurrent.User, params);
            // params = this.appendHttpParams('SSL', objectCurrent.SSL.toString(), params);
            // params = this.appendHttpParams('Authentication', objectCurrent.Authentication.toString(), params);
            params = this.appendHttpParams('Email', objectCurrent.Email, params);
            params = this.appendHttpParams('Category', objectCurrent.Category, params);
        }
        return this.http.get(this.environment.apiCore + 'smtp/getbyfilters', { params: params });
    };
    /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    SmtpService.prototype.appendHttpParams = /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    function (name, value, params) {
        return params.append(name, !value ? '' : value);
    };
    /**
     * @return {?}
     */
    SmtpService.prototype.getSmtpCategories = /**
     * @return {?}
     */
    function () {
        return this.http.get(this.environment.apiCore + 'smtp/getcategories');
    };
    SmtpService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    SmtpService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['environment',] }] }
    ]; };
    /** @nocollapse */ SmtpService.ngInjectableDef = defineInjectable({ factory: function SmtpService_Factory() { return new SmtpService(inject(HttpClient), inject("environment")); }, token: SmtpService, providedIn: "root" });
    return SmtpService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SmtpFormComponent = /** @class */ (function () {
    function SmtpFormComponent(rteAlertService, apiService) {
        this.rteAlertService = rteAlertService;
        this.apiService = apiService;
    }
    /**
     * @return {?}
     */
    SmtpFormComponent.prototype.getDescriptionMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.Description)
            ? 'A descrição deve ser informada.' : '';
    };
    /**
     * @return {?}
     */
    SmtpFormComponent.prototype.getServerMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.Server) ? 'O Servidor deve ser informado.' : '';
    };
    /**
     * @return {?}
     */
    SmtpFormComponent.prototype.getPortMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.Port) ? 'A Porta deve ser informado.' : '';
    };
    /**
     * @return {?}
     */
    SmtpFormComponent.prototype.getUserMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.User) ? 'Usuário deve ser informado.' : '';
    };
    /**
     * @return {?}
     */
    SmtpFormComponent.prototype.getPasswordMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.Password) ? 'A Senha deve ser informada.' : '';
    };
    /**
     * @return {?}
     */
    SmtpFormComponent.prototype.getEmailMessage = /**
     * @return {?}
     */
    function () {
        if (!this.showErrorMessage()) {
            return;
        }
        if (!this.toolbarObject.current.Email) {
            return 'O Email deve ser informado.';
        }
        if (!this.isEmailValid(this.toolbarObject.current.Email)) {
            return 'Email inválido';
        }
        return '';
    };
    /**
     * @return {?}
     */
    SmtpFormComponent.prototype.getCategoryMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.Category) ? 'A Categoria deve ser informada.' : '';
    };
    /**
     * @return {?}
     */
    SmtpFormComponent.prototype.getValidation = /**
     * @return {?}
     */
    function () {
        return (this.getDescriptionMessage() ||
            this.getServerMessage() ||
            this.getPortMessage() ||
            this.getUserMessage() ||
            this.getPasswordMessage() ||
            this.getEmailMessage() ||
            this.getCategoryMessage());
    };
    /**
     * @return {?}
     */
    SmtpFormComponent.prototype.showErrorMessage = /**
     * @return {?}
     */
    function () {
        return this.toolbarObject.currentStatus === RteToolbarStatusEnum.Creating
            || this.toolbarObject.currentStatus === RteToolbarStatusEnum.Editing;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    SmtpFormComponent.prototype.isEmailValid = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var regx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regx.test(value);
    };
    /**
     * @param {?} afterSave
     * @return {?}
     */
    SmtpFormComponent.prototype.customizeAfterSave = /**
     * @param {?} afterSave
     * @return {?}
     */
    function (afterSave) {
        if (afterSave.success === true) {
            this.rteAlertService.success('SMTP salvo com sucesso', 'Sucesso');
        }
    };
    /**
     * @param {?} option
     * @return {?}
     */
    SmtpFormComponent.prototype.customizeAfterDelete = /**
     * @param {?} option
     * @return {?}
     */
    function (option) {
        if (option === true) {
            this.rteAlertService.success('SMTP excluído com sucesso', 'Sucesso');
        }
    };
    /**
     * @return {?}
     */
    SmtpFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.apiService.getSmtpCategories().subscribe(function (r) {
            _this.categories = r;
        });
    };
    SmtpFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-smtp-form',
                    template: "<div class=\"wrapper\">\r\n  <rte-card>\r\n    <mat-card-content>\r\n      <form #formFilterRules=\"ngForm\" autocomplete=\"off\">\r\n        <div class=\"row-form\">\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"Descri\u00E7\u00E3o\"\r\n                name=\"Descri\u00E7\u00E3o\" \r\n                [(ngModel)]=\"toolbarObject.current.Description\" \r\n                maxlength=\"3000\"\r\n                [readonly]=\"toolbarObject.readonlyBrowserMode\"\r\n                required\r\n              >\r\n                <mat-error>{{getDescriptionMessage()}}</mat-error>\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n\r\n        <div class='row-form'>\r\n            <div class='column-form'>\r\n              <rte-checkbox \r\n                placeholder=\"SSL\" \r\n                [(ngModel)]=\"toolbarObject.current.SSL\" \r\n                name=\"Id\">\r\n                SSL\r\n              </rte-checkbox>\r\n            </div>\r\n            <div class=\"column-form\">\r\n                <rte-checkbox \r\n                  placeholder=\"Autentica\u00E7\u00E3o\"\r\n                  [(ngModel)]=\"toolbarObject.current.Authentication\" \r\n                  name=\"Id\">\r\n                  Autentica\u00E7\u00E3o\r\n                </rte-checkbox>\r\n            </div>\r\n          </div>\r\n\r\n\r\n        <div class='row-form'>\r\n          <div class='column-form'>\r\n              <rte-form-field class=\"example-full-width\">\r\n                <input rteInput placeholder=\"Servidor\" name=\"Servidor\"\r\n                  [(ngModel)]=\"toolbarObject.current.Server\" \r\n                  [readonly]=\"toolbarObject.readonlyBrowserMode\"\r\n                  required>\r\n                <mat-error>{{getServerMessage()}}</mat-error>\r\n              </rte-form-field>\r\n          </div>\r\n          \r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input rteInput placeholder=\"Porta\" \r\n                name=\"Porta\"\r\n                [(ngModel)]=\"toolbarObject.current.Port\" \r\n                [readonly]=\"toolbarObject.readonlyBrowserMode\"\r\n                required\r\n                type=\"number\">\r\n              <mat-error>{{getPortMessage()}}</mat-error>\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row-form\">\r\n          <div class='column-form'>\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input rteInput placeholder=\"Usu\u00E1rio\" name=\"Usu\u00E1rio\"\r\n                [(ngModel)]=\"toolbarObject.current.User\" \r\n                [readonly]=\"toolbarObject.readonlyBrowserMode\"\r\n                required>\r\n              <mat-error>{{getUserMessage()}}</mat-error>\r\n            </rte-form-field>\r\n          </div>\r\n\r\n          <div class='column-form'>\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input rteInput placeholder=\"Senha\" name=\"Senha\"\r\n                [(ngModel)]=\"toolbarObject.current.Password\" \r\n                [readonly]=\"toolbarObject.readonlyBrowserMode\"\r\n                required>\r\n              <mat-error>{{getPasswordMessage()}}</mat-error>\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n\r\n\r\n        <div class=\"row-form\">\r\n            <div class='column-form'>\r\n              <rte-form-field class=\"example-full-width\">\r\n                <input rteInput placeholder=\"Email\" name=\"Email\"\r\n                  [(ngModel)]=\"toolbarObject.current.Email\" \r\n                  [readonly]=\"toolbarObject.readonlyBrowserMode\"\r\n                  required\r\n                  type=\"email\"\r\n                  email>\r\n                <mat-error>{{getEmailMessage()}}</mat-error>\r\n              </rte-form-field>\r\n            </div>\r\n  \r\n            <div class='column-form'>\r\n              <rte-form-field>\r\n                <mat-label>Categoria</mat-label>\r\n                <rte-select required [(ngModel)]=\"toolbarObject.current.Category\" name=\"Category\">\r\n                  <rte-option *ngFor=\"let category of categories\" [value]=\"category.Id\">\r\n                    {{category.Description}}\r\n                  </rte-option>\r\n                </rte-select>\r\n                <mat-error>{{getCategoryMessage()}}</mat-error>\r\n              </rte-form-field>\r\n            </div>\r\n          </div>\r\n\r\n      </form>\r\n    </mat-card-content>\r\n  </rte-card>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    SmtpFormComponent.ctorParameters = function () { return [
        { type: RTEAlertService },
        { type: SmtpService }
    ]; };
    SmtpFormComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return SmtpFormComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SmtpComponent = /** @class */ (function () {
    function SmtpComponent(service, rteAlertService) {
        this.service = service;
        this.rteAlertService = rteAlertService;
        this.toolbarObject = new RteToolbarViewModel();
        this.toolbarObject = new RteToolbarViewModel();
    }
    /**
     * @return {?}
     */
    SmtpComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.toolbarObject.current = new Smtp();
        this.toolbarObject.searchObject = new Smtp();
    };
    /**
     * @param {?} beforeSave
     * @return {?}
     */
    SmtpComponent.prototype.validateBeforeSave = /**
     * @param {?} beforeSave
     * @return {?}
     */
    function (beforeSave) {
        /** @type {?} */
        var validation = this.smtpForm.getValidation();
        if (validation) {
            beforeSave.cancelSave = true;
            this.rteAlertService.warning('Preencha todos os campos', validation);
        }
    };
    SmtpComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-smtp',
                    template: "<rte-toolbar [toolbarObject]=\"toolbarObject\" [service]=\"service\"\r\n\r\n[KeyDownElementArea]=\"form\"\r\n(validateBeforeSave)=\"validateBeforeSave($event)\"\r\n(customizeAfterSave)=\"smtpForm.customizeAfterSave($event)\"\r\n(customizeAfterDelete)=\"smtpForm.customizeAfterDelete($event)\">\r\n\r\n</rte-toolbar>\r\n<div class=\"wrapper\">   \r\n<rte-app-title></rte-app-title>\r\n</div>\r\n\r\n<div #form>\r\n<rte-app-smtp-search [toolbarObject]=\"toolbarObject\" *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n</rte-app-smtp-search>\r\n\r\n<rte-app-smtp-grid [toolbarObject]=\"toolbarObject\" *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n</rte-app-smtp-grid>\r\n\r\n<rte-app-smtp-form #smtpForm  [toolbarObject]=\"toolbarObject\" [hidden]=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n</rte-app-smtp-form>\r\n</div>\r\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    SmtpComponent.ctorParameters = function () { return [
        { type: SmtpService },
        { type: RTEAlertService }
    ]; };
    SmtpComponent.propDecorators = {
        smtpForm: [{ type: ViewChild, args: ['smtpForm', { read: SmtpFormComponent },] }]
    };
    return SmtpComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SmtpGridComponent = /** @class */ (function () {
    function SmtpGridComponent() {
        this.displayedColumns = ['Description', 'Server', 'Port', 'User', 'Email', 'SSL', 'Authentication'];
    }
    /**
     * @return {?}
     */
    SmtpGridComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    SmtpGridComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-smtp-grid',
                    template: "<div class=\"wrapper\">\r\n  <rte-card>\r\n    <mat-card-content>\r\n      <div class=\"mat-elevation-z4\">\r\n        <rte-table [dataSource]=\"toolbarObject.dataSource\"\r\n          *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n\r\n          <ng-container rteColumnDef=\"Description\">\r\n            <rte-header-cell *rteHeaderCellDef>Descri\u00E7\u00E3o</rte-header-cell>\r\n            <rte-cell *rteCellDef=\"let smtp\">{{smtp.Description}}</rte-cell>\r\n          </ng-container>\r\n\r\n          <ng-container rteColumnDef=\"Server\">\r\n            <rte-header-cell *rteHeaderCellDef>Servidor</rte-header-cell>\r\n            <rte-cell *rteCellDef=\"let smtp\">{{smtp.Server}}</rte-cell>\r\n          </ng-container>\r\n\r\n          <ng-container rteColumnDef=\"Port\">\r\n            <rte-header-cell *rteHeaderCellDef>Porta</rte-header-cell>\r\n            <rte-cell *rteCellDef=\"let smtp\">{{smtp.Port}}</rte-cell>\r\n          </ng-container>\r\n\r\n          <ng-container rteColumnDef=\"User\">\r\n            <rte-header-cell *rteHeaderCellDef>Usu\u00E1rio</rte-header-cell>\r\n            <rte-cell *rteCellDef=\"let smtp\">{{smtp.User}}</rte-cell>\r\n          </ng-container>\r\n\r\n          <ng-container rteColumnDef=\"Email\">\r\n            <rte-header-cell *rteHeaderCellDef>Email</rte-header-cell>\r\n            <rte-cell *rteCellDef=\"let smtp\">{{smtp.Email}}</rte-cell>\r\n          </ng-container>\r\n\r\n          <ng-container rteColumnDef=\"SSL\">\r\n            <rte-header-cell *rteHeaderCellDef>SSL</rte-header-cell>\r\n            <rte-cell *rteCellDef=\"let smtp\">\r\n              <rte-checkbox [checked]=\"smtp.SSL\" disabled></rte-checkbox>\r\n            </rte-cell>\r\n          </ng-container>\r\n\r\n          <ng-container rteColumnDef=\"Authentication\">\r\n            <rte-header-cell *rteHeaderCellDef>Authentication</rte-header-cell>\r\n            <rte-cell *rteCellDef=\"let smtp\">\r\n                <rte-checkbox [checked]=\"smtp.Authentication\" disabled></rte-checkbox>\r\n            </rte-cell>\r\n          </ng-container>\r\n\r\n          <rte-header-row *rteHeaderRowDef=\"displayedColumns\"></rte-header-row>\r\n          <rte-row *rteRowDef=\"let row; columns: displayedColumns;\" (click)=\"toolbarObject.setCurrent(row)\"\r\n            (dblclick)=\"toolbarObject.viewMode(row)\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"\r\n            [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted, selected: toolbarObject.selectionModel.isSelected(row)}\">\r\n          </rte-row>\r\n        </rte-table>\r\n      </div>\r\n    </mat-card-content>\r\n  </rte-card>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    SmtpGridComponent.ctorParameters = function () { return []; };
    SmtpGridComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return SmtpGridComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SmtpSearchComponent = /** @class */ (function () {
    function SmtpSearchComponent(apiService) {
        this.apiService = apiService;
        this.categories = [];
    }
    /**
     * @return {?}
     */
    SmtpSearchComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.apiService.getSmtpCategories().subscribe(function (r) {
            _this.categories = r;
        });
    };
    SmtpSearchComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-smtp-search',
                    template: "<div class=\"wrapper\">\r\n  <rte-card>\r\n    <mat-card-content>\r\n      <form #formFilterRules=\"ngForm\" autocomplete=\"off\">\r\n        <div class=\"row-form\">\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"Descri\u00E7\u00E3o\"\r\n                name=\"Descri\u00E7\u00E3o\" \r\n                [(ngModel)]=\"toolbarObject.searchObject.Description\" \r\n                maxlength=\"3000\"\r\n              >\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n\r\n        <div class='row-form'>\r\n          <div class='column-form'>\r\n              <rte-form-field class=\"example-full-width\">\r\n                <input rteInput placeholder=\"Servidor\" name=\"Servidor\"\r\n                  [(ngModel)]=\"toolbarObject.searchObject.Server\" \r\n                >\r\n              </rte-form-field>\r\n          </div>\r\n          \r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input rteInput placeholder=\"Porta\" \r\n                name=\"Porta\"\r\n                [(ngModel)]=\"toolbarObject.searchObject.Port\" \r\n                type=\"number\">\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row-form\">\r\n          <div class='column-form'>\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input rteInput placeholder=\"Usu\u00E1rio\" name=\"Usu\u00E1rio\"\r\n                [(ngModel)]=\"toolbarObject.searchObject.User\" \r\n              >\r\n            </rte-form-field>\r\n          </div>\r\n\r\n          <div class='column-form'>\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input rteInput placeholder=\"Senha\" name=\"Senha\"\r\n                [(ngModel)]=\"toolbarObject.searchObject.Password\" \r\n              >\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n\r\n\r\n        <div class=\"row-form\">\r\n            <div class='column-form'>\r\n              <rte-form-field class=\"example-full-width\">\r\n                <input rteInput placeholder=\"Email\" name=\"Email\"\r\n                  [(ngModel)]=\"toolbarObject.searchObject.Email\" \r\n                  type=\"email\"\r\n                  email>\r\n              </rte-form-field>\r\n            </div>\r\n  \r\n            <div class='column-form'>\r\n              <rte-form-field>\r\n                <mat-label>Categoria</mat-label>\r\n                <rte-select [(ngModel)]=\"toolbarObject.searchObject.Category\" name=\"Category\">\r\n                  <rte-option [value]=\"null\">\r\n                    SELECIONE\r\n                  </rte-option>\r\n\r\n                  <rte-option *ngFor=\"let category of categories\" [value]=\"category.Id\">\r\n                    {{category.Description}}\r\n                  </rte-option>\r\n                </rte-select>\r\n              </rte-form-field>\r\n            </div>\r\n          </div>\r\n      </form>\r\n    </mat-card-content>\r\n  </rte-card>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    SmtpSearchComponent.ctorParameters = function () { return [
        { type: SmtpService }
    ]; };
    SmtpSearchComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return SmtpSearchComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteSmtpModule = /** @class */ (function () {
    function RteSmtpModule() {
    }
    /**
     * @param {?} environment
     * @return {?}
     */
    RteSmtpModule.forRoot = /**
     * @param {?} environment
     * @return {?}
     */
    function (environment) {
        return {
            ngModule: RteSmtpModule,
            providers: [
                SmtpService,
                {
                    provide: 'environment',
                    useValue: environment
                }
            ]
        };
    };
    RteSmtpModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        RteToolbarModule,
                        RteAppTitleModule,
                        RteMaterialModule,
                        MatRippleModule,
                        MatCheckboxModule,
                        MatSelectModule,
                        MatOptionModule,
                        MatListModule,
                        MatTableModule,
                        MatIconModule,
                        MatAutocompleteModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatProgressSpinnerModule,
                        MatToolbarModule,
                        MatDialogModule,
                        MatCardModule,
                        CdkTableModule,
                        MatDividerModule,
                        FormsModule
                    ],
                    declarations: [SmtpComponent, SmtpFormComponent, SmtpGridComponent, SmtpSearchComponent]
                },] }
    ];
    return RteSmtpModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteCompanyGroupService = /** @class */ (function () {
    function RteCompanyGroupService(http, environment) {
        this.http = http;
        this.environment = environment;
    }
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    RteCompanyGroupService.prototype.clear = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        objectCurrent.Id = 0;
        objectCurrent.Name = '';
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    RteCompanyGroupService.prototype.save = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        if (!objectCurrent.Id)
            return this.http.post(this.environment.apiCore + 'webapi/companygroup', objectCurrent);
        else
            return this.http.put(this.environment.apiCore + 'webapi/companygroup', objectCurrent);
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    RteCompanyGroupService.prototype.delete = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        return this.http.delete(this.environment.apiCore + 'webapi/companygroup/' + objectCurrent.Id);
    };
    /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    RteCompanyGroupService.prototype.get = /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    function (objectCurrent, page, pageSize) {
        page++;
        /** @type {?} */
        var params = new HttpParams()
            .set('page', page.toString())
            .set('amountByPage', pageSize.toString());
        if (objectCurrent) {
            params = this.appendHttpParams('Id', objectCurrent.Id, params);
            params = this.appendHttpParams('Name', objectCurrent.Name, params);
        }
        return this.http.get(this.environment.apiCore + 'webapi/companygroup/getbyfilters', { params: params });
    };
    /**
     * @return {?}
     */
    RteCompanyGroupService.prototype.getAll = /**
     * @return {?}
     */
    function () {
        return this.http.get(this.environment.apiCore + 'webapi/companygroup/getall');
    };
    /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    RteCompanyGroupService.prototype.appendHttpParams = /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    function (name, value, params) {
        return params.append(name, !value ? '' : value);
    };
    RteCompanyGroupService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    RteCompanyGroupService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['environment',] }] }
    ]; };
    /** @nocollapse */ RteCompanyGroupService.ngInjectableDef = defineInjectable({ factory: function RteCompanyGroupService_Factory() { return new RteCompanyGroupService(inject(HttpClient), inject("environment")); }, token: RteCompanyGroupService, providedIn: "root" });
    return RteCompanyGroupService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CompanyGroup = /** @class */ (function () {
    function CompanyGroup() {
    }
    return CompanyGroup;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CompanyGroupFormComponent = /** @class */ (function () {
    function CompanyGroupFormComponent(rteAlertService) {
        this.rteAlertService = rteAlertService;
    }
    /**
     * @return {?}
     */
    CompanyGroupFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} afterSave
     * @return {?}
     */
    CompanyGroupFormComponent.prototype.customizeAfterSave = /**
     * @param {?} afterSave
     * @return {?}
     */
    function (afterSave) {
        if (afterSave.success === true) {
            this.rteAlertService.success('Grupo salvo com sucesso', 'Sucesso');
        }
    };
    /**
     * @param {?} option
     * @return {?}
     */
    CompanyGroupFormComponent.prototype.customizeAfterDelete = /**
     * @param {?} option
     * @return {?}
     */
    function (option) {
        if (option === true) {
            this.rteAlertService.success('Grupo excluído com sucesso', 'Sucesso');
        }
    };
    /**
     * @return {?}
     */
    CompanyGroupFormComponent.prototype.getNameMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.Name)
            ? 'O campo nome deve ser informado.' : '';
    };
    /**
     * @return {?}
     */
    CompanyGroupFormComponent.prototype.showErrorMessage = /**
     * @return {?}
     */
    function () {
        return this.toolbarObject.currentStatus === RteToolbarStatusEnum.Creating
            || this.toolbarObject.currentStatus === RteToolbarStatusEnum.Editing;
    };
    /**
     * @return {?}
     */
    CompanyGroupFormComponent.prototype.getValidation = /**
     * @return {?}
     */
    function () {
        return (this.getNameMessage());
    };
    CompanyGroupFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-company-group-form',
                    template: "<div class=\"wrapper\">\r\n  <rte-card>\r\n    <mat-card-content>\r\n      <form #formFilterRules=\"ngForm\" autocomplete=\"off\">\r\n        <div class=\"row-form\">\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"C\u00F3digo\"\r\n                name=\"Codigo\"\r\n                type=\"number\"\r\n                [(ngModel)]=\"toolbarObject.current.Id\"\r\n                readonly\r\n                [required]=\"toolbarObject.currentStatus === toolbarObject.possibleStatus.Editing\">\r\n            </rte-form-field>\r\n          </div>\r\n\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"Nome\"\r\n                name=\"Nome\"\r\n                type=\"text\"\r\n                [(ngModel)]=\"toolbarObject.current.Name\" \r\n                maxlength=\"255\"\r\n                [readonly]=\"toolbarObject.readonlyBrowserMode\"\r\n                required>\r\n                <mat-error>{{getNameMessage()}}</mat-error>\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </mat-card-content>\r\n  </rte-card>\r\n</div>\r\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    CompanyGroupFormComponent.ctorParameters = function () { return [
        { type: RTEAlertService }
    ]; };
    CompanyGroupFormComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return CompanyGroupFormComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CompanyGroupComponent = /** @class */ (function () {
    function CompanyGroupComponent(service, rteAlertService) {
        this.service = service;
        this.rteAlertService = rteAlertService;
        this.toolbarObject = new RteToolbarViewModel();
        this.toolbarObject = new RteToolbarViewModel();
    }
    /**
     * @return {?}
     */
    CompanyGroupComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.toolbarObject.current = new CompanyGroup();
        this.toolbarObject.searchObject = new CompanyGroup();
    };
    /**
     * @param {?} beforeSave
     * @return {?}
     */
    CompanyGroupComponent.prototype.validateBeforeSave = /**
     * @param {?} beforeSave
     * @return {?}
     */
    function (beforeSave) {
        /** @type {?} */
        var validation = this.companyGroupForm.getValidation();
        if (validation) {
            beforeSave.cancelSave = true;
            this.rteAlertService.warning('Preencha todos os campos', validation);
        }
    };
    CompanyGroupComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-company-group',
                    template: "<rte-toolbar [toolbarObject]=\"toolbarObject\" \r\n             [service]=\"service\"\r\n             [KeyDownElementArea]=\"form\"\r\n             (validateBeforeSave)=\"validateBeforeSave($event)\"\r\n             (customizeAfterSave)=\"companyGroupForm.customizeAfterSave($event)\"\r\n             (customizeAfterDelete)=\"companyGroupForm.customizeAfterDelete($event)\">\r\n\r\n</rte-toolbar>\r\n<div class=\"wrapper\">   \r\n  <rte-app-title></rte-app-title>\r\n</div>\r\n\r\n<div #form>\r\n  <rte-app-company-group-search [toolbarObject]=\"toolbarObject\" *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n  </rte-app-company-group-search>\r\n\r\n  <rte-app-company-group-grid [toolbarObject]=\"toolbarObject\" *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n  </rte-app-company-group-grid>\r\n\r\n  <rte-app-company-group-form #companyGroupForm [toolbarObject]=\"toolbarObject\" [hidden]=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n  </rte-app-company-group-form>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    CompanyGroupComponent.ctorParameters = function () { return [
        { type: RteCompanyGroupService },
        { type: RTEAlertService }
    ]; };
    CompanyGroupComponent.propDecorators = {
        companyGroupForm: [{ type: ViewChild, args: ['companyGroupForm', { read: CompanyGroupFormComponent },] }]
    };
    return CompanyGroupComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CompanyGroupSearchComponent = /** @class */ (function () {
    function CompanyGroupSearchComponent() {
    }
    /**
     * @return {?}
     */
    CompanyGroupSearchComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    CompanyGroupSearchComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-company-group-search',
                    template: "<div class=\"wrapper\">\r\n  <rte-card>\r\n    <mat-card-content>\r\n      <form #formFilterRules=\"ngForm\" autocomplete=\"off\">\r\n        <div class=\"row-form\">\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"C\u00F3digo\" \r\n                name=\"C\u00F3digo\"\r\n                [(ngModel)]=\"toolbarObject.searchObject.Id\" >\r\n            </rte-form-field>\r\n          </div>\r\n          \r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"Nome\" \r\n                name=\"Nome\"\r\n                [(ngModel)]=\"toolbarObject.searchObject.Name\" \r\n                maxlength=\"255\">\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </mat-card-content>\r\n  </rte-card>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    CompanyGroupSearchComponent.ctorParameters = function () { return []; };
    CompanyGroupSearchComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return CompanyGroupSearchComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CompanyGroupGridComponent = /** @class */ (function () {
    function CompanyGroupGridComponent() {
        this.displayedColumns = ['id', 'name'];
    }
    /**
     * @return {?}
     */
    CompanyGroupGridComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    CompanyGroupGridComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-company-group-grid',
                    template: "<div class=\"wrapper\">\r\n  <rte-card>\r\n      <mat-card-content>\r\n          <div class=\"mat-elevation-z4\">\r\n            <rte-table [dataSource]=\"toolbarObject.dataSource\"\r\n                        *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n              <ng-container rteColumnDef=\"id\">\r\n                <rte-header-cell *rteHeaderCellDef>C\u00F3digo</rte-header-cell>\r\n                <rte-cell *rteCellDef=\"let companyGroup\">{{companyGroup.Id}}</rte-cell>\r\n              </ng-container>\r\n\r\n              <ng-container rteColumnDef=\"name\">\r\n                <rte-header-cell *rteHeaderCellDef>Nome</rte-header-cell>\r\n                <rte-cell *rteCellDef=\"let companyGroup\">{{companyGroup.Name}}</rte-cell>\r\n              </ng-container>\r\n\r\n              <rte-header-row *rteHeaderRowDef=\"displayedColumns\"></rte-header-row>\r\n              <rte-row *rteRowDef=\"let row; columns: displayedColumns;\" (click)=\"toolbarObject.setCurrent(row)\"\r\n                      (dblclick)=\"toolbarObject.viewMode(row)\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"\r\n                      [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted, selected: toolbarObject.selectionModel.isSelected(row)}\">\r\n              </rte-row>\r\n            </rte-table>\r\n          </div>\r\n      </mat-card-content>\r\n  </rte-card>\r\n</div>\r\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    CompanyGroupGridComponent.ctorParameters = function () { return []; };
    CompanyGroupGridComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return CompanyGroupGridComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteCompanyGroupModule = /** @class */ (function () {
    function RteCompanyGroupModule() {
    }
    /**
     * @param {?} environment
     * @return {?}
     */
    RteCompanyGroupModule.forRoot = /**
     * @param {?} environment
     * @return {?}
     */
    function (environment) {
        return {
            ngModule: RteCompanyGroupModule,
            providers: [
                RteCompanyGroupService,
                {
                    provide: 'environment',
                    useValue: environment
                }
            ]
        };
    };
    RteCompanyGroupModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        RteToolbarModule,
                        RteAppTitleModule,
                        RteMaterialModule,
                        MatRippleModule,
                        MatCheckboxModule,
                        MatSelectModule,
                        MatOptionModule,
                        MatListModule,
                        MatTableModule,
                        MatIconModule,
                        MatAutocompleteModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatProgressSpinnerModule,
                        MatToolbarModule,
                        MatDialogModule,
                        MatCardModule,
                        CdkTableModule,
                        MatDividerModule,
                        FormsModule
                    ],
                    declarations: [CompanyGroupComponent, CompanyGroupFormComponent, CompanyGroupSearchComponent, CompanyGroupGridComponent],
                    exports: [CompanyGroupComponent]
                },] }
    ];
    return RteCompanyGroupModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Company$1 = /** @class */ (function () {
    function Company$$1() {
    }
    return Company$$1;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CompanyImageComponent = /** @class */ (function () {
    function CompanyImageComponent(domSanitizer, rteAlertService) {
        this.domSanitizer = domSanitizer;
        this.rteAlertService = rteAlertService;
    }
    /**
     * @return {?}
     */
    CompanyImageComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    CompanyImageComponent.prototype.customizeAfterEditMode = /**
     * @return {?}
     */
    function () {
        if (this.toolbarObject) {
            this.logo = this.toolbarObject.current.Logo;
            this.reportLogo = this.toolbarObject.current.ReportLogo;
            this.headerQuotationLogo = this.toolbarObject.current.HeaderQuotationLogo;
            this.footerQuotationLogo = this.toolbarObject.current.FooterQuotationLogo;
        }
    };
    /**
     * @return {?}
     */
    CompanyImageComponent.prototype.customizeAfterInsertMode = /**
     * @return {?}
     */
    function () {
        if (this.toolbarObject && this.toolbarObject.readonlyInsertMode)
            this.toolbarObject.current = new Company$1();
        this.logo = '';
        this.reportLogo = '';
        this.headerQuotationLogo = '';
        this.footerQuotationLogo = '';
    };
    /**
     * @param {?} files
     * @return {?}
     */
    CompanyImageComponent.prototype.getLogoImage = /**
     * @param {?} files
     * @return {?}
     */
    function (files) {
        var _this = this;
        if (!this.checkImage(files))
            return;
        /** @type {?} */
        var reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = function (_event) {
            _this.logo = _this.getFileResult(reader);
        };
    };
    /**
     * @param {?} files
     * @return {?}
     */
    CompanyImageComponent.prototype.getReportLogoImage = /**
     * @param {?} files
     * @return {?}
     */
    function (files) {
        var _this = this;
        if (!this.checkImage(files))
            return;
        /** @type {?} */
        var reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = function (_event) {
            _this.reportLogo = _this.getFileResult(reader);
        };
    };
    /**
     * @param {?} files
     * @return {?}
     */
    CompanyImageComponent.prototype.getHeaderLogoImage = /**
     * @param {?} files
     * @return {?}
     */
    function (files) {
        var _this = this;
        if (!this.checkImage(files))
            return;
        /** @type {?} */
        var reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = function (_event) {
            _this.headerQuotationLogo = _this.getFileResult(reader);
        };
    };
    /**
     * @param {?} files
     * @return {?}
     */
    CompanyImageComponent.prototype.getFooterLogoImage = /**
     * @param {?} files
     * @return {?}
     */
    function (files) {
        var _this = this;
        if (!this.checkImage(files))
            return;
        /** @type {?} */
        var reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = function (_event) {
            _this.footerQuotationLogo = _this.getFileResult(reader);
        };
    };
    /**
     * @param {?} reader
     * @return {?}
     */
    CompanyImageComponent.prototype.getFileResult = /**
     * @param {?} reader
     * @return {?}
     */
    function (reader) {
        return reader.result.toString().replace('data:image/jpeg;base64,', '');
    };
    /**
     * @param {?} files
     * @return {?}
     */
    CompanyImageComponent.prototype.checkImage = /**
     * @param {?} files
     * @return {?}
     */
    function (files) {
        if (files.length === 0) {
            return false;
        }
        /** @type {?} */
        var mimeType = files[0].type;
        if (mimeType.match(/image\/*/) == null) {
            this.rteAlertService.warning('Apenas imagens são aceitas', 'Selecione arquivos de imagem .png, .jpg, entre outros');
            return false;
        }
        return true;
    };
    /**
     * @return {?}
     */
    CompanyImageComponent.prototype.fillCurrentObjectWithImages = /**
     * @return {?}
     */
    function () {
        if (this.toolbarObject &&
            this.toolbarObject.current) {
            this.toolbarObject.current.Logo = this.logo;
            this.toolbarObject.current.ReportLogo = this.reportLogo;
            this.toolbarObject.current.HeaderQuotationLogo = this.headerQuotationLogo;
            this.toolbarObject.current.FooterQuotationLogo = this.footerQuotationLogo;
        }
    };
    /**
     * @return {?}
     */
    CompanyImageComponent.prototype.clearLogoImage = /**
     * @return {?}
     */
    function () {
        this.logo = '';
    };
    /**
     * @return {?}
     */
    CompanyImageComponent.prototype.clearReportLogoImage = /**
     * @return {?}
     */
    function () {
        this.reportLogo = '';
    };
    /**
     * @return {?}
     */
    CompanyImageComponent.prototype.clearHeaderQuotationLogoImage = /**
     * @return {?}
     */
    function () {
        this.headerQuotationLogo = '';
    };
    /**
     * @return {?}
     */
    CompanyImageComponent.prototype.clearFooterQuotationLogoImage = /**
     * @return {?}
     */
    function () {
        this.footerQuotationLogo = '';
    };
    CompanyImageComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-company-image',
                    template: "<div class=\"wrapper\">\r\n  <mat-expansion-panel>\r\n    <mat-expansion-panel-header style=\"background-color: #F5F5F5\">\r\n      <mat-panel-title>\r\n        Imagens\r\n      </mat-panel-title>\r\n    </mat-expansion-panel-header>\r\n    <div class=\"row-form image-div\">\r\n      <div class=\"column-image-form\">\r\n        <rte-card class=\"mat-elevation-z2 image-card\">\r\n          <mat-card-header class=\"image-header\">\r\n            <mat-card-title>Logomarca (Empresa)</mat-card-title>\r\n          </mat-card-header>\r\n          <mat-card-content align=\"center\" class=\"image-card-content\">\r\n            <input hidden #logoFile type=\"file\" accept=\"image/*\" name=\"Logo\" (change)=\"getLogoImage(logoFile.files)\">\r\n            <img [src]=\"logo ? domSanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + logo) : ''\" height=\"80\" width=\"80\"/>\r\n          </mat-card-content>\r\n          <mat-card-actions class=\"image-actions\" align=\"end\">\r\n            <button rtebutton-raised color=\"primary\" (click)=\"logoFile.click()\">Adicionar</button>\r\n            <button rtebutton-raised color=\"warn\" (click)=\"clearLogoImage()\">Remover</button>\r\n          </mat-card-actions>\r\n        </rte-card>\r\n      </div>\r\n\r\n      <div class=\"column-image-form\">\r\n        <rte-card class=\"mat-elevation-z2 image-card\">\r\n          <mat-card-header class=\"image-header\">\r\n            <mat-card-title>Logomarca (Relat\u00F3rio)</mat-card-title>\r\n          </mat-card-header>\r\n          <mat-card-content align=\"center\" class=\"image-card-content\">\r\n            <input hidden #reportFile type=\"file\" accept=\"image/*\" name=\"ReportLogo\" (change)=\"getReportLogoImage(reportFile.files)\">\r\n            <img [src]=\"reportLogo ? domSanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + reportLogo) : ''\" height=\"80\" width=\"80\" />\r\n          </mat-card-content>\r\n          <mat-card-actions align=\"end\" class=\"image-actions\">\r\n            <button rtebutton-raised color=\"primary\" (click)=\"reportFile.click()\">Adicionar</button>\r\n            <button rtebutton-raised color=\"warn\" (click)=\"clearReportLogoImage()\">Remover</button>\r\n          </mat-card-actions>\r\n        </rte-card>\r\n      </div>\r\n\r\n      <div class=\"column-image-form\">\r\n        <rte-card class=\"mat-elevation-z2 image-card\">\r\n          <mat-card-header class=\"image-header\">\r\n            <mat-card-title>Cabe\u00E7alho Cota\u00E7\u00E3o</mat-card-title>\r\n          </mat-card-header>\r\n          <mat-card-content align=\"center\" class=\"image-card-content\">\r\n            <input hidden #headerFile type=\"file\" accept=\"image/*\" name=\"ReportLogo\" (change)=\"getHeaderLogoImage(headerFile.files)\">\r\n            <img [src]=\"headerQuotationLogo ? domSanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + headerQuotationLogo) : ''\" height=\"80\" width=\"260\" />\r\n          </mat-card-content>\r\n          <mat-card-actions align=\"end\" class=\"image-actions\">\r\n            <button rtebutton-raised color=\"primary\" (click)=\"headerFile.click()\">Adicionar</button>\r\n            <button rtebutton-raised color=\"warn\" (click)=\"clearHeaderQuotationLogoImage()\">Remover</button>\r\n          </mat-card-actions>\r\n        </rte-card>\r\n      </div>\r\n\r\n      <div class=\"column-image-form\">\r\n        <rte-card class=\"mat-elevation-z2 image-card\">\r\n          <mat-card-header class=\"image-header\">\r\n            <mat-card-title>Rodap\u00E9 Cota\u00E7\u00E3o</mat-card-title>\r\n          </mat-card-header>\r\n          <mat-card-content align=\"center\" class=\"image-card-content\">\r\n            <input hidden #footerFile type=\"file\" accept=\"image/*\" name=\"ReportLogo\" (change)=\"getFooterLogoImage(footerFile.files)\">\r\n            <img [src]=\"footerQuotationLogo ? domSanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + footerQuotationLogo) : ''\" height=\"80\" width=\"275\"/>\r\n          </mat-card-content>\r\n          <mat-card-actions align=\"end\" class=\"image-actions\">\r\n            <button rtebutton-raised color=\"primary\" (click)=\"footerFile.click()\">Adicionar</button>\r\n            <button rtebutton-raised color=\"warn\" (click)=\"clearFooterQuotationLogoImage()\">Remover</button>\r\n          </mat-card-actions>\r\n        </rte-card>\r\n      </div>\r\n    </div>\r\n  </mat-expansion-panel>\r\n</div>",
                    styles: [".image-card-content{padding:10px!important;background-color:#f5f5f5}.image-card{padding-left:0!important;padding-right:0!important}.image-header{height:28px}.image-actions{padding:0 10px 8px 15px}mat-card-actions[align=end]{justify-content:flex-end}mat-card-actions{margin-bottom:0!important;align-self:flex-end}.column-image-form{margin:0 15px}.image-div{margin-top:50px!important}"]
                }] }
    ];
    /** @nocollapse */
    CompanyImageComponent.ctorParameters = function () { return [
        { type: DomSanitizer },
        { type: RTEAlertService }
    ]; };
    CompanyImageComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return CompanyImageComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CompanyColorComponent = /** @class */ (function () {
    function CompanyColorComponent() {
    }
    /**
     * @return {?}
     */
    CompanyColorComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    CompanyColorComponent.prototype.getValidation = /**
     * @return {?}
     */
    function () {
        return (this.getColorMessage() ||
            this.getFontColorMessage() ||
            this.getRequiredBackgroundMessage() ||
            this.getRequiredFontColorMessage() ||
            this.getInactiveBackgroundMessage() ||
            this.getInactiveFontMessage() ||
            this.getSelectedBackgroundMessage() ||
            this.getSelectedFontColorMessage() ||
            this.getInactiveFontColorMessage());
    };
    /**
     * @return {?}
     */
    CompanyColorComponent.prototype.showErrorMessage = /**
     * @return {?}
     */
    function () {
        return this.toolbarObject.currentStatus === RteToolbarStatusEnum.Creating
            || this.toolbarObject.currentStatus === RteToolbarStatusEnum.Editing;
    };
    /**
     * @return {?}
     */
    CompanyColorComponent.prototype.getColorMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.Color) ? 'A cor da empresa deve ser informada.' : '';
    };
    /**
     * @return {?}
     */
    CompanyColorComponent.prototype.getFontColorMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.FontColor) ? 'A cor da fonte da empresa deve ser informada.' : '';
    };
    /**
     * @return {?}
     */
    CompanyColorComponent.prototype.getRequiredBackgroundMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.RequiredBackground) ? 'A cor de campo requerido deve ser informada.' : '';
    };
    /**
     * @return {?}
     */
    CompanyColorComponent.prototype.getRequiredFontColorMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.RequiredFontColor) ? 'A cor da fonte de campo requerido deve ser informada.' : '';
    };
    /**
     * @return {?}
     */
    CompanyColorComponent.prototype.getInactiveBackgroundMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.InactiveBackground) ? 'A cor de registro inativo deve ser informada.' : '';
    };
    /**
     * @return {?}
     */
    CompanyColorComponent.prototype.getInactiveFontMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.InactiveFont) ? 'A cor da fonte de registro inativo deve ser informada.' : '';
    };
    /**
     * @return {?}
     */
    CompanyColorComponent.prototype.getSelectedBackgroundMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.SelectedBackground) ? 'A cor de registro selecionado deve ser informada.' : '';
    };
    /**
     * @return {?}
     */
    CompanyColorComponent.prototype.getSelectedFontColorMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.SelectedFontColor) ? 'A cor da fonte de registro selecionado deve ser informada.' : '';
    };
    /**
     * @return {?}
     */
    CompanyColorComponent.prototype.getInactiveFontColorMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.InactiveFontColor) ? 'A cor da fonte de registro inativo selecionado deve ser informada.' : '';
    };
    CompanyColorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-company-colors',
                    template: "<div class=\"wrapper\">\r\n  <mat-expansion-panel>\r\n    <mat-expansion-panel-header style=\"background-color: #F5F5F5\">\r\n      <mat-panel-title>\r\n        Cores\r\n      </mat-panel-title>\r\n    </mat-expansion-panel-header>\r\n    <form #formFilterRules=\"ngForm\" autocomplete=\"off\">\r\n      <div class=\"row-form image-div\">\r\n        <div class=\"column-form\">\r\n          <rte-form-field class=\"example-full-width\" [style.background]=\"toolbarObject.current.Color\">\r\n            <input \r\n              rteInput \r\n              placeholder=\"Empresa\"\r\n              required\r\n              [(colorPicker)]=\"toolbarObject.current.Color\" \r\n              [cpPosition]=\"'top'\"\r\n              name=\"Color\"\r\n              [(ngModel)]=\"toolbarObject.current.Color\">\r\n              <mat-error>{{getColorMessage()}}</mat-error>\r\n          </rte-form-field>\r\n        </div>\r\n\r\n        <div class=\"column-form\">\r\n          <rte-form-field class=\"example-full-width\" [style.background]=\"toolbarObject.current.FontColor\">\r\n            <input \r\n              rteInput \r\n              placeholder=\"Empresa (Fonte)\"\r\n              required\r\n              [(colorPicker)]=\"toolbarObject.current.FontColor\" \r\n              [cpPosition]=\"'top'\"\r\n              name=\"FontColor\"\r\n              [(ngModel)]=\"toolbarObject.current.FontColor\">\r\n              <mat-error>{{getFontColorMessage()}}</mat-error>\r\n          </rte-form-field>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row-form\">\r\n        <div class=\"column-form\">\r\n          <rte-form-field class=\"example-full-width\" [style.background]=\"toolbarObject.current.RequiredBackground\">\r\n            <input \r\n              rteInput \r\n              placeholder=\"Campo Requerido\"\r\n              required\r\n              [cpPosition]=\"'top'\"\r\n              [(colorPicker)]=\"toolbarObject.current.RequiredBackground\" \r\n              name=\"RequiredBackground\"\r\n              [(ngModel)]=\"toolbarObject.current.RequiredBackground\">\r\n              <mat-error>{{getRequiredBackgroundMessage()}}</mat-error>\r\n          </rte-form-field>\r\n        </div>\r\n\r\n        <div class=\"column-form\">\r\n          <rte-form-field class=\"example-full-width\" [style.background]=\"toolbarObject.current.RequiredFontColor\">\r\n            <input \r\n              rteInput \r\n              placeholder=\"Campo Requerido (Fonte)\"\r\n              required\r\n              [cpPosition]=\"'top'\"\r\n              [(colorPicker)]=\"toolbarObject.current.RequiredFontColor\" \r\n              name=\"RequiredFont\"\r\n              [(ngModel)]=\"toolbarObject.current.RequiredFontColor\">\r\n              <mat-error>{{getRequiredFontColorMessage()}}</mat-error>\r\n          </rte-form-field>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row-form\">\r\n        <div class=\"column-form\">\r\n          <rte-form-field class=\"example-full-width\" [style.background]=\"toolbarObject.current.InactiveBackground\">\r\n            <input \r\n              rteInput \r\n              required\r\n              [cpPosition]=\"'top'\"\r\n              placeholder=\"Registro Inativo (GRID)\"\r\n              [(colorPicker)]=\"toolbarObject.current.InactiveBackground\" \r\n              name=\"InactiveBackground\"\r\n              [(ngModel)]=\"toolbarObject.current.InactiveBackground\">\r\n              <mat-error>{{getInactiveBackgroundMessage()}}</mat-error>\r\n          </rte-form-field>\r\n        </div>\r\n\r\n        <div class=\"column-form\">\r\n          <rte-form-field class=\"example-full-width\" [style.background]=\"toolbarObject.current.InactiveFont\">\r\n            <input \r\n              rteInput \r\n              required\r\n              [cpPosition]=\"'top'\"\r\n              placeholder=\"Registro Inativo (Fonte - GRID)\"\r\n              [(colorPicker)]=\"toolbarObject.current.InactiveFont\"\r\n              name=\"InactiveFont\"\r\n              [(ngModel)]=\"toolbarObject.current.InactiveFont\">\r\n              <mat-error>{{getInactiveFontMessage()}}</mat-error>\r\n          </rte-form-field>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row-form\">\r\n        <div class=\"column-form\">\r\n          <rte-form-field class=\"example-full-width\" [style.background]=\"toolbarObject.current.SelectedBackground\">\r\n            <input \r\n              rteInput \r\n              [cpPosition]=\"'top'\"\r\n              required\r\n              placeholder=\"Registro Selecionado (GRID)\"\r\n              [(colorPicker)]=\"toolbarObject.current.SelectedBackground\" \r\n              name=\"SelectedBackground\"\r\n              [(ngModel)]=\"toolbarObject.current.SelectedBackground\">\r\n              <mat-error>{{getSelectedBackgroundMessage()}}</mat-error>\r\n          </rte-form-field>\r\n        </div>\r\n\r\n        <div class=\"column-form\">\r\n          <rte-form-field class=\"example-full-width\" [style.background]=\"toolbarObject.current.SelectedFontColor\">\r\n            <input \r\n              rteInput \r\n              [cpPosition]=\"'top'\"\r\n              required\r\n              placeholder=\"Registro Selecionado (Fonte - GRID)\"\r\n              [(colorPicker)]=\"toolbarObject.current.SelectedFontColor\" \r\n              name=\"SelectedFont\"\r\n              [(ngModel)]=\"toolbarObject.current.SelectedFontColor\">\r\n              <mat-error>{{getSelectedFontColorMessage()}}</mat-error>\r\n          </rte-form-field>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row-form half-width\">\r\n        <div class=\"column-form\">\r\n          <rte-form-field class=\"example-full-width\" [style.background]=\"toolbarObject.current.InactiveFontColor\">\r\n            <input \r\n              rteInput \r\n              required\r\n              [cpPosition]=\"'top'\"\r\n              placeholder=\"Cor da Fonte ao Selecionar um Registro Inativo\"\r\n              [(colorPicker)]=\"toolbarObject.current.InactiveFontColor\" \r\n              [style.background]=\"toolbarObject.current.InactiveFontColor\"\r\n              name=\"InactiveFontColor\"\r\n              [(ngModel)]=\"toolbarObject.current.InactiveFontColor\">\r\n              <mat-error>{{getInactiveFontColorMessage()}}</mat-error>\r\n          </rte-form-field>\r\n        </div>\r\n      </div>\r\n\r\n    </form>\r\n  </mat-expansion-panel>\r\n</div>",
                    styles: [".image-card-content{padding:10px!important;background-color:#f5f5f5}.image-card{padding-left:0!important;padding-right:0!important}.image-header{height:28px}.image-actions{padding:0 10px 8px 15px}mat-card-actions[align=end]{justify-content:flex-end}mat-card-actions{margin-bottom:0!important;align-self:flex-end}.image-div{margin-top:50px!important}.half-width{width:50%!important}"]
                }] }
    ];
    /** @nocollapse */
    CompanyColorComponent.ctorParameters = function () { return []; };
    CompanyColorComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return CompanyColorComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CompanyFormComponent = /** @class */ (function () {
    function CompanyFormComponent(rteAlertService, companyGroupService) {
        this.rteAlertService = rteAlertService;
        this.companyGroupService = companyGroupService;
    }
    /**
     * @return {?}
     */
    CompanyFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.companyGroupService.getAll()
            .subscribe(function (c) {
            console.log(c);
            _this.companyGroups = c;
        });
    };
    /**
     * @param {?} afterSave
     * @return {?}
     */
    CompanyFormComponent.prototype.customizeAfterSave = /**
     * @param {?} afterSave
     * @return {?}
     */
    function (afterSave) {
        if (afterSave.success === true) {
            this.rteAlertService.success('Empresa salva com sucesso', 'Sucesso');
        }
    };
    /**
     * @param {?} option
     * @return {?}
     */
    CompanyFormComponent.prototype.customizeAfterDelete = /**
     * @param {?} option
     * @return {?}
     */
    function (option) {
        if (option === true) {
            this.rteAlertService.success('Empresa excluída com sucesso', 'Sucesso');
        }
    };
    /**
     * @return {?}
     */
    CompanyFormComponent.prototype.getExternalCodeMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.ExternalCode) ? 'O código da empresa deve ser informado.' : '';
    };
    /**
     * @return {?}
     */
    CompanyFormComponent.prototype.getDescriptionMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.Description) ? 'A descrição deve ser informada.' : '';
    };
    /**
     * @return {?}
     */
    CompanyFormComponent.prototype.getAcronymMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.Acronym) ? 'A sigla deve ser informada.' : '';
    };
    /**
     * @return {?}
     */
    CompanyFormComponent.prototype.getRntrcMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.Rntrc) ? 'O RNTRC deve ser informado.' : '';
    };
    /**
     * @return {?}
     */
    CompanyFormComponent.prototype.getValidation = /**
     * @return {?}
     */
    function () {
        return (this.getExternalCodeMessage() ||
            this.getDescriptionMessage() ||
            this.getAcronymMessage() ||
            this.getRntrcMessage());
    };
    /**
     * @return {?}
     */
    CompanyFormComponent.prototype.showErrorMessage = /**
     * @return {?}
     */
    function () {
        return this.toolbarObject.currentStatus === RteToolbarStatusEnum.Creating
            || this.toolbarObject.currentStatus === RteToolbarStatusEnum.Editing;
    };
    CompanyFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-company-form',
                    template: "<div class=\"wrapper\">\r\n  <rte-card>\r\n    <mat-card-content>\r\n      <form #formFilterRules=\"ngForm\" autocomplete=\"off\">\r\n        \r\n        <div class=\"row-form\">\r\n          <div class=\"column-form\" [hidden]=\"toolbarObject.currentStatus === toolbarObject.possibleStatus.Creating\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"C\u00F3digo\" \r\n                name=\"C\u00F3digo\"\r\n                type=\"number\"\r\n                readonly\r\n                [(ngModel)]=\"toolbarObject.current.Id\" >\r\n            </rte-form-field>\r\n          </div>\r\n\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"C\u00F3digo Externo\" \r\n                name=\"ExternalCode\"\r\n                required\r\n                [(ngModel)]=\"toolbarObject.current.ExternalCode\" \r\n                maxlength=\"35\">\r\n              <mat-error>{{getExternalCodeMessage()}}</mat-error>\r\n            </rte-form-field>\r\n          </div>\r\n\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"Descri\u00E7\u00E3o\" \r\n                name=\"Description\"\r\n                required\r\n                [(ngModel)]=\"toolbarObject.current.Description\" \r\n                maxlength=\"65\">\r\n              <mat-error>{{getDescriptionMessage()}}</mat-error>\r\n            </rte-form-field>\r\n          </div>\r\n\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"Sigla\" \r\n                name=\"Acronym\"\r\n                type=\"text\"\r\n                required\r\n                [(ngModel)]=\"toolbarObject.current.Acronym\">\r\n              <mat-error>{{getAcronymMessage()}}</mat-error>\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row-form\">\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"RNTRC\"\r\n                required\r\n                matTooltip=\"Registro Nacional de Transporte Rodovi\u00E1rio de Carga\" \r\n                name=\"Rntrc\"\r\n                [(ngModel)]=\"toolbarObject.current.Rntrc\" \r\n                maxlength=\"35\">\r\n              <mat-error>{{getRntrcMessage()}}</mat-error>\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row-form\">\r\n          <div class=\"column-form\">\r\n            <mat-checkbox name=\"active\" [(ngModel)]=\"toolbarObject.current.Active\">Ativo</mat-checkbox>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </mat-card-content>\r\n  </rte-card>\r\n</div>\r\n\r\n<rte-app-company-image #companyImage [toolbarObject]=\"toolbarObject\"></rte-app-company-image>\r\n<rte-app-company-colors #companyColor [toolbarObject]=\"toolbarObject\"></rte-app-company-colors>",
                    styles: [".column-form-check{margin:0 15px}mat-card-title{margin:-30px -30px 50px!important;padding:20px 30px;font-size:20px}"]
                }] }
    ];
    /** @nocollapse */
    CompanyFormComponent.ctorParameters = function () { return [
        { type: RTEAlertService },
        { type: RteCompanyGroupService }
    ]; };
    CompanyFormComponent.propDecorators = {
        toolbarObject: [{ type: Input }],
        companyImage: [{ type: ViewChild, args: ['companyImage', { read: CompanyImageComponent },] }],
        companyColor: [{ type: ViewChild, args: ['companyColor', { read: CompanyColorComponent },] }]
    };
    return CompanyFormComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteCompanyService = /** @class */ (function () {
    function RteCompanyService(http, environment) {
        this.http = http;
        this.environment = environment;
    }
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    RteCompanyService.prototype.clear = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        objectCurrent.Id = 0;
        objectCurrent.ExternalCode = null;
        objectCurrent.FontColor = null;
        objectCurrent.InactiveBackground = null;
        objectCurrent.InactiveFont = null;
        objectCurrent.Logo = null;
        objectCurrent.ReportLogo = null;
        objectCurrent.RequiredBackground = null;
        objectCurrent.RequiredFontColor = null;
        objectCurrent.SelectedBackground = null;
        objectCurrent.SelectedFontColor = null;
        objectCurrent.UrlInitial = null;
        objectCurrent.Description = null;
        objectCurrent.FooterQuotationLogo = null;
        objectCurrent.HeaderQuotationLogo = null;
        objectCurrent.Active = false;
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    RteCompanyService.prototype.save = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        console.log(objectCurrent);
        if (!objectCurrent.Id) {
            return this.http.post(this.environment.apiCore + 'webapi/company', objectCurrent);
        }
        else {
            return this.http.put(this.environment.apiCore + 'webapi/company', objectCurrent);
        }
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    RteCompanyService.prototype.delete = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        return this.http.delete(this.environment.apiCore + 'webapi/company/' + objectCurrent.Id);
    };
    /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    RteCompanyService.prototype.get = /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    function (objectCurrent, page, pageSize) {
        page++;
        /** @type {?} */
        var params = new HttpParams()
            .set('page', page.toString())
            .set('amountByPage', pageSize.toString());
        if (objectCurrent) {
            params = this.appendHttpParams('Id', objectCurrent.Id, params);
            params = this.appendHttpParams('Description', objectCurrent.Description, params);
        }
        return this.http.get(this.environment.apiCore + 'webapi/company/getbyfilters', { params: params });
    };
    /**
     * @return {?}
     */
    RteCompanyService.prototype.getAllCompanies = /**
     * @return {?}
     */
    function () {
        return this.http.get(this.environment.apiCore + 'webapi/company/getall');
    };
    /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    RteCompanyService.prototype.appendHttpParams = /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    function (name, value, params) {
        return params.append(name, !value ? '' : value);
    };
    RteCompanyService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    RteCompanyService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['environment',] }] }
    ]; };
    /** @nocollapse */ RteCompanyService.ngInjectableDef = defineInjectable({ factory: function RteCompanyService_Factory() { return new RteCompanyService(inject(HttpClient), inject("environment")); }, token: RteCompanyService, providedIn: "root" });
    return RteCompanyService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CompanyComponent = /** @class */ (function () {
    function CompanyComponent(service, rteAlertService) {
        this.service = service;
        this.rteAlertService = rteAlertService;
        this.toolbarObject = new RteToolbarViewModel();
        this.showButton = new ShowButton();
        this.toolbarObject = new RteToolbarViewModel();
    }
    /**
     * @return {?}
     */
    CompanyComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.toolbarObject.current = new Company$1();
        this.toolbarObject.searchObject = new Company$1();
    };
    /**
     * @param {?} beforeSave
     * @return {?}
     */
    CompanyComponent.prototype.validateBeforeSave = /**
     * @param {?} beforeSave
     * @return {?}
     */
    function (beforeSave) {
        this.companyForm.companyImage.fillCurrentObjectWithImages();
        /** @type {?} */
        var validation = this.companyForm.getValidation();
        /** @type {?} */
        var colorValidation = this.companyForm.companyColor.getValidation();
        if (validation || colorValidation) {
            beforeSave.cancelSave = true;
            this.rteAlertService.warning('Preencha todos os campos', validation ? validation : colorValidation);
        }
    };
    CompanyComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-company',
                    template: "<rte-toolbar [toolbarObject]=\"toolbarObject\" \r\n             [service]=\"service\"\r\n             [KeyDownElementArea]=\"form\"\r\n             (validateBeforeSave)=\"validateBeforeSave($event)\"\r\n             (customizeAfterSave)=\"companyForm.customizeAfterSave($event)\"\r\n             (customizeAfterDelete)=\"companyForm.customizeAfterDelete($event)\"\r\n             (customizeAfterEditMode)=\"companyForm.companyImage.customizeAfterEditMode()\"\r\n             (customizeAfterInsertMode)=\"companyForm.companyImage.customizeAfterInsertMode()\"\r\n             [showButton]=\"showButton\">\r\n\r\n</rte-toolbar>\r\n<div class=\"wrapper\">   \r\n  <rte-app-title></rte-app-title>\r\n</div>\r\n\r\n<div #form>\r\n  <rte-app-company-search [toolbarObject]=\"toolbarObject\" *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n  </rte-app-company-search>\r\n\r\n  <rte-app-company-grid [toolbarObject]=\"toolbarObject\" *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n  </rte-app-company-grid>\r\n\r\n  <rte-app-company-form #companyForm [toolbarObject]=\"toolbarObject\" [hidden]=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n  </rte-app-company-form>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    CompanyComponent.ctorParameters = function () { return [
        { type: RteCompanyService },
        { type: RTEAlertService }
    ]; };
    CompanyComponent.propDecorators = {
        companyForm: [{ type: ViewChild, args: ['companyForm', { read: CompanyFormComponent },] }]
    };
    return CompanyComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CompanyGridComponent = /** @class */ (function () {
    function CompanyGridComponent() {
        this.displayedColumns = ['Id', 'Description', 'Rntrc', 'Color', 'Active'];
    }
    /**
     * @return {?}
     */
    CompanyGridComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    CompanyGridComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-company-grid',
                    template: "<div class=\"wrapper\">\r\n  <rte-card>\r\n    <mat-card-content>\r\n      <div class=\"mat-elevation-z4\">\r\n        <rte-table [dataSource]=\"toolbarObject.dataSource\"\r\n                   *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n          <ng-container rteColumnDef=\"Id\">\r\n            <rte-header-cell *rteHeaderCellDef>C\u00F3digo</rte-header-cell>\r\n            <rte-cell *rteCellDef=\"let company\">{{company.Id}}</rte-cell>\r\n          </ng-container>\r\n\r\n          <ng-container rteColumnDef=\"Description\">\r\n            <rte-header-cell *rteHeaderCellDef>Descri\u00E7\u00E3o</rte-header-cell>\r\n            <rte-cell *rteCellDef=\"let company\">{{company.Description}}</rte-cell>\r\n          </ng-container>\r\n\r\n          <ng-container rteColumnDef=\"Rntrc\">\r\n            <rte-header-cell *rteHeaderCellDef>RNTRC</rte-header-cell>\r\n            <rte-cell *rteCellDef=\"let company\">{{company.Rntrc}}</rte-cell>\r\n          </ng-container>\r\n\r\n          <ng-container rteColumnDef=\"Color\">\r\n            <rte-header-cell *rteHeaderCellDef>Cor da Empresa</rte-header-cell>\r\n            <rte-cell *rteCellDef=\"let company\">\r\n              <div class=\"color-div\" [style.background-color]=\"company.Color\"></div>\r\n              {{company.Color}}\r\n            </rte-cell>\r\n          </ng-container>\r\n\r\n          <ng-container rteColumnDef=\"Active\">\r\n            <rte-header-cell *rteHeaderCellDef>Ativo</rte-header-cell>\r\n            <rte-cell *rteCellDef=\"let company\">\r\n              <mat-checkbox [(ngModel)]=\"company.Active\" [disabled]=\"true\"></mat-checkbox>\r\n            </rte-cell>\r\n          </ng-container>\r\n\r\n          <rte-header-row *rteHeaderRowDef=\"displayedColumns\"></rte-header-row>\r\n          <rte-row *rteRowDef=\"let row; columns: displayedColumns;\" (click)=\"toolbarObject.setCurrent(row)\"\r\n                  (dblclick)=\"toolbarObject.viewMode(row)\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"\r\n                  [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted, selected: toolbarObject.selectionModel.isSelected(row)}\">\r\n          </rte-row>\r\n        </rte-table>\r\n      </div>\r\n    </mat-card-content>\r\n  </rte-card>\r\n</div>\r\n",
                    styles: ["rte-cell:nth-child(1),rte-cell:nth-child(5),rte-header-cell:nth-child(1),rte-header-cell:nth-child(5){flex:0 0 10%;justify-content:start}rte-cell:nth-child(2),rte-cell:nth-child(3),rte-header-cell:nth-child(2),rte-header-cell:nth-child(3){flex:0 0 30%;justify-content:start}rte-cell:nth-child(4),rte-header-cell:nth-child(4){flex:0 0 20%;justify-content:center}.color-div{width:15px;height:15px;border:1px solid #ebebeb;box-sizing:border-box;margin-right:5px}"]
                }] }
    ];
    /** @nocollapse */
    CompanyGridComponent.ctorParameters = function () { return []; };
    CompanyGridComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return CompanyGridComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CompanySearchComponent = /** @class */ (function () {
    function CompanySearchComponent() {
    }
    /**
     * @return {?}
     */
    CompanySearchComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    CompanySearchComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-company-search',
                    template: "<div class=\"wrapper\">\r\n  <rte-card>\r\n    <mat-card-content>\r\n      <form #formFilterRules=\"ngForm\" autocomplete=\"off\">\r\n\r\n        <div class=\"row-form\">\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"C\u00F3digo\" \r\n                name=\"C\u00F3digo\"\r\n                [(ngModel)]=\"toolbarObject.searchObject.Id\" >\r\n            </rte-form-field>\r\n          </div>\r\n          \r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"Descri\u00E7\u00E3o\" \r\n                name=\"Descri\u00E7\u00E3o\"\r\n                [(ngModel)]=\"toolbarObject.searchObject.Description\" \r\n                maxlength=\"65\">\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row-form\">\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"C\u00F3digo Externo\" \r\n                name=\"ExternalCode\"\r\n                [(ngModel)]=\"toolbarObject.searchObject.ExternalCode\" >\r\n            </rte-form-field>\r\n          </div>\r\n          \r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"RNTRC\" \r\n                name=\"Rntrc\"\r\n                [(ngModel)]=\"toolbarObject.searchObject.Rntrc\" >\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n\r\n      </form>\r\n    </mat-card-content>\r\n  </rte-card>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    CompanySearchComponent.ctorParameters = function () { return []; };
    CompanySearchComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return CompanySearchComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteCompanyModule = /** @class */ (function () {
    function RteCompanyModule() {
    }
    /**
     * @param {?} environment
     * @return {?}
     */
    RteCompanyModule.forRoot = /**
     * @param {?} environment
     * @return {?}
     */
    function (environment) {
        return {
            ngModule: RteCompanyModule,
            providers: [
                RteCompanyService,
                {
                    provide: 'environment',
                    useValue: environment
                }
            ]
        };
    };
    RteCompanyModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        RteToolbarModule,
                        RteAppTitleModule,
                        RteMaterialModule,
                        MatRippleModule,
                        MatCheckboxModule,
                        MatSelectModule,
                        MatOptionModule,
                        MatListModule,
                        MatTableModule,
                        MatIconModule,
                        MatAutocompleteModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatProgressSpinnerModule,
                        MatToolbarModule,
                        MatDialogModule,
                        MatCardModule,
                        CdkTableModule,
                        MatDividerModule,
                        MatExpansionModule,
                        FormsModule,
                        MatTooltipModule,
                        ColorPickerModule
                    ],
                    declarations: [CompanyComponent, CompanyFormComponent, CompanyGridComponent, CompanySearchComponent, CompanyImageComponent, CompanyColorComponent],
                    exports: [CompanyComponent]
                },] }
    ];
    return RteCompanyModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ObjectGroupFormComponent = /** @class */ (function () {
    function ObjectGroupFormComponent(rteSnackBarService) {
        this.rteSnackBarService = rteSnackBarService;
    }
    /**
     * @return {?}
     */
    ObjectGroupFormComponent.prototype.getDescriptionMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.Description)
            ? 'A descrição deve ser informada.' : '';
    };
    /**
     * @return {?}
     */
    ObjectGroupFormComponent.prototype.getValidation = /**
     * @return {?}
     */
    function () {
        return (this.getDescriptionMessage());
    };
    /**
     * @return {?}
     */
    ObjectGroupFormComponent.prototype.showErrorMessage = /**
     * @return {?}
     */
    function () {
        return this.toolbarObject.currentStatus === RteToolbarStatusEnum.Creating
            || this.toolbarObject.currentStatus === RteToolbarStatusEnum.Editing;
    };
    /**
     * @param {?} afterSave
     * @return {?}
     */
    ObjectGroupFormComponent.prototype.customizeAfterSave = /**
     * @param {?} afterSave
     * @return {?}
     */
    function (afterSave) {
        if (afterSave.success === true) {
            this.rteSnackBarService.showSuccessMessage('Grupo de objetos salvo com sucesso', 'Sucesso');
        }
    };
    /**
     * @param {?} option
     * @return {?}
     */
    ObjectGroupFormComponent.prototype.customizeAfterDelete = /**
     * @param {?} option
     * @return {?}
     */
    function (option) {
        if (option === true) {
            this.rteSnackBarService.showSuccessMessage('Grupo de objetos excluído com sucesso', 'Sucesso');
        }
    };
    /**
     * @return {?}
     */
    ObjectGroupFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    ObjectGroupFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-object-group-form',
                    template: "<rte-card>\r\n    <mat-card-content>\r\n        <form #formFilterRules=\"ngForm\" autocomplete=\"off\">\r\n            <div class=\"row-form\">\r\n                <div class=\"column-form\">\r\n                    <rte-form-field >\r\n                        <input rteInput placeholder=\"C\u00F3digo\" [(ngModel)]=\"toolbarObject.current.Id\" name=\"Id\" [readonly]=\"true\">\r\n                    </rte-form-field>\r\n                </div>\r\n                <div class=\"column-form\">\r\n                    <rte-form-field>\r\n                        <input rteInput #Description name=\"Description\" placeholder=\"Descri\u00E7\u00E3o\"\r\n                            [disabled]=\"toolbarObject.readonlyBrowserMode\" required maxlength=\"65\"\r\n                            [(ngModel)]=\"toolbarObject.current.Description\">\r\n                    </rte-form-field>\r\n                </div>\r\n            </div>\r\n        </form>\r\n    </mat-card-content>\r\n</rte-card>\r\n     \r\n<rte-app-object-group-form-grid [toolbarObject]=\"toolbarObject\" ></rte-app-object-group-form-grid>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ObjectGroupFormComponent.ctorParameters = function () { return [
        { type: RteSnackbarService }
    ]; };
    ObjectGroupFormComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return ObjectGroupFormComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ObjectGroupService = /** @class */ (function () {
    function ObjectGroupService(http, environment) {
        this.http = http;
        this.environment = environment;
    }
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    ObjectGroupService.prototype.clear = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        objectCurrent.Id = null;
        objectCurrent.Description = '';
        objectCurrent.Objects = [];
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    ObjectGroupService.prototype.save = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        if (objectCurrent.Id === null || objectCurrent.Id === 0) {
            return this.http.post(this.environment.apiCore + 'webapi/objectgroup', objectCurrent);
        }
        else {
            return this.http.put(this.environment.apiCore + 'webapi/objectgroup', objectCurrent);
        }
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    ObjectGroupService.prototype.delete = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        return this.http.delete(this.environment.apiCore +
            'webapi/objectgroup/' +
            objectCurrent.Id);
    };
    /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    ObjectGroupService.prototype.get = /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    function (objectCurrent, page, pageSize) {
        page++;
        /** @type {?} */
        var params = new HttpParams()
            .set('page', page.toString())
            .set('amountByPage', pageSize.toString());
        if (objectCurrent) {
            params = this.appendHttpParams('id', objectCurrent.Id, params);
            params = this.appendHttpParams('Description', objectCurrent.Description, params);
        }
        return this.http.get(this.environment.apiCore + 'webapi/objectgroup/getbyfilters', { params: params });
    };
    /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    ObjectGroupService.prototype.appendHttpParams = /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    function (name, value, params) {
        return params.append(name, !value ? '' : value);
    };
    ObjectGroupService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    ObjectGroupService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['environment',] }] }
    ]; };
    /** @nocollapse */ ObjectGroupService.ngInjectableDef = defineInjectable({ factory: function ObjectGroupService_Factory() { return new ObjectGroupService(inject(HttpClient), inject("environment")); }, token: ObjectGroupService, providedIn: "root" });
    return ObjectGroupService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ObjectGroupComponent = /** @class */ (function () {
    function ObjectGroupComponent(service, rteSnackBarService) {
        this.service = service;
        this.rteSnackBarService = rteSnackBarService;
        this.toolbarObject = new RteToolbarViewModel();
        this.toolbarObject = new RteToolbarViewModel();
        this.toolbarObject.searchObject = {};
    }
    /**
     * @return {?}
     */
    ObjectGroupComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.toolbarObject.current = new ObjectGroup();
    };
    /**
     * @param {?} beforeSave
     * @return {?}
     */
    ObjectGroupComponent.prototype.validateBeforeSave = /**
     * @param {?} beforeSave
     * @return {?}
     */
    function (beforeSave) {
        // const validation = this.objectGroupForm.getValidation();
        // if (validation) {
        //   beforeSave.cancelSave = true;
        //   this.rteSnackBarService.showWarningMessage('Aviso', validation);
        // }
    };
    ObjectGroupComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-object-group',
                    template: "<rte-toolbar [toolbarObject]=\"toolbarObject\" [service]=\"service\" [KeyDownElementArea]=\"form\"\r\n  (validateBeforeSave)=\"validateBeforeSave($event)\" (customizeAfterSave)=\"objectGroupForm.customizeAfterSave($event)\"\r\n  (customizeAfterDelete)=\"objectGroupForm.customizeAfterDelete($event)\">\r\n\r\n</rte-toolbar>\r\n\r\n<div class=\"wrapper\">\r\n  <rte-app-title></rte-app-title>\r\n\r\n  <div #form>\r\n    <rte-app-object-group-search [toolbarObject]=\"toolbarObject\"\r\n      *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n    </rte-app-object-group-search>\r\n\r\n    <rte-app-object-group-grid [toolbarObject]=\"toolbarObject\"\r\n      *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n    </rte-app-object-group-grid>\r\n\r\n    <rte-app-object-group-form #objectGroupForm [toolbarObject]=\"toolbarObject\"\r\n      [hidden]=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n    </rte-app-object-group-form>\r\n  </div>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ObjectGroupComponent.ctorParameters = function () { return [
        { type: ObjectGroupService },
        { type: RteSnackbarService }
    ]; };
    ObjectGroupComponent.propDecorators = {
        objectGroupForm: [{ type: ViewChild, args: ['objectGroupForm', { read: ObjectGroupFormComponent },] }]
    };
    return ObjectGroupComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ObjectGroupGridComponent = /** @class */ (function () {
    function ObjectGroupGridComponent() {
        this.displayedColumns = ['Id', 'Description'];
    }
    /**
     * @return {?}
     */
    ObjectGroupGridComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    ObjectGroupGridComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-object-group-grid',
                    template: "<rte-card>\r\n  <mat-card-content>\r\n    <div class=\"mat-elevation-z4\">\r\n      <rte-table [dataSource]=\"toolbarObject.dataSource\"\r\n        *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n        <ng-container rteColumnDef=\"Id\">\r\n          <rte-header-cell *rteHeaderCellDef>Id</rte-header-cell>\r\n          <rte-cell *rteCellDef=\"let groupObject\">{{groupObject.Id}}</rte-cell>\r\n        </ng-container>\r\n\r\n        <ng-container rteColumnDef=\"Description\">\r\n          <rte-header-cell *rteHeaderCellDef>Descri\u00E7\u00E3o</rte-header-cell>\r\n          <rte-cell *rteCellDef=\"let groupObject\">{{groupObject.Description}}</rte-cell>\r\n        </ng-container>\r\n\r\n        <rte-header-row *rteHeaderRowDef=\"displayedColumns\"></rte-header-row>\r\n        <rte-row *rteRowDef=\"let row; columns: displayedColumns;\" (click)=\"toolbarObject.setCurrent(row)\"\r\n          (dblclick)=\"toolbarObject.viewMode(row)\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"\r\n          [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted, selected: toolbarObject.selectionModel.isSelected(row)}\">\r\n        </rte-row>\r\n      </rte-table>\r\n    </div>\r\n  </mat-card-content>\r\n</rte-card>",
                    styles: ["rte-card{margin-top:30px}"]
                }] }
    ];
    /** @nocollapse */
    ObjectGroupGridComponent.ctorParameters = function () { return []; };
    ObjectGroupGridComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return ObjectGroupGridComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ObjectGroupSearchComponent = /** @class */ (function () {
    function ObjectGroupSearchComponent() {
    }
    /**
     * @return {?}
     */
    ObjectGroupSearchComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    ObjectGroupSearchComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-object-group-search',
                    template: "<rte-card>\r\n  <mat-card-content>\r\n    <form #formFilterRules=\"ngForm\" autocomplete=\"off\">\r\n      <div class=\"row-form\">\r\n        <div class=\"column-form\">\r\n          <rte-form-field class=\"example-full-width\">\r\n            <input rteInput placeholder=\"C\u00F3digo\" [(ngModel)]=\"toolbarObject.searchObject.Id\" name=\"Id\">\r\n          </rte-form-field>\r\n        </div>\r\n        <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n                <input rteInput #Description name=\"Description\" placeholder=\"Descri\u00E7\u00E3o\"\r\n                  [(ngModel)]=\"toolbarObject.searchObject.Description\">\r\n              </rte-form-field>\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </mat-card-content>\r\n</rte-card>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ObjectGroupSearchComponent.ctorParameters = function () { return []; };
    ObjectGroupSearchComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return ObjectGroupSearchComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ObjectGroup$1 = /** @class */ (function () {
    function ObjectGroup() {
    }
    return ObjectGroup;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ObjectCore = /** @class */ (function () {
    function ObjectCore() {
    }
    return ObjectCore;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ModalObjectRegisterComponent = /** @class */ (function () {
    //objectLov: IRteObjectLov;
    function ModalObjectRegisterComponent(dialog, data, rteAlert) {
        this.dialog = dialog;
        this.rteAlert = rteAlert;
        this.toolbarObjectParent = data.toolbarObject;
        this.currentStatus = data.status;
        this.toolbarObject = new RteLocalDataToolbarViewModel();
        /** @type {?} */
        var objects = _.cloneDeep(this.toolbarObjectParent.current.Objects);
        this.toolbarObject.dataSource = new RteToolbarDataSource(objects);
        if (data.currentRow) {
            /** @type {?} */
            var current = _.head(_.filter(this.toolbarObject.dataSource.data, function (obj) {
                return obj.Id === data.currentRow.Id;
            }));
            this.toolbarObject.current = (current) ? current : new ObjectCore();
        }
        //this.objectLov = { Id: null, Description: '', Name: '' };
    }
    /**
     * @param {?} validItem
     * @return {?}
     */
    ModalObjectRegisterComponent.prototype.validateItemEvent = /**
     * @param {?} validItem
     * @return {?}
     */
    function (validItem) {
        if (!this.toolbarObject.current.Id) {
            this.rteAlert.error('Necessário informar um objeto');
            return;
        }
        validItem.cancelConfirm = false;
    };
    /**
     * @param {?} localDataSourceResult
     * @return {?}
     */
    ModalObjectRegisterComponent.prototype.closeEvent = /**
     * @param {?} localDataSourceResult
     * @return {?}
     */
    function (localDataSourceResult) {
        this.toolbarObjectParent.current.Objects = localDataSourceResult.newData;
    };
    /**
     * @return {?}
     */
    ModalObjectRegisterComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    ModalObjectRegisterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-modal-object-register',
                    template: "<rte-local-data-toolbar rte-dialog-title\r\n [toolbarObject]=\"toolbarObject\"\r\n (validateItemEvent)=\"validateItemEvent($event)\"\r\n (closeEvent)=\"closeEvent($event)\"></rte-local-data-toolbar>\r\n<form #ObjectForm=\"ngForm\" autocomplete=\"off\">\r\n  <rte-app-object-lov [model]=\"toolbarObject.current\"></rte-app-object-lov>\r\n</form>\r\n<rte-app-model-grid [toolbarObject]=\"toolbarObject\">\r\n</rte-app-model-grid>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ModalObjectRegisterComponent.ctorParameters = function () { return [
        { type: RteDialog },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] },
        { type: RTEAlertService }
    ]; };
    return ModalObjectRegisterComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ObjectGroupFormGridComponent = /** @class */ (function () {
    function ObjectGroupFormGridComponent(dialog) {
        this.dialog = dialog;
        this.displayedColumns = ['Id', 'Description', 'Name'];
        this.selectionModel = new SelectionModel(true, []);
    }
    /**
     * @return {?}
     */
    ObjectGroupFormGridComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} newRow
     * @return {?}
     */
    ObjectGroupFormGridComponent.prototype.setCurrentRow = /**
     * @param {?} newRow
     * @return {?}
     */
    function (newRow) {
        this.currentRow = newRow;
        if (this.selectionModel.isSelected(newRow) === false) {
            this.selectionModel.toggle(newRow);
        }
    };
    /**
     * @param {?} element
     * @return {?}
     */
    ObjectGroupFormGridComponent.prototype.add = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        this.openDialogMode(element, 3);
        this.currentRow = new Object();
    };
    /**
     * @param {?} element
     * @return {?}
     */
    ObjectGroupFormGridComponent.prototype.edit = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        if (this.selectionModel.selected && this.selectionModel.selected.length > 0) {
            this.currentRow = this.selectionModel.selected[0];
        }
        else {
            this.currentRow = new Object();
        }
        this.openDialogMode(element, 4);
    };
    /**
     * @param {?} row
     * @param {?} status
     * @return {?}
     */
    ObjectGroupFormGridComponent.prototype.openDialogMode = /**
     * @param {?} row
     * @param {?} status
     * @return {?}
     */
    function (row, status) {
        if (this.toolbarObject.currentStatus !== this.toolbarObject.possibleStatus.Viewing) {
            this.openDialog(ModalObjectRegisterComponent, status);
        }
    };
    /**
     * @param {?} dialogref
     * @param {?} status
     * @return {?}
     */
    ObjectGroupFormGridComponent.prototype.openDialog = /**
     * @param {?} dialogref
     * @param {?} status
     * @return {?}
     */
    function (dialogref, status) {
        /** @type {?} */
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '1000px';
        dialogConfig.disableClose = true;
        dialogConfig.data = {
            status: status,
            currentRow: (status === 4 ? this.currentRow : new ObjectGroup$1()),
            toolbarObject: this.toolbarObject
        };
        /** @type {?} */
        var currentDialog = this.dialog.customOpen(dialogref, dialogConfig);
    };
    ObjectGroupFormGridComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-object-group-form-grid',
                    template: "<rte-card>\r\n  <mat-card-title>\r\n    <rte-toolbar-minor *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Creating ||\r\n        toolbarObject.currentStatus == toolbarObject.possibleStatus.Editing\" #toolbarObjects\r\n      (addEvent)=\"add(toolbarObject.current)\" (editEvent)=\"edit(toolbarObject.current)\"></rte-toolbar-minor>\r\n  </mat-card-title>\r\n  <mat-card-content>\r\n    <div class=\"mat-elevation-z4\">\r\n      <rte-table [dataSource]=\"toolbarObject.current.Objects\">\r\n        <ng-container rteColumnDef=\"Id\">\r\n          <rte-header-cell *rteHeaderCellDef>Id</rte-header-cell>\r\n          <rte-cell *rteCellDef=\"let object\">{{object.Id}}</rte-cell>\r\n        </ng-container>\r\n\r\n        <ng-container rteColumnDef=\"Description\">\r\n          <rte-header-cell *rteHeaderCellDef>Descri\u00E7\u00E3o</rte-header-cell>\r\n          <rte-cell *rteCellDef=\"let object\">{{object.Description}}</rte-cell>\r\n        </ng-container>\r\n\r\n        <ng-container rteColumnDef=\"Name\">\r\n          <rte-header-cell *rteHeaderCellDef>Nome do Objeto</rte-header-cell>\r\n          <rte-cell *rteCellDef=\"let object\">{{object.Name}}</rte-cell>\r\n        </ng-container>\r\n\r\n        <rte-header-row *rteHeaderRowDef=\"displayedColumns\"></rte-header-row>\r\n        <rte-row *rteRowDef=\"let row; columns: displayedColumns;\" (click)=\"setCurrentRow(row)\"\r\n          (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"\r\n          [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted, selected: selectionModel.isSelected(row)}\">\r\n        </rte-row>\r\n      </rte-table>\r\n      <rte-paginator [pageSize]=\"10\" [pageSizeOptions]=\"[5, 10, 20]\" showFirstLastButtons>\r\n      </rte-paginator>\r\n    </div>\r\n  </mat-card-content>\r\n</rte-card>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ObjectGroupFormGridComponent.ctorParameters = function () { return [
        { type: RteDialog }
    ]; };
    ObjectGroupFormGridComponent.propDecorators = {
        toolbarObject: [{ type: Input }],
        sort: [{ type: ViewChild, args: [MatSort,] }],
        paginator: [{ type: ViewChild, args: [MatPaginator,] }]
    };
    return ObjectGroupFormGridComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0 = { hasBackdrop: true };
var MaterialModule = /** @class */ (function () {
    function MaterialModule(matIconRegistry) {
        this.matIconRegistry = matIconRegistry;
        matIconRegistry.registerFontClassAlias('fontawesome', 'fa');
    }
    MaterialModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CdkTableModule,
                        MatAutocompleteModule,
                        MatButtonModule,
                        MatButtonToggleModule,
                        MatCardModule,
                        MatCheckboxModule,
                        MatChipsModule,
                        MatStepperModule,
                        MatDatepickerModule,
                        MatDialogModule,
                        MatDividerModule,
                        MatExpansionModule,
                        MatGridListModule,
                        MatIconModule,
                        MatInputModule,
                        MatListModule,
                        MatMenuModule,
                        MatNativeDateModule,
                        MatPaginatorModule,
                        MatProgressBarModule,
                        MatProgressSpinnerModule,
                        MatRadioModule,
                        MatRippleModule,
                        MatSelectModule,
                        MatSidenavModule,
                        MatSliderModule,
                        MatSlideToggleModule,
                        MatSnackBarModule,
                        MatSortModule,
                        MatTableModule,
                        MatTabsModule,
                        MatToolbarModule,
                        MatTooltipModule,
                        MatBadgeModule
                    ],
                    exports: [
                        CdkTableModule,
                        MatAutocompleteModule,
                        MatButtonModule,
                        MatButtonToggleModule,
                        MatCardModule,
                        MatCheckboxModule,
                        MatChipsModule,
                        MatStepperModule,
                        MatDatepickerModule,
                        MatDialogModule,
                        MatDividerModule,
                        MatExpansionModule,
                        MatGridListModule,
                        MatIconModule,
                        MatInputModule,
                        MatListModule,
                        MatMenuModule,
                        MatNativeDateModule,
                        MatPaginatorModule,
                        MatProgressBarModule,
                        MatProgressSpinnerModule,
                        MatRadioModule,
                        MatRippleModule,
                        MatSelectModule,
                        MatSidenavModule,
                        MatSliderModule,
                        MatSlideToggleModule,
                        MatSnackBarModule,
                        MatSortModule,
                        MatTableModule,
                        MatTabsModule,
                        MatToolbarModule,
                        MatTooltipModule,
                        MatBadgeModule
                    ],
                    providers: [
                        [
                            { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: ɵ0 }
                        ], MatDialog, MatIconRegistry
                    ],
                    declarations: []
                },] }
    ];
    /** @nocollapse */
    MaterialModule.ctorParameters = function () { return [
        { type: MatIconRegistry }
    ]; };
    return MaterialModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ModalGridComponent = /** @class */ (function () {
    function ModalGridComponent() {
        this.displayedColumns = ['Id', 'Description', 'Status'];
    }
    /**
     * @return {?}
     */
    ModalGridComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    ModalGridComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-model-grid',
                    template: "<rte-card>\r\n  <mat-card-content>\r\n    <rte-table [dataSource]=\"toolbarObject.getCleanDataSource()\">\r\n      <ng-container rteColumnDef=\"Id\">\r\n        <rte-header-cell *rteHeaderCellDef>Id</rte-header-cell>\r\n        <rte-cell *rteCellDef=\"let object\">{{object.Id}}</rte-cell>\r\n      </ng-container>\r\n\r\n      <ng-container rteColumnDef=\"Description\">\r\n        <rte-header-cell *rteHeaderCellDef>Descri\u00E7\u00E3o</rte-header-cell>\r\n        <rte-cell *rteCellDef=\"let object\">{{object.Description}}</rte-cell>\r\n      </ng-container>\r\n\r\n      <ng-container rteColumnDef=\"Status\">\r\n        <rte-header-cell *rteHeaderCellDef>Nome</rte-header-cell>\r\n        <rte-cell *rteCellDef=\"let object\">{{object.Name}}</rte-cell>\r\n      </ng-container>\r\n\r\n      <rte-header-row *rteHeaderRowDef=\"displayedColumns\"></rte-header-row>\r\n      <rte-row *rteRowDef=\"let row; columns: displayedColumns;\" (click)=\"toolbarObject.setCurrent(row)\"\r\n        (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"\r\n        [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted, selected: toolbarObject.selectionModel.isSelected(row)}\">\r\n      </rte-row>\r\n    </rte-table>\r\n  </mat-card-content>\r\n</rte-card>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ModalGridComponent.ctorParameters = function () { return []; };
    ModalGridComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return ModalGridComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteObjectLovModalComponent = /** @class */ (function () {
    function RteObjectLovModalComponent(data, modalRef, objectCoreService) {
        this.data = data;
        this.modalRef = modalRef;
        this.objectCoreService = objectCoreService;
        this.ok = false;
        this.displayedColumns = [
            'Id',
            'Description'
        ];
        this.isFixedToolbar = false;
        this.showButton = new ShowButton();
        this.showButton.cancelEdit = false;
        this.showButton.cancelSave = false;
        this.showButton.close = false;
        this.showButton.delete = false;
        this.showButton.edit = false;
        this.showButton.insert = false;
        this.showButton.rteHistory = false;
        this.showButton.save = false;
        this.showButton.cancel = false;
        this.toolbarObject = new RteToolbarViewModel();
        this.toolbarObject.searchObject = {};
        this.serviceBaseUrl = data.serviceBaseUrl;
    }
    /**
     * @return {?}
     */
    RteObjectLovModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.toolbarObject.dataSource.sort = this.sort;
    };
    /**
     * @param {?} selected
     * @return {?}
     */
    RteObjectLovModalComponent.prototype.selectAndClose = /**
     * @param {?} selected
     * @return {?}
     */
    function (selected) {
        this.ok = true;
        this.selected = selected;
        this.modalRef.close();
    };
    /**
     * @return {?}
     */
    RteObjectLovModalComponent.prototype.confirmAndClose = /**
     * @return {?}
     */
    function () {
        if (this.toolbarObject.selectionModel.selected != null && this.toolbarObject.selectionModel.selected.length > 0) {
            this.selected = this.toolbarObject.selectionModel.selected[0];
            this.ok = true;
            this.modalRef.close();
        }
    };
    /**
     * @return {?}
     */
    RteObjectLovModalComponent.prototype.close = /**
     * @return {?}
     */
    function () {
        this.ok = false;
        this.modalRef.close();
    };
    RteObjectLovModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-rte-object-lov-modal',
                    template: "<div class=\"dialog-overflow\">\r\n  <div class=\"header\">\r\n      <rte-toolbar\r\n          [title]=\"'Pesquisa de Cliente'\"\r\n          [isFixedToolbar]=\"isFixedToolbar\"\r\n          [showButton]=\"showButton\"\r\n          [toolbarObject]=\"toolbarObject\"\r\n          [service]=\"objectCoreService\">\r\n          <span class=\"toolbar-grouped-buttons\">\r\n              <button\r\n                  *ngIf=\"toolbarObject.current?.Id != null && toolbarObject.current?.Id > 0\"\r\n                  rtebutton-flat \r\n                  color=\"primary\"\r\n                  (click)=\"confirmAndClose()\">\r\n                  <span class=\"rte-icon\">\r\n                      Confirmar\r\n                  </span>\r\n              </button>\r\n          </span>\r\n          <span class=\"toolbar-grouped-buttons\">\r\n              <button\r\n                  rtebutton-stroked\r\n                  (click)=\"close()\">\r\n                  <span class=\"rte-icon\">\r\n                      Fechar\r\n                  </span>\r\n              </button>\r\n          </span>\r\n      </rte-toolbar>\r\n  </div>\r\n  <rte-card>\r\n      <mat-card-content>\r\n          <form>\r\n              <div class=\"row-form\">\r\n                  <div class=\"column-form\">\r\n                      <rte-form-field>\r\n                          <input rteInput\r\n                              name=\"Id\"\r\n                              type=\"text\"\r\n                              maxlength=\"15\"\r\n                              placeholder=\"C\u00F3digo\"\r\n                              [(ngModel)]=\"toolbarObject.searchObject.Id\" />\r\n                      </rte-form-field>\r\n                  </div>\r\n                  <div class=\"column-form\">\r\n                      <rte-form-field>\r\n                          <input rteInput\r\n                              name=\"Description\"\r\n                              type=\"text\"\r\n                              maxlength=\"65\"\r\n                              placeholder=\"Descri\u00E7\u00E3o\" \r\n                              [(ngModel)]=\"toolbarObject.searchObject.Description\" />\r\n                      </rte-form-field>\r\n                  </div>\r\n              </div>\r\n          </form>\r\n      </mat-card-content>\r\n  </rte-card>\r\n  <rte-card>\r\n      <mat-card-content>\r\n          <rte-table [dataSource]=\"toolbarObject.dataSource\" rteSort>\r\n              <ng-container rteColumnDef=\"Id\">\r\n                  <rte-header-cell *rteHeaderCellDef> C\u00F3digo</rte-header-cell>\r\n                  <rte-cell *rteCellDef=\"let element\">\r\n                      {{ element.Id }}\r\n                  </rte-cell>\r\n              </ng-container>\r\n\r\n              <ng-container rteColumnDef=\"Description\">\r\n                  <rte-header-cell *rteHeaderCellDef> Descri\u00E7\u00E3o </rte-header-cell>\r\n                  <rte-cell *rteCellDef=\"let element\">\r\n                      {{ element.Description }}\r\n                  </rte-cell>\r\n              </ng-container>\r\n\r\n              <rte-header-row\r\n                  *rteHeaderRowDef=\"displayedColumns\">\r\n              </rte-header-row>\r\n              <rte-row\r\n                  *rteRowDef=\"let row; columns: displayedColumns\"\r\n                  [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted, selected: toolbarObject.selectionModel.isSelected(row)}\"\r\n                  (dblclick)=\"selectAndClose(row)\"  \r\n                  (click)=\"toolbarObject.setCurrent(row)\"\r\n                  (mouseover)=\"row.hovered = true\" \r\n                  (mouseout)=\"row.hovered = false\"  \r\n              >\r\n              </rte-row>\r\n          </rte-table>\r\n      </mat-card-content>\r\n  </rte-card>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    RteObjectLovModalComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] },
        { type: RteDialogRef },
        { type: ObjectService }
    ]; };
    RteObjectLovModalComponent.propDecorators = {
        sort: [{ type: ViewChild, args: [RteSortDirective,] }]
    };
    return RteObjectLovModalComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteObjectLovComponent = /** @class */ (function () {
    function RteObjectLovComponent(dialog, objectCoreService) {
        this.dialog = dialog;
        this.objectCoreService = objectCoreService;
    }
    /**
     * @return {?}
     */
    RteObjectLovComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    RteObjectLovComponent.prototype.ObjectIdChanged = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.model.Id != null) {
            this.objectCoreService.get({
                Id: this.model.Id
            }, 0, 1).subscribe(function (data) {
                if (data.TotalRegisters > 0) {
                    _this.model.Id = data.Data[0].Id;
                    _this.model.Description = data.Data[0].Description;
                    _this.model.Name = data.Data[0].Name;
                }
                else {
                    _this.model.Id = null;
                    _this.model.Description = null;
                    _this.model.Name = null;
                }
            });
        }
        else {
            this.model.Id = null;
            this.model.Description = null;
            this.model.Name = null;
        }
    };
    /**
     * @return {?}
     */
    RteObjectLovComponent.prototype.openModal = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '1200px';
        dialogConfig.disableClose = true;
        dialogConfig.data = {
            serviceBaseUrl: this.serviceBaseUrl
        };
        /** @type {?} */
        var currentDialog = this.dialog.open(RteObjectLovModalComponent, dialogConfig);
        currentDialog.afterClosed().subscribe(function () {
            if (currentDialog.componentInstance.ok === true) {
                _this.model.Id = currentDialog.componentInstance.selected.Id;
                _this.model.Description = currentDialog.componentInstance.selected.Description;
                _this.model.Name = currentDialog.componentInstance.selected.Name;
            }
        });
    };
    RteObjectLovComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-object-lov',
                    template: "<div class='row-form'>\r\n  <div class='column-form'>\r\n      <rte-form-field>\r\n          <input rteInput\r\n              name=\"ObjectId\"\r\n              type=\"text\"\r\n              required\r\n              maxlength=\"15\"\r\n              placeholder=\"C\u00F3digo\"\r\n              [(ngModel)]=\"model.Id\"\r\n              (change)=\"ObjectIdChanged()\" />\r\n              <rte-icon matSuffix class=\"search-button\" (click)=\"openModal()\">search</rte-icon>\r\n      </rte-form-field>\r\n  </div>\r\n  <div class='column-form'>\r\n      <rte-form-field>\r\n          <input rteInput\r\n              name=\"ObjectDescription\"\r\n              type=\"text\"\r\n              required\r\n              maxlength=\"65\"\r\n              placeholder=\"Descri\u00E7\u00E3o\"\r\n              readonly=\"readonly\"\r\n              [(ngModel)]=\"model.Description\" />\r\n      </rte-form-field>\r\n  </div>\r\n</div>\r\n\r\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    RteObjectLovComponent.ctorParameters = function () { return [
        { type: RteDialog },
        { type: ObjectService }
    ]; };
    RteObjectLovComponent.propDecorators = {
        model: [{ type: Input }],
        serviceBaseUrl: [{ type: Input }]
    };
    return RteObjectLovComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteObjectLovModule = /** @class */ (function () {
    function RteObjectLovModule() {
    }
    RteObjectLovModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [RteObjectLovComponent, RteObjectLovModalComponent],
                    imports: [
                        CommonModule,
                        RteToolbarModule,
                        RteAppTitleModule,
                        RteMaterialModule,
                        MaterialModule,
                        RteToolbarMinorModule,
                        FormsModule,
                        RteObjectModule
                    ],
                    exports: [RteObjectLovComponent],
                    entryComponents: [RteObjectLovModalComponent]
                },] }
    ];
    return RteObjectLovModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteObjectGroupModule = /** @class */ (function () {
    function RteObjectGroupModule() {
    }
    /**
     * @param {?} environment
     * @return {?}
     */
    RteObjectGroupModule.forRoot = /**
     * @param {?} environment
     * @return {?}
     */
    function (environment) {
        return {
            ngModule: RteObjectGroupModule,
            providers: [
                ObjectGroupService,
                {
                    provide: 'environment',
                    useValue: environment
                }
            ]
        };
    };
    RteObjectGroupModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        ObjectGroupComponent,
                        ObjectGroupFormComponent,
                        ObjectGroupGridComponent,
                        ObjectGroupSearchComponent,
                        ObjectGroupFormGridComponent,
                        ModalObjectRegisterComponent,
                        ModalGridComponent
                    ],
                    imports: [
                        CommonModule,
                        RteToolbarModule,
                        RteAppTitleModule,
                        RteMaterialModule,
                        MaterialModule,
                        RteToolbarMinorModule,
                        RteObjectLovModule,
                        FormsModule
                    ],
                    exports: [ObjectGroupComponent],
                    entryComponents: [
                        ModalObjectRegisterComponent
                    ],
                },] }
    ];
    return RteObjectGroupModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MenuInputFormComponent = /** @class */ (function () {
    function MenuInputFormComponent(rteAlertService, objectService) {
        this.rteAlertService = rteAlertService;
        this.objectService = objectService;
    }
    /**
     * @return {?}
     */
    MenuInputFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} afterSave
     * @return {?}
     */
    MenuInputFormComponent.prototype.customizeAfterSave = /**
     * @param {?} afterSave
     * @return {?}
     */
    function (afterSave) {
        if (afterSave.success === true) {
            this.rteAlertService.success('Registro salvo com sucesso', 'Sucesso');
        }
    };
    /**
     * @param {?} option
     * @return {?}
     */
    MenuInputFormComponent.prototype.customizeAfterDelete = /**
     * @param {?} option
     * @return {?}
     */
    function (option) {
        if (option === true) {
            this.rteAlertService.success('Registro excluído com sucesso', 'Sucesso');
        }
    };
    /**
     * @return {?}
     */
    MenuInputFormComponent.prototype.getDescriptionMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.Description)
            ? 'A descrição deve ser informada.' : '';
    };
    /**
     * @return {?}
     */
    MenuInputFormComponent.prototype.showErrorMessage = /**
     * @return {?}
     */
    function () {
        return this.toolbarObject.currentStatus === RteToolbarStatusEnum.Creating
            || this.toolbarObject.currentStatus === RteToolbarStatusEnum.Editing;
    };
    /**
     * @return {?}
     */
    MenuInputFormComponent.prototype.getValidation = /**
     * @return {?}
     */
    function () {
        return (this.getDescriptionMessage());
    };
    /**
     * @param {?=} obj
     * @return {?}
     */
    MenuInputFormComponent.prototype.autoObjectDisplayName = /**
     * @param {?=} obj
     * @return {?}
     */
    function (obj) {
        return obj ? obj.Description : undefined;
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    MenuInputFormComponent.prototype.filterObjects = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        var _this = this;
        if (evt.target.value) {
            this.objectService.getById(evt.target.value).subscribe(function (r) {
                _this.toolbarObject.current.Object = r;
            });
        }
        else {
            /** @type {?} */
            var newObj = new ObjectModel();
            newObj.Id = 0;
            this.toolbarObject.current.Object = newObj;
        }
    };
    MenuInputFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-menu-input-form',
                    template: "<div class=\"wrapper\">\r\n    <rte-card>\r\n        <mat-card-content>\r\n            <form #formFilterRules=\"ngForm\" autocomplete=\"off\">\r\n                <div class=\"row-form\">\r\n                    <div class=\"column-form\">\r\n                        <rte-form-field class=\"example-full-width\">\r\n                        <input \r\n                            rteInput \r\n                            placeholder=\"Descri\u00E7\u00E3o\"\r\n                            name=\"Descri\u00E7\u00E3o\" \r\n                            [(ngModel)]=\"toolbarObject.current.Description\" \r\n                            maxlength=\"200\"\r\n                            [readonly]=\"toolbarObject.readonlyBrowserMode\"\r\n                            disable-uppercase\r\n                            required\r\n                        >\r\n                            <mat-error>{{getDescriptionMessage()}}</mat-error>\r\n                        </rte-form-field>\r\n                    </div>\r\n\r\n                    <div class=\"column-form col-objeto\">\r\n                        <rte-form-field>\r\n                            <input \r\n                            #objRef\r\n                            rteInput \r\n                            placeholder=\"Objeto\"  \r\n                            type=\"text\" \r\n                            [ngModel]=\"toolbarObject.current.Object?.Id\" \r\n                            (ngModelChange)=\"toolbarObject.current.Object.Id=$event\"\r\n                            [readonly]=\"toolbarObject.readonlyBrowserMode\"\r\n                            name=\"objectItem\"\r\n                            (change)=\"filterObjects($event);\">\r\n                        </rte-form-field>\r\n\r\n                        <rte-form-field>\r\n                            <input \r\n                                rteInput \r\n                                type=\"text\" \r\n                                placeholder=\"Descri\u00E7\u00E3o do Objeto\"  \r\n                                [ngModel]=\"toolbarObject.current.Object?.Description\" \r\n                                (ngModelChange)=\"toolbarObject.current.Object.Description=$event\"\r\n                                name=\"objectItemDescription\"\r\n                                disabled=\"disabled\">\r\n                        </rte-form-field>\r\n\r\n                        <rte-form-field>\r\n                            <input \r\n                                rteInput \r\n                                type=\"text\" \r\n                                placeholder=\"Nome do Objeto\"  \r\n                                [ngModel]=\"toolbarObject.current.Object?.Name\" \r\n                                (ngModelChange)=\"toolbarObject.current.Object.Name=$event\" \r\n                                name=\"objectItemName\"\r\n                                disabled=\"disabled\">\r\n                        </rte-form-field>\r\n                    </div>\r\n                </div>\r\n                \r\n                <div class=\"row-form\">\r\n                    <div class=\"column-form\">\r\n                        <rte-form-field>\r\n                            <textarea \r\n                                rteInput \r\n                                placeholder=\"Coment\u00E1rio\"  \r\n                                type=\"text\" \r\n                                [(ngModel)]=\"toolbarObject.current.Comment\" \r\n                                [readonly]=\"toolbarObject.readonlyBrowserMode\"\r\n                                name=\"menuComment\">\r\n                            </textarea>\r\n                        </rte-form-field>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n        </mat-card-content>\r\n    </rte-card>\r\n</div>",
                    styles: [".col-objeto{flex-direction:row;flex-wrap:wrap}.col-objeto rte-form-field{width:100%!important}.col-objeto rte-form-field:first-child{width:60px!important;margin-right:10px;margin-bottom:10px}.col-objeto rte-form-field:nth-child(2){width:calc(100% - 70px)!important}"]
                }] }
    ];
    /** @nocollapse */
    MenuInputFormComponent.ctorParameters = function () { return [
        { type: RTEAlertService },
        { type: ObjectService }
    ]; };
    MenuInputFormComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return MenuInputFormComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MenuInput = /** @class */ (function () {
    function MenuInput() {
        this.Object = new ObjectModel();
    }
    return MenuInput;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MenuChangeOrderRequest = /** @class */ (function () {
    function MenuChangeOrderRequest() {
    }
    return MenuChangeOrderRequest;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MenuInputService = /** @class */ (function () {
    function MenuInputService(http, environment) {
        this.http = http;
        this.environment = environment;
    }
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    MenuInputService.prototype.clear = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        for (var propertyName in objectCurrent) {
            objectCurrent[propertyName] = null;
        }
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    MenuInputService.prototype.save = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        /** @type {?} */
        var copyObj = this.copyMenuInput(objectCurrent, 0);
        if (!objectCurrent.Id) {
            return this.http.post(this.environment.apiCore + 'webapi/menuinput', copyObj);
        }
        else {
            return this.http.put(this.environment.apiCore + 'webapi/menuinput', copyObj);
        }
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    MenuInputService.prototype.delete = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        return this.http.delete(this.environment.apiCore + 'webapi/menuinput/' + objectCurrent.Id);
    };
    /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    MenuInputService.prototype.get = /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    function (objectCurrent, page, pageSize) {
        page++;
        /** @type {?} */
        var params = new HttpParams()
            .set('systemId', objectCurrent.systemId.toString())
            .set('languageId', objectCurrent.languageId.toString());
        return this.http.get(this.environment.apiCore + 'webapi/menuinput/getbyfilters', { params: params });
    };
    /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    MenuInputService.prototype.appendHttpParams = /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    function (name, value, params) {
        return params.append(name, !value ? '' : value);
    };
    /**
     * @param {?} parent
     * @param {?} target
     * @return {?}
     */
    MenuInputService.prototype.changeOrderUp = /**
     * @param {?} parent
     * @param {?} target
     * @return {?}
     */
    function (parent, target) {
        /** @type {?} */
        var request = new MenuChangeOrderRequest();
        request.indexOfTarget = target;
        request.parent = this.copyMenuInput(parent);
        return this.http.post(this.environment.apiCore + 'webapi/menuinput/changeorderup', request);
    };
    /**
     * @param {?} parent
     * @param {?} target
     * @return {?}
     */
    MenuInputService.prototype.changeOrderDown = /**
     * @param {?} parent
     * @param {?} target
     * @return {?}
     */
    function (parent, target) {
        /** @type {?} */
        var request = new MenuChangeOrderRequest();
        request.indexOfTarget = target;
        request.parent = this.copyMenuInput(parent);
        return this.http.post(this.environment.apiCore + 'webapi/menuinput/changeorderdown', request);
    };
    /**
     * @param {?} parent
     * @param {?} target
     * @return {?}
     */
    MenuInputService.prototype.changeParentToChildren = /**
     * @param {?} parent
     * @param {?} target
     * @return {?}
     */
    function (parent, target) {
        /** @type {?} */
        var request = new MenuChangeOrderRequest();
        request.indexOfTarget = target;
        request.parent = this.copyMenuInput(parent, 2);
        return this.http.post(this.environment.apiCore + 'webapi/menuinput/changeparentident', request);
    };
    /**
     * @param {?} parentOfParent
     * @param {?} middleParentIndex
     * @param {?} target
     * @return {?}
     */
    MenuInputService.prototype.changeParentToFather = /**
     * @param {?} parentOfParent
     * @param {?} middleParentIndex
     * @param {?} target
     * @return {?}
     */
    function (parentOfParent, middleParentIndex, target) {
        /** @type {?} */
        var request = new MenuChangeOrderRequest();
        request.indexOfTarget = target;
        request.indexOfFirstParentTarget = middleParentIndex;
        request.parent = this.copyMenuInput(parentOfParent, 2);
        return this.http.post(this.environment.apiCore + 'webapi/menuinput/changeparentoutdent', request);
    };
    /**
     * @private
     * @param {?} input
     * @param {?=} maxLevel
     * @return {?}
     */
    MenuInputService.prototype.copyMenuInput = /**
     * @private
     * @param {?} input
     * @param {?=} maxLevel
     * @return {?}
     */
    function (input, maxLevel) {
        if (maxLevel === void 0) { maxLevel = 1; }
        var e_1, _a;
        /** @type {?} */
        var newParent = new MenuInput();
        newParent.Id = input.Id;
        newParent.Description = input.Description;
        newParent.SystemId = input.SystemId;
        newParent.Object = input.Object;
        newParent.Level = input.Level;
        newParent.LanguageId = input.LanguageId;
        newParent.Order = input.Order;
        newParent.Comment = input.Comment;
        newParent.Parent = null;
        newParent.ParentId = input.ParentId;
        newParent.Menus = [];
        newParent.Revision = input.Revision;
        if (maxLevel > 0) {
            try {
                for (var _b = __values(input.Menus), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    newParent.Menus.push(this.copyMenuInput(item, maxLevel - 1));
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return newParent;
    };
    MenuInputService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    MenuInputService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['environment',] }] }
    ]; };
    /** @nocollapse */ MenuInputService.ngInjectableDef = defineInjectable({ factory: function MenuInputService_Factory() { return new MenuInputService(inject(HttpClient), inject("environment")); }, token: MenuInputService, providedIn: "root" });
    return MenuInputService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MenuInputSearch = /** @class */ (function () {
    function MenuInputSearch() {
    }
    return MenuInputSearch;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var OrderOrientationEnum = {
    Left: 1,
    Right: 2,
};
OrderOrientationEnum[OrderOrientationEnum.Left] = 'Left';
OrderOrientationEnum[OrderOrientationEnum.Right] = 'Right';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var ParentOrientationEnum = {
    Father: 1,
    Children: 2,
};
ParentOrientationEnum[ParentOrientationEnum.Father] = 'Father';
ParentOrientationEnum[ParentOrientationEnum.Children] = 'Children';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MenuInputTableComponent = /** @class */ (function () {
    function MenuInputTableComponent(rteAlertService, menuService) {
        this.rteAlertService = rteAlertService;
        this.menuService = menuService;
        this.treeControl = new NestedTreeControl(function (node) { return node.Menus; });
        this.dataSource = new MatTreeNestedDataSource();
        this.selectionModel = new SelectionModel(false);
        this.left = OrderOrientationEnum.Left;
        this.right = OrderOrientationEnum.Right;
        this.father = ParentOrientationEnum.Father;
        this.children = ParentOrientationEnum.Children;
        this.hasChild = function (_$$1, node) { return !!node.Menus && node.Menus.length > 0; };
    }
    /**
     * @param {?} afterGet
     * @return {?}
     */
    MenuInputTableComponent.prototype.setDataTree = /**
     * @param {?} afterGet
     * @return {?}
     */
    function (afterGet) {
        if (this.toolbarObject.current) {
            this.setParents(this.toolbarObject.current);
            this.dataSource.data = [this.toolbarObject.current];
            this.root = this.toolbarObject.current;
        }
    };
    /**
     * @private
     * @param {?} rootEle
     * @param {?=} parent
     * @return {?}
     */
    MenuInputTableComponent.prototype.setParents = /**
     * @private
     * @param {?} rootEle
     * @param {?=} parent
     * @return {?}
     */
    function (rootEle, parent) {
        var _this = this;
        if (parent === void 0) { parent = null; }
        rootEle.Parent = parent;
        rootEle.Menus.forEach(function (item) {
            _this.setParents(item, rootEle);
        });
    };
    /**
     * @param {?} row
     * @return {?}
     */
    MenuInputTableComponent.prototype.selectNode = /**
     * @param {?} row
     * @return {?}
     */
    function (row) {
        if (row.Description === 'Menu') {
            this.rteAlertService.warning('Não é possível selecionar o item Raíz.', 'O primeiro item não pode ser selecionado e/ou editado.');
            return;
        }
        this.selectionModel.toggle(row);
        this.toolbarObject.setCurrent(row);
    };
    /**
     * @param {?} orientation
     * @return {?}
     */
    MenuInputTableComponent.prototype.changeOrder = /**
     * @param {?} orientation
     * @return {?}
     */
    function (orientation) {
        var _this = this;
        if (!this.selectionModel.hasValue()) {
            this.rteAlertService.warning('Selecione um item', 'Nenhum item do menu está selecionado');
            return;
        }
        /** @type {?} */
        var selected = this.selectionModel.selected[0];
        if (!selected.Parent) {
            this.rteAlertService.error('Não é possível mover a Raiz do menu', 'O primeiro item do menu não pode ser movido ou alterado.');
            return;
        }
        /** @type {?} */
        var parent = selected.Parent;
        /** @type {?} */
        var indexOfItem = parent.Menus.indexOf(selected);
        switch (orientation) {
            case OrderOrientationEnum.Left:
                if (indexOfItem <= 0) {
                    this.rteAlertService.error('Não é possível mover para a esquerda.', 'O item que está sendo movido já pertence a primeira posição.');
                    return;
                }
                this.menuService.changeOrderUp(parent, indexOfItem).subscribe(function (r) {
                    parent.Menus.splice(indexOfItem, 1);
                    parent.Menus.splice(indexOfItem - 1, 0, selected);
                    parent.Menus.forEach(function (item) {
                        item.Revision++;
                    });
                    _this.refreshTree();
                });
                break;
            case OrderOrientationEnum.Right:
                if (indexOfItem >= parent.Menus.length - 1) {
                    this.rteAlertService.error('Não é possível mover para a direita.', 'O item que está sendo movido já pertence a última posição.');
                    return;
                }
                this.menuService.changeOrderDown(parent, indexOfItem).subscribe(function (r) {
                    parent.Menus.splice(indexOfItem, 1);
                    parent.Menus.splice(indexOfItem + 1, 0, selected);
                    parent.Menus.forEach(function (item) {
                        item.Revision++;
                    });
                    _this.refreshTree();
                });
                break;
        }
    };
    /**
     * @param {?} orientation
     * @return {?}
     */
    MenuInputTableComponent.prototype.changeParent = /**
     * @param {?} orientation
     * @return {?}
     */
    function (orientation) {
        var _this = this;
        if (!this.selectionModel.hasValue()) {
            this.rteAlertService.warning('Selecione um item', 'Nenhum item do menu está selecionado');
            return;
        }
        /** @type {?} */
        var selected = this.selectionModel.selected[0];
        if (!selected.Parent) {
            this.rteAlertService.error('Não é possível mover a Raiz do menu', 'O primeiro item do menu não pode ser movido ou alterado.');
            return;
        }
        /** @type {?} */
        var parent = selected.Parent;
        /** @type {?} */
        var indexOfItem = parent.Menus.indexOf(selected);
        switch (orientation) {
            case ParentOrientationEnum.Father:
                if (!parent.Parent) {
                    this.rteAlertService.error('Não é possível mover um item para a raiz!', 'Não existe nenhum nó acima do nó raiz.');
                    return;
                }
                /** @type {?} */
                var parentOfParent_1 = parent.Parent;
                /** @type {?} */
                var middleParentIndex = parentOfParent_1.Menus.indexOf(parent);
                this.menuService.changeParentToFather(parentOfParent_1, middleParentIndex, indexOfItem).subscribe(function (r) {
                    parent.Menus.splice(indexOfItem, 1);
                    parentOfParent_1.Menus.push(selected);
                    parent.Menus.forEach(function (item) {
                        item.Revision++;
                    });
                    parentOfParent_1.Menus.forEach(function (item) {
                        item.Revision++;
                    });
                    _this.setParents(_this.root);
                    _this.refreshTree();
                });
                break;
            case ParentOrientationEnum.Children:
                if (indexOfItem <= 0) {
                    this.rteAlertService.error('Não é possível mover o primeiro item', 'O nó sempre é inserido no item que está acima dele e ' +
                        'neste caso, o item selecionado é o primeiro da lista, não tendo nenhum acima dele.');
                    return;
                }
                this.menuService.changeParentToChildren(parent, indexOfItem).subscribe(function (r) {
                    selected.Revision++;
                    parent.Menus[indexOfItem - 1].Menus.push(selected);
                    parent.Menus.splice(indexOfItem, 1);
                    parent.Menus.forEach(function (item) {
                        item.Revision++;
                    });
                    _this.setParents(_this.root);
                    _this.refreshTree();
                });
                break;
        }
    };
    /**
     * @private
     * @return {?}
     */
    MenuInputTableComponent.prototype.refreshTree = /**
     * @private
     * @return {?}
     */
    function () {
        this.dataSource.data = null;
        this.dataSource.data = [this.root];
    };
    MenuInputTableComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-menu-input-table',
                    template: "<div class=\"wrapper\">\r\n  <rte-card>\r\n    <mat-card-content>\r\n      <div class=\"mat-elevation-z4\">\r\n        <mat-tree [dataSource]=\"dataSource\" [treeControl]=\"treeControl\" class=\"example-tree\">\r\n            <mat-tree-node *matTreeNodeDef=\"let node\" matTreeNodeToggle>\r\n              <li class=\"mat-tree-node\"\r\n                (click)=\"selectNode(node)\"\r\n                (dblclick)=\"toolbarComponent.editMode(true)\"\r\n                (mouseover)=\"node.hovered = true\"\r\n                (mouseout)=\"node.hovered = false\"\r\n                [ngClass]=\"{hovered: node.hovered, highlighted: node.highlighted, selected: selectionModel.isSelected(node)}\">\r\n                <button mat-icon-button disabled></button>\r\n                {{node.Description}}\r\n              </li>\r\n            </mat-tree-node>\r\n\r\n            <mat-nested-tree-node *matTreeNodeDef=\"let node; when: hasChild\">\r\n              <li>\r\n                <div class=\"mat-tree-node\"\r\n                  (click)=\"selectNode(node)\"\r\n                  (dblclick)=\"toolbarComponent.editMode(true)\"\r\n                  (mouseover)=\"node.hovered = true\"\r\n                  (mouseout)=\"node.hovered = false\"\r\n                  [ngClass]=\"{hovered: node.hovered, highlighted: node.highlighted, selected: selectionModel.isSelected(node)}\">\r\n\r\n                  <button mat-icon-button matTreeNodeToggle\r\n                          [attr.aria-label]=\"'toggle ' + node.Description\">\r\n                    <mat-icon class=\"mat-icon-rtl-mirror\">\r\n                      {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}\r\n                    </mat-icon>\r\n                  </button>\r\n                  {{node.Description}}\r\n                </div>\r\n                <ul [class.example-tree-invisible]=\"!treeControl.isExpanded(node)\">\r\n                  <ng-container matTreeNodeOutlet></ng-container>\r\n                </ul>\r\n              </li>\r\n            </mat-nested-tree-node>\r\n        </mat-tree>\r\n      </div>\r\n    </mat-card-content>\r\n  </rte-card>\r\n</div>",
                    providers: [],
                    styles: [".example-tree-invisible{display:none}.example-tree li,.example-tree ul{margin-top:0;margin-bottom:0;list-style-type:none}.mat-tree-node.hovered{background:#eee}.mat-tree-node.selected{background:#e0e0e0}.mat-tree-node.highlighted{background:#999}.mat-tree-node:hover{cursor:pointer}.custom-button{min-width:unset!important}"]
                }] }
    ];
    /** @nocollapse */
    MenuInputTableComponent.ctorParameters = function () { return [
        { type: RTEAlertService },
        { type: MenuInputService }
    ]; };
    MenuInputTableComponent.propDecorators = {
        toolbarObject: [{ type: Input }],
        toolbarComponent: [{ type: Input }]
    };
    return MenuInputTableComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MenuInputComponent = /** @class */ (function () {
    function MenuInputComponent(service, rteAlertService) {
        this.service = service;
        this.rteAlertService = rteAlertService;
        this.toolbarObject = new RteToolbarViewModel();
        this.showButton = new ShowButton();
        this.toolbarObject = new RteToolbarViewModel();
    }
    /**
     * @return {?}
     */
    MenuInputComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.toolbarObject.current = new MenuInput();
        this.toolbarObject.current.Object.Id = 0;
        this.toolbarObject.searchObject = new MenuInputSearch();
    };
    /**
     * @param {?} beforeSave
     * @return {?}
     */
    MenuInputComponent.prototype.validateBeforeSave = /**
     * @param {?} beforeSave
     * @return {?}
     */
    function (beforeSave) {
        /** @type {?} */
        var validation = this.rteMenuInputForm.getValidation();
        if (validation) {
            beforeSave.cancelSave = true;
            this.rteAlertService.warning('Preencha todos os campos', validation);
        }
    };
    /**
     * @param {?} option
     * @return {?}
     */
    MenuInputComponent.prototype.beforeEditMode = /**
     * @param {?} option
     * @return {?}
     */
    function (option) {
        if (option === true &&
            this.toolbarObject.current.Description === 'Menu') {
            this.rteToolbar.cancelOperation(true);
        }
    };
    /**
     * @param {?} option
     * @return {?}
     */
    MenuInputComponent.prototype.beforeInsertMode = /**
     * @param {?} option
     * @return {?}
     */
    function (option) {
        if (option === true) {
            /** @type {?} */
            var parent_1 = this.rteMenuInputTable.selectionModel.selected[0];
            this.toolbarObject.current.ParentId = parent_1.Id;
            this.toolbarObject.current.SystemId = this.toolbarObject.searchObject.systemId;
            this.toolbarObject.current.LanguageId = this.toolbarObject.searchObject.languageId;
            this.toolbarObject.current.Order = parent_1.Menus.length + 1;
        }
    };
    /**
     * @return {?}
     */
    MenuInputComponent.prototype.isViewing = /**
     * @return {?}
     */
    function () {
        return this.toolbarObject.currentStatus === RteToolbarStatusEnum.Searching;
    };
    MenuInputComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-menu-input',
                    template: "<rte-toolbar [toolbarObject]=\"toolbarObject\" \r\n             [service]=\"service\"\r\n             [KeyDownElementArea]=\"form\"\r\n             (validateBeforeSave)=\"validateBeforeSave($event)\"\r\n             (customizeAfterSave)=\"rteMenuInputForm.customizeAfterSave($event)\"\r\n             (customizeAfterDelete)=\"rteMenuInputForm.customizeAfterDelete($event)\"\r\n             (customizeAfterGet)=\"rteMenuInputTable.setDataTree($event)\"\r\n             [showButton]=\"showButton\"\r\n             (customizeAfterEditMode)=\"beforeEditMode($event)\"\r\n             (customizeAfterInsertMode)=\"beforeInsertMode($event)\"\r\n             #rteToolbar>\r\n\r\n  <div *ngIf=\"isViewing()\">\r\n      <button\r\n      (click)=\"rteMenuInputTable.changeOrder(rteMenuInputTable.left);\"\r\n      rtebutton\r\n      class=\"custom-button\"\r\n      matTooltip=\"Antecipar item do mesmo n\u00EDvel\"\r\n      [disabled]=\"!!rteMenuInputTable && !rteMenuInputTable.selectionModel.hasValue()\">\r\n  \r\n      <mat-icon>\r\n        keyboard_arrow_left\r\n      </mat-icon>\r\n    </button>\r\n  \r\n    <button\r\n      (click)=\"rteMenuInputTable.changeOrder(rteMenuInputTable.right);\"\r\n      rtebutton\r\n      class=\"custom-button\"\r\n      matTooltip=\"Postergar item do mesmo n\u00EDvel\"\r\n      [disabled]=\"!!rteMenuInputTable && !rteMenuInputTable.selectionModel.hasValue()\">\r\n      \r\n      <mat-icon>\r\n        keyboard_arrow_right\r\n      </mat-icon>\r\n    </button>\r\n    <button \r\n      (click)=\"rteMenuInputTable.changeParent(rteMenuInputTable.father);\"\r\n      rtebutton\r\n      class=\"custom-button\"\r\n      matTooltip=\"Mover item para n\u00EDvel acima\"\r\n      [disabled]=\"!!rteMenuInputTable && !rteMenuInputTable.selectionModel.hasValue()\">\r\n  \r\n      <mat-icon>\r\n        keyboard_arrow_up\r\n      </mat-icon>\r\n    </button>\r\n  \r\n    <button \r\n      (click)=\"rteMenuInputTable.changeParent(rteMenuInputTable.children);\"\r\n      rtebutton\r\n      class=\"custom-button\"\r\n      matTooltip=\"Mover item para n\u00EDvel abaixo\"\r\n      [disabled]=\"!!rteMenuInputTable && !rteMenuInputTable.selectionModel.hasValue()\">\r\n  \r\n      <mat-icon>\r\n        keyboard_arrow_down\r\n      </mat-icon>\r\n    </button>\r\n  </div>\r\n  \r\n</rte-toolbar>\r\n\r\n<div class=\"wrapper\">   \r\n  <rte-app-title></rte-app-title>\r\n</div>\r\n\r\n<div #form>\r\n  <rte-app-menu-input-search [toolbarObject]=\"toolbarObject\" *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n  </rte-app-menu-input-search>\r\n\r\n  <rte-app-menu-input-table #rteMenuInputTable [toolbarObject]=\"toolbarObject\" [toolbarComponent]=\"rteToolbar\" *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n  </rte-app-menu-input-table>\r\n\r\n  <rte-app-menu-input-form #rteMenuInputForm [toolbarObject]=\"toolbarObject\" [hidden]=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n  </rte-app-menu-input-form>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    MenuInputComponent.ctorParameters = function () { return [
        { type: MenuInputService },
        { type: RTEAlertService }
    ]; };
    MenuInputComponent.propDecorators = {
        rteMenuInputForm: [{ type: ViewChild, args: ['rteMenuInputForm', { read: MenuInputFormComponent },] }],
        rteMenuInputTable: [{ type: ViewChild, args: ['rteMenuInputTable', { read: MenuInputTableComponent },] }],
        rteToolbar: [{ type: ViewChild, args: ['rteToolbar',] }]
    };
    return MenuInputComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LanguageService = /** @class */ (function () {
    function LanguageService(http, environment) {
        this.http = http;
        this.environment = environment;
    }
    /**
     * @return {?}
     */
    LanguageService.prototype.getAll = /**
     * @return {?}
     */
    function () {
        return this.http.get(this.environment.apiCore + 'webapi/language/getall');
    };
    LanguageService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    LanguageService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['environment',] }] }
    ]; };
    /** @nocollapse */ LanguageService.ngInjectableDef = defineInjectable({ factory: function LanguageService_Factory() { return new LanguageService(inject(HttpClient), inject("environment")); }, token: LanguageService, providedIn: "root" });
    return LanguageService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MenuInputSearchComponent = /** @class */ (function () {
    function MenuInputSearchComponent(systemService, languageService) {
        this.systemService = systemService;
        this.languageService = languageService;
    }
    /**
     * @return {?}
     */
    MenuInputSearchComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.systemService.getAll().subscribe(function (r) { return _this.systemList = r; });
        this.languageService.getAll().subscribe(function (r) { return _this.languageList = r; });
    };
    MenuInputSearchComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-menu-input-search',
                    template: "<div class=\"wrapper\">\r\n    <rte-card>\r\n        <mat-card-content>\r\n            <form #formFilterRules=\"ngForm\" autocomplete=\"off\">\r\n                <div class=\"row-form\">\r\n                    <div class=\"column-form\">\r\n                        <rte-form-field class=\"example-full-width\">\r\n                            <rte-select placeholder=\"Sistema\" [(ngModel)]=\"toolbarObject.searchObject.systemId\" name=\"system\" required>\r\n                                <rte-option *ngFor=\"let item of systemList\" [value]=\"item.Id\">\r\n                                    {{ item.Description }}\r\n                                </rte-option>\r\n                            </rte-select>\r\n                        </rte-form-field>\r\n                    </div>\r\n\r\n                    <div class=\"column-form\">\r\n                        <rte-form-field class=\"example-full-width\">\r\n                            <rte-select placeholder=\"L\u00EDngua\" [(ngModel)]=\"toolbarObject.searchObject.languageId\" name=\"language\" required>\r\n                                <rte-option *ngFor=\"let item of languageList\" [value]=\"item.Id\">\r\n                                    {{ item.Description }}\r\n                                </rte-option>\r\n                            </rte-select>\r\n                        </rte-form-field>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n        </mat-card-content>\r\n    </rte-card>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    MenuInputSearchComponent.ctorParameters = function () { return [
        { type: SystemService },
        { type: LanguageService }
    ]; };
    MenuInputSearchComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return MenuInputSearchComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteMenuInputModule = /** @class */ (function () {
    function RteMenuInputModule() {
    }
    /**
     * @param {?} environment
     * @return {?}
     */
    RteMenuInputModule.forRoot = /**
     * @param {?} environment
     * @return {?}
     */
    function (environment) {
        return {
            ngModule: RteMenuInputModule,
            providers: [
                MenuInputService,
                {
                    provide: 'environment',
                    useValue: environment
                }
            ]
        };
    };
    RteMenuInputModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        RteToolbarModule,
                        RteAppTitleModule,
                        RteMaterialModule,
                        MatRippleModule,
                        MatCheckboxModule,
                        MatSelectModule,
                        MatOptionModule,
                        MatListModule,
                        MatTableModule,
                        MatIconModule,
                        MatAutocompleteModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatProgressSpinnerModule,
                        MatToolbarModule,
                        MatDialogModule,
                        MatCardModule,
                        CdkTableModule,
                        MatDividerModule,
                        MatExpansionModule,
                        FormsModule,
                        MatTooltipModule,
                        MatTreeModule,
                        MatButtonModule,
                        DragDropModule
                    ],
                    declarations: [MenuInputComponent, MenuInputFormComponent, MenuInputTableComponent, MenuInputSearchComponent],
                    exports: [MenuInputComponent]
                },] }
    ];
    return RteMenuInputModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Parameter = /** @class */ (function () {
    function Parameter() {
        this.Items = [];
        this.Attributes = [];
    }
    return Parameter;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParameterAttribute = /** @class */ (function () {
    function ParameterAttribute() {
    }
    return ParameterAttribute;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AttributesDialogComponent = /** @class */ (function () {
    function AttributesDialogComponent(dialogRef, data, alert) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.alert = alert;
        this.attribute = new ParameterAttribute();
        if (data != undefined) {
            if (data.attribute != undefined) {
                this.attribute = data.attribute;
            }
            this.toolbarObject = data.toolbarObject;
        }
    }
    /**
     * @return {?}
     */
    AttributesDialogComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    AttributesDialogComponent.prototype.close = /**
     * @return {?}
     */
    function () {
        this.dialogRef.close();
    };
    /**
     * @return {?}
     */
    AttributesDialogComponent.prototype.save = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var validation = this.getValidation();
        if (validation) {
            this.alert.warning(validation, null, { tapToDismiss: true, timeOut: 3000, extendedTimeOut: 1000 });
            return;
        }
        this.dialogRef.close(this.attribute);
    };
    /**
     * @return {?}
     */
    AttributesDialogComponent.prototype.getValidation = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var validationMessage = '';
        validationMessage = !this.attribute.Description ? 'Insira a descrição do parâmetro.' : '';
        return validationMessage;
    };
    AttributesDialogComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-attributes-dialog',
                    template: "<h3 rte-dialog-title class=\"mat-dialog-title\">Atributos do Par\u00E2metro</h3>\r\n<mat-dialog-content class=\"mat-typography mat-dialog-content-style\">\r\n  <form #formAttribute>\r\n    <div class=\"row-form form-div\">\r\n      <div class=\"column-form\">\r\n        <rte-form-field class=\"example-full-width\">\r\n          <input \r\n            rteInput \r\n            placeholder=\"C\u00F3digo\" \r\n            type=\"number\"\r\n            name=\"Code\"\r\n            [(ngModel)]=\"toolbarObject.current.Id\"\r\n            readonly>\r\n        </rte-form-field>\r\n      </div>\r\n      <div class=\"column-form\">\r\n        <rte-form-field class=\"example-full-width\">\r\n          <input \r\n            rteInput \r\n            placeholder=\"Par\u00E2metro\" \r\n            name=\"Parameter\"\r\n            [(ngModel)]=\"toolbarObject.current.Description\"\r\n            readonly>\r\n        </rte-form-field>\r\n      </div>\r\n    </div>\r\n    \r\n    <div class=\"row-form\">\r\n      <div class=\"column-form\">\r\n        <rte-form-field class=\"example-full-width\">\r\n          <input \r\n            rteInput \r\n            placeholder=\"Descri\u00E7\u00E3o\" \r\n            name=\"Description\"\r\n            required\r\n            [(ngModel)]=\"attribute.Description\">\r\n        </rte-form-field>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row-form\">\r\n      <div class=\"column-form\">\r\n        <rte-form-field class=\"example-full-width\">\r\n          <textarea \r\n            placeholder=\"Observa\u00E7\u00E3o\" \r\n            type=\"text\" \r\n            rteInput \r\n            rows=\"5\" \r\n            name=\"Observation\"\r\n            [(ngModel)]=\"attribute.Comment\">\r\n          </textarea>\r\n        </rte-form-field>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</mat-dialog-content>\r\n<div class=\"div-actions\">\r\n  <mat-dialog-actions>\r\n    <button rtebutton-raised (click)=\"close()\">Cancelar</button>\r\n    <button id=\"save\" rtebutton-raised color=\"primary\" (click)=\"save()\">Salvar</button>\r\n  </mat-dialog-actions>\r\n</div>",
                    styles: ["button{border-radius:4px}#save{min-width:0}.mat-dialog-title{background-color:#f5f5f5;padding:20px 30px!important;margin:-24px!important;font-size:20px}.form-div{margin-top:50px!important}.div-actions{background-color:#f5f5f5;font-size:20px;margin-left:-24px;margin-right:-24px}mat-dialog-actions{padding-right:20px!important}mat-dialog-actions:first-child{justify-content:flex-end!important}"]
                }] }
    ];
    /** @nocollapse */
    AttributesDialogComponent.ctorParameters = function () { return [
        { type: MatDialogRef },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] },
        { type: RTEAlertService }
    ]; };
    return AttributesDialogComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParameterAttributesComponent = /** @class */ (function () {
    function ParameterAttributesComponent(dialog, alert) {
        this.dialog = dialog;
        this.alert = alert;
        this.dataSource = new MatTableDataSource();
        this.selection = new SelectionModel(true, []);
        this.displayedColumns = ['Id', 'Description'];
    }
    /**
     * @return {?}
     */
    ParameterAttributesComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.showButton = new ShowToolbarMinorButton();
    };
    /**
     * @return {?}
     */
    ParameterAttributesComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.fileNameDialogRef = null;
        this.dataSource = null;
    };
    /**
     * @param {?} action
     * @return {?}
     */
    ParameterAttributesComponent.prototype.openDialog = /**
     * @param {?} action
     * @return {?}
     */
    function (action) {
        var _this = this;
        if (action === 'edit' && this.selection.selected.length == 0) {
            this.alert.warning('Selecione um item para edição.', null, { timeOut: 2000, extendedTimeOut: 1000 });
        }
        else {
            /** @type {?} */
            var dialogConfig = new MatDialogConfig();
            dialogConfig.autoFocus = true;
            dialogConfig.hasBackdrop = true;
            dialogConfig.data = {
                attribute: action === 'insert' ? new ParameterAttribute() : this.selection.selected[0],
                toolbarObject: this.toolbarObject
            };
            this.fileNameDialogRef = this.dialog.open(AttributesDialogComponent, dialogConfig);
            this.fileNameDialogRef
                .afterClosed()
                .pipe(filter(function (attribute) { return attribute; }))
                .subscribe(function (attribute) {
                if (action === 'insert') {
                    /** @type {?} */
                    var newItem = _this.toolbarObject.current.Attributes.slice(0);
                    newItem.push(attribute);
                    _this.toolbarObject.current.Attributes = newItem;
                    _this.dataSource.data = _this.toolbarObject.current.Attributes;
                }
            });
        }
    };
    /**
     * @param {?} row
     * @return {?}
     */
    ParameterAttributesComponent.prototype.selectRow = /**
     * @param {?} row
     * @return {?}
     */
    function (row) {
        if (this.selection.isSelected(row) == false)
            this.selection.toggle(row);
    };
    /**
     * @return {?}
     */
    ParameterAttributesComponent.prototype.removeItem = /**
     * @return {?}
     */
    function () {
        if (this.selection.selected.length > 0) {
            /** @type {?} */
            var rowIndex = this.toolbarObject.current.Attributes.indexOf(this.selection.selected[0]);
            /** @type {?} */
            var newAttributes = this.toolbarObject.current.Attributes.slice(0);
            newAttributes.splice(rowIndex, 1);
            this.toolbarObject.current.Attributes = newAttributes;
            this.dataSource.data = this.toolbarObject.current.Attributes;
        }
        else {
            this.alert.warning('Selecione um item para remoção.');
        }
    };
    /**
     * @return {?}
     */
    ParameterAttributesComponent.prototype.onBrowserOrEditMode = /**
     * @return {?}
     */
    function () {
        return this.isBrowserOrEditMode;
    };
    ParameterAttributesComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-parameter-attributes',
                    template: "<div class=\"wrapper\">\r\n  <mat-expansion-panel>\r\n    <mat-expansion-panel-header style=\"background-color: #F5F5F5\">\r\n      <mat-panel-title>\r\n        Atributos do Par\u00E2metro\r\n      </mat-panel-title>\r\n    </mat-expansion-panel-header>\r\n    <div class=\"row-form\">\r\n      <div class=\"column-form\">\r\n        <rte-toolbar-minor\r\n          #toolbarMinor\r\n          (addEvent)=\"openDialog('insert')\"\r\n          (editEvent)=\"openDialog('edit')\"\r\n          [showButton]=\"showButton\">\r\n        </rte-toolbar-minor>\r\n      </div>\r\n    </div>\r\n    <div class=\"column-form\">\r\n      <rte-table [dataSource]=\"toolbarObject.current.Attributes\" class=\"rte-table-attributes mat-elevation-z4\">\r\n        <ng-container rteColumnDef=\"Id\">\r\n          <rte-header-cell *rteHeaderCellDef>Atributo</rte-header-cell>\r\n          <rte-cell *rteCellDef=\"let parameterAttribute\">{{parameterAttribute.Id ? parameterAttribute.Id : '0'}}</rte-cell>\r\n        </ng-container>\r\n  \r\n        <ng-container rteColumnDef=\"Description\">\r\n          <rte-header-cell *rteHeaderCellDef>Descri\u00E7\u00E3o</rte-header-cell>\r\n          <rte-cell *rteCellDef=\"let parameterAttribute\">{{parameterAttribute.Description}}</rte-cell>\r\n        </ng-container>\r\n        <rte-header-row *rteHeaderRowDef=\"displayedColumns\"></rte-header-row>\r\n        <rte-row *rteRowDef=\"let row; columns: displayedColumns;\" (click)=\"selectRow(row)\"\r\n                 (dblclick)=\"openDialog('edit')\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"\r\n                 [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted, selected: toolbarObject.selectionModel.isSelected(row)}\">\r\n        </rte-row>\r\n      </rte-table>\r\n    </div>\r\n  </mat-expansion-panel>\r\n</div>",
                    styles: [".card-header-attributes{margin-left:-15px;margin-right:-15px;padding:0}.rte-table-attributes{padding-bottom:15px!important}.rte-attribute-card{padding-top:0!important}"]
                }] }
    ];
    /** @nocollapse */
    ParameterAttributesComponent.ctorParameters = function () { return [
        { type: MatDialog },
        { type: RTEAlertService }
    ]; };
    ParameterAttributesComponent.propDecorators = {
        toolbarObject: [{ type: Input }],
        isBrowserOrEditMode: [{ type: Input }]
    };
    return ParameterAttributesComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Language = /** @class */ (function () {
    function Language() {
    }
    return Language;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParameterItem = /** @class */ (function () {
    function ParameterItem() {
        this.Language = new Language();
        this.Attributes = [];
    }
    return ParameterItem;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DetailsDialogComponent = /** @class */ (function () {
    function DetailsDialogComponent(dialogRef, data, alert) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.alert = alert;
        this.item = new ParameterItem();
        this.selection = new SelectionModel(true, []);
        this.languages = [];
        this.displayedColumns = ['Id', 'Description', 'Value'];
        this.currentAttributes = [];
        if (data != undefined) {
            if (data.item !== undefined) {
                this.item = data.item;
            }
            if (data.languages !== undefined) {
                this.languages = data.languages;
            }
            this.toolbarObject = data.toolbarObject;
        }
    }
    /**
     * @return {?}
     */
    DetailsDialogComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.toolbarObject.current.Attributes.length > 0 &&
            this.item.Attributes.length <= 0) {
            this.item.Attributes = this.toolbarObject.current.Attributes;
        }
        this.item.Attributes.forEach(function (item) {
            _this.currentAttributes.push(item.Value);
        });
    };
    /**
     * @return {?}
     */
    DetailsDialogComponent.prototype.close = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var counter = 0;
        this.currentAttributes.forEach(function (item) {
            _this.item.Attributes[counter].Value = item;
            counter++;
        });
        this.dialogRef.close();
    };
    /**
     * @return {?}
     */
    DetailsDialogComponent.prototype.save = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var validation = this.getValidation();
        if (validation) {
            this.alert.warning(validation, null, { tapToDismiss: true, timeOut: 3000, extendedTimeOut: 1000 });
            return;
        }
        this.item.Language = this.languages.find(function (p) { return p.Id === _this.item.Language.Id; });
        this.dialogRef.close(this.item);
    };
    /**
     * @return {?}
     */
    DetailsDialogComponent.prototype.getValidation = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var validationMessage = '';
        validationMessage = !this.item.Description ? 'Insira a descrição do parâmetro.' : '';
        if (!validationMessage) {
            validationMessage = this.item.Language.Id <= 0 ? 'Selecione o idioma.' : '';
        }
        if (!validationMessage) {
            validationMessage = !this.item.Value ? 'Insira o valor do parâmetro.' : '';
        }
        return validationMessage;
    };
    DetailsDialogComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-details-dialog',
                    template: "<h3 rte-dialog-title class=\"mat-dialog-title\">Cadastro de \u00CDtens do Par\u00E2metro</h3>\r\n<mat-dialog-content style=\"width: 900px\" class=\"mat-typography mat-dialog-content-style\">\r\n  <form #formAttribute>\r\n    <div class=\"row-form form-div\">\r\n      <div class=\"column-form\">\r\n        <rte-form-field class=\"example-full-width\">\r\n          <input \r\n            rteInput \r\n            placeholder=\"C\u00F3digo\" \r\n            type=\"number\"\r\n            name=\"Code\"\r\n            [(ngModel)]=\"toolbarObject.current.Id\"\r\n            readonly>\r\n        </rte-form-field>\r\n      </div>\r\n\r\n      <div class=\"column-form\">\r\n        <rte-form-field class=\"example-full-width\">\r\n          <input \r\n            rteInput \r\n            placeholder=\"Par\u00E2metro\" \r\n            name=\"Parameter\"\r\n            [(ngModel)]=\"toolbarObject.current.Description\"\r\n            readonly>\r\n        </rte-form-field>\r\n      </div>\r\n    </div>\r\n    \r\n    <div class=\"row-form\">\r\n      <div class=\"column-form\">\r\n        <rte-form-field class=\"example-full-width\">\r\n          <input \r\n            rteInput \r\n            placeholder=\"Descri\u00E7\u00E3o\" \r\n            name=\"Description\"\r\n            required\r\n            [(ngModel)]=\"item.Description\">\r\n        </rte-form-field>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row-form\">\r\n      <div class=\"column-form\">\r\n        <rte-form-field class=\"example-full-width\">\r\n          <mat-label>Idioma</mat-label>\r\n          <rte-select name=\"Languages\" required [(ngModel)]=\"this.item.Language.Id\">\r\n            <rte-option *ngFor=\"let language of languages\" [value]=\"language.Id\">\r\n              {{language.Description}}\r\n            </rte-option>\r\n          </rte-select>\r\n        </rte-form-field>\r\n      </div>\r\n\r\n      <div class=\"column-form\">\r\n        <rte-form-field class=\"example-full-width\">\r\n          <input \r\n            rteInput \r\n            placeholder=\"Valor\" \r\n            name=\"Value\"\r\n            required\r\n            [(ngModel)]=\"item.Value\"\r\n            maxlength=\"5\">\r\n        </rte-form-field>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row-form\">\r\n      <div class=\"column-form\">\r\n        <rte-form-field class=\"example-full-width\">\r\n          <textarea \r\n            placeholder=\"Observa\u00E7\u00E3o\" \r\n            type=\"text\" \r\n            rteInput \r\n            rows=\"2\" \r\n            name=\"Observation\"\r\n            [(ngModel)]=\"item.Comment\">\r\n          </textarea>\r\n        </rte-form-field>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"column-form\">\r\n      <rte-card class=\"mat-elevation-z3\">\r\n        <mat-card-title>\r\n          <h3 rte-dialog-title class=\"rte-card-title\">Valor dos Atributos para o Item</h3>\r\n        </mat-card-title>\r\n        <mat-card-content>\r\n          <div class=\"column-form\">\r\n            <rte-table [dataSource]=\"item.Attributes\" class=\"mat-elevation-z4\">\r\n              <ng-container rteColumnDef=\"Id\">\r\n                <rte-header-cell *rteHeaderCellDef>Atributo</rte-header-cell>\r\n                <rte-cell *rteCellDef=\"let parameterAttribute\">{{parameterAttribute.Id ? parameterAttribute.Id : '0'}}</rte-cell>\r\n              </ng-container>\r\n        \r\n              <ng-container rteColumnDef=\"Description\">\r\n                <rte-header-cell *rteHeaderCellDef>Descri\u00E7\u00E3o</rte-header-cell>\r\n                <rte-cell *rteCellDef=\"let parameterAttribute\">\r\n                  {{parameterAttribute.Description}}\r\n                </rte-cell>\r\n              </ng-container>\r\n        \r\n              <ng-container rteColumnDef=\"Value\">\r\n                <rte-header-cell *rteHeaderCellDef>Valor</rte-header-cell>\r\n                <rte-cell *rteCellDef=\"let parameterAttribute\">\r\n        \r\n                <editable>\r\n                  <ng-template viewMode>\r\n                    {{parameterAttribute.Value == null ? 'Insira um valor' : parameterAttribute.Value}}\r\n                  </ng-template>\r\n                  <ng-template editMode>\r\n                    <input [(ngModel)]=\"parameterAttribute.Value\" name=\"ValueInput\" focusable editableOnEnter>\r\n                  </ng-template>\r\n                </editable> \r\n        \r\n                </rte-cell>\r\n              </ng-container>\r\n              <rte-header-row *rteHeaderRowDef=\"displayedColumns\"></rte-header-row>\r\n              <rte-row *rteRowDef=\"let row; columns: displayedColumns;\"\r\n                        (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"\r\n                        [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted, selected: toolbarObject.selectionModel.isSelected(row)}\">\r\n              </rte-row>\r\n            </rte-table>\r\n          </div>\r\n        </mat-card-content>\r\n      </rte-card>\r\n      \r\n    </div>\r\n  </form>\r\n</mat-dialog-content>\r\n<div class=\"div-actions\">\r\n  <mat-dialog-actions>\r\n    <button rtebutton-raised (click)=\"close()\">Cancelar</button>\r\n    <button id=\"save\" rtebutton-raised color=\"primary\" (click)=\"save()\">Salvar</button>\r\n  </mat-dialog-actions>\r\n</div>",
                    styles: ["button{border-radius:4px}#save{min-width:0}.mat-dialog-title{background-color:#f5f5f5;padding:20px 30px!important;font-size:20px;margin:-30px -24px 0!important}.rte-card-title{background-color:#f5f5f5;padding:20px 30px!important;font-size:20px;margin:-30px -15px 50px!important}.form-div{margin-top:50px!important}.div-actions{background-color:#f5f5f5;font-size:20px;margin-left:-24px;margin-right:-24px}.mat-dialog-content-style{padding-bottom:20px}mat-dialog-actions{padding-right:20px!important}mat-dialog-actions:first-child{justify-content:flex-end!important}"]
                }] }
    ];
    /** @nocollapse */
    DetailsDialogComponent.ctorParameters = function () { return [
        { type: MatDialogRef },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] },
        { type: RTEAlertService }
    ]; };
    return DetailsDialogComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteParameterService = /** @class */ (function () {
    function RteParameterService(http, environment) {
        this.http = http;
        this.environment = environment;
    }
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    RteParameterService.prototype.clear = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        objectCurrent.Id = 0;
        objectCurrent.Description = null;
        objectCurrent.Comment = null;
        objectCurrent.Items = [];
        objectCurrent.Attributes = [];
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    RteParameterService.prototype.save = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        if (objectCurrent.Id) {
            return this.http.put(this.environment.apiCore + 'webapi/parameter', objectCurrent);
        }
        else {
            return this.http.post(this.environment.apiCore + 'webapi/parameter', objectCurrent);
        }
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    RteParameterService.prototype.delete = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        return this.http.delete(this.environment.apiCore + 'webapi/parameter/' + objectCurrent.Id);
    };
    /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    RteParameterService.prototype.get = /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    function (objectCurrent, page, pageSize) {
        page++;
        /** @type {?} */
        var params = new HttpParams()
            .set('page', page.toString())
            .set('amountByPage', pageSize.toString());
        if (objectCurrent) {
            params = this.appendHttpParams('Description', objectCurrent.Description, params);
            params = this.appendHttpParams('Comment', objectCurrent.Comment, params);
            params = this.appendHttpParams('LanguageId', 1, params);
        }
        return this.http.get(this.environment.apiCore + 'webapi/parameter/getbyfilters', { params: params });
    };
    /**
     * @return {?}
     */
    RteParameterService.prototype.getAllLanguages = /**
     * @return {?}
     */
    function () {
        return this.http.get(this.environment.apiCore + 'webapi/language/getall');
    };
    /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    RteParameterService.prototype.appendHttpParams = /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    function (name, value, params) {
        return params.append(name, !value ? '' : value);
    };
    RteParameterService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    RteParameterService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['environment',] }] }
    ]; };
    /** @nocollapse */ RteParameterService.ngInjectableDef = defineInjectable({ factory: function RteParameterService_Factory() { return new RteParameterService(inject(HttpClient), inject("environment")); }, token: RteParameterService, providedIn: "root" });
    return RteParameterService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParameterDetailsComponent = /** @class */ (function () {
    function ParameterDetailsComponent(dialog, alert, service) {
        this.dialog = dialog;
        this.alert = alert;
        this.service = service;
        this.dataSource = new MatTableDataSource();
        this.selection = new SelectionModel(false, []);
        this.subscription = new Subscription();
        this.displayedColumns = ['Select', 'Id', 'Language', 'Description', 'Value'];
        this.attributesDisplayedColumns = ['Id', 'Description', 'Value'];
        this.languages = [];
    }
    /**
     * @return {?}
     */
    ParameterDetailsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.showButton = new ShowToolbarMinorButton();
        this.subscription = this.service.getAllLanguages().subscribe(function (items) {
            _this.languages = items;
        });
    };
    /**
     * @return {?}
     */
    ParameterDetailsComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.fileNameDialogRef = null;
        this.dataSource = null;
        this.subscription.unsubscribe();
    };
    /**
     * @param {?} action
     * @return {?}
     */
    ParameterDetailsComponent.prototype.openDialog = /**
     * @param {?} action
     * @return {?}
     */
    function (action) {
        var _this = this;
        if (this.toolbarObject.currentStatus !== this.toolbarObject.possibleStatus.Viewing)
            if (action === 'edit' && this.selection.selected.length == 0) {
                this.alert.warning('Selecione um item para edição.', null, { timeOut: 2000, extendedTimeOut: 1000 });
            }
            else {
                /** @type {?} */
                var dialogConfig = new MatDialogConfig();
                dialogConfig.autoFocus = true;
                dialogConfig.hasBackdrop = true;
                dialogConfig.data = {
                    item: action === 'insert' ? new ParameterItem() : this.selection.selected[0],
                    languages: this.languages,
                    toolbarObject: this.toolbarObject
                };
                this.fileNameDialogRef = this.dialog.open(DetailsDialogComponent, dialogConfig);
                this.fileNameDialogRef
                    .afterClosed()
                    .pipe(filter(function (item) { return item; }))
                    .subscribe(function (item) {
                    if (action === 'insert') {
                        /** @type {?} */
                        var newItem = _this.toolbarObject.current.Items.slice(0);
                        newItem.push(item);
                        _this.toolbarObject.current.Items = newItem;
                        _this.dataSource.data = _this.toolbarObject.current.Items;
                    }
                });
            }
    };
    /**
     * @param {?} row
     * @return {?}
     */
    ParameterDetailsComponent.prototype.selectRow = /**
     * @param {?} row
     * @return {?}
     */
    function (row) {
        if (this.selection.isSelected(row) == false) {
            this.selection.toggle(row);
        }
    };
    /**
     * @return {?}
     */
    ParameterDetailsComponent.prototype.removeItem = /**
     * @return {?}
     */
    function () {
        if (this.selection.selected.length > 0) {
            /** @type {?} */
            var rowIndex = this.toolbarObject.current.Items.indexOf(this.selection.selected[0]);
            /** @type {?} */
            var newItems = this.toolbarObject.current.Items.slice(0);
            newItems.splice(rowIndex, 1);
            this.toolbarObject.current.Items = newItems;
            this.dataSource.data = this.toolbarObject.current.Items;
        }
        else {
            this.alert.warning('Selecione um item para remoção.');
        }
    };
    /**
     * @return {?}
     */
    ParameterDetailsComponent.prototype.onBrowserOrEditMode = /**
     * @return {?}
     */
    function () {
        return this.isBrowserOrEditMode;
    };
    /**
     * @param {?} row
     * @return {?}
     */
    ParameterDetailsComponent.prototype.expandRow = /**
     * @param {?} row
     * @return {?}
     */
    function (row) {
        if (row === this.expandedElement) {
            row.Icon = '';
            this.expandedElement = null;
        }
        else {
            row.Icon = 'arrow_drop_down';
            this.expandedElement = row;
        }
    };
    ParameterDetailsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-parameter-details',
                    template: "<div class=\"wrapper\">\r\n  <mat-expansion-panel>\r\n    <mat-expansion-panel-header style=\"background-color: #F5F5F5\">\r\n      <mat-panel-title>\r\n        Detalhes do Par\u00E2metro\r\n      </mat-panel-title>\r\n    </mat-expansion-panel-header>\r\n    <div class=\"row-form\">\r\n      <div class=\"column-form\">\r\n        <rte-toolbar-minor\r\n          #toolbarMinor\r\n          (addEvent)=\"openDialog('insert')\"\r\n          (editEvent)=\"openDialog('edit')\"\r\n          (removeEvent)=\"removeItem()\"\r\n          [showButton]=\"showButton\">\r\n        </rte-toolbar-minor>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"column-form\">\r\n      <table rte-table [dataSource]=\"toolbarObject.current.Items\" \r\n             multiTemplateDataRows class=\"mat-elevation-z4\">\r\n        <ng-container rteColumnDef=\"Select\">\r\n          <rte-header-cell class=\"rte-header-cell\" *rteHeaderCellDef></rte-header-cell>\r\n          <rte-cell class=\"rte-cell\" *rteCellDef=\"let row\">\r\n            <rte-icon style=\"cursor: pointer;\" (click)=\"expandRow(row)\">{{row.Icon ? row.Icon : 'arrow_right'}}</rte-icon>\r\n          </rte-cell>\r\n        </ng-container>\r\n\r\n        <ng-container rteColumnDef=\"Id\">\r\n          <rte-header-cell *rteHeaderCellDef>Item</rte-header-cell>\r\n          <rte-cell *rteCellDef=\"let parameterItem\">{{parameterItem.Id ? parameterItem.Id : '0'}}</rte-cell>\r\n        </ng-container>\r\n\r\n        <ng-container rteColumnDef=\"Language\">\r\n          <rte-header-cell *rteHeaderCellDef>Idioma</rte-header-cell>\r\n          <rte-cell *rteCellDef=\"let parameterItem\">{{parameterItem.Language?.Description}}</rte-cell>\r\n        </ng-container>\r\n\r\n        <ng-container rteColumnDef=\"Description\">\r\n          <rte-header-cell *rteHeaderCellDef>Descri\u00E7\u00E3o</rte-header-cell>\r\n          <rte-cell *rteCellDef=\"let parameterItem\">{{parameterItem.Description}}</rte-cell>\r\n        </ng-container>\r\n\r\n        <ng-container rteColumnDef=\"Value\">\r\n          <rte-header-cell *rteHeaderCellDef>Valor</rte-header-cell>\r\n          <rte-cell *rteCellDef=\"let parameterItem\">{{parameterItem.Value}}</rte-cell>\r\n        </ng-container>\r\n\r\n        <ng-container rteColumnDef=\"expandedDetail\">\r\n          <td rte-cell *rteCellDef=\"let element\" [attr.colspan]=\"displayedColumns.length\">\r\n            <div class=\"example-element-detail\"\r\n                 [@detailExpand]=\"element == expandedElement ? 'expanded' : 'collapsed'\">\r\n              <table rte-table [dataSource]=\"element.Attributes\">\r\n                <ng-container rteColumnDef=\"Id\">\r\n                  <rte-header-cell *rteHeaderCellDef>Atributo</rte-header-cell>\r\n                  <rte-cell *rteCellDef=\"let parameterAttribute\">{{parameterAttribute.Id ? parameterAttribute.Id : '0'}}</rte-cell>\r\n                </ng-container>\r\n          \r\n                <ng-container rteColumnDef=\"Description\">\r\n                  <rte-header-cell *rteHeaderCellDef>Descri\u00E7\u00E3o</rte-header-cell>\r\n                  <rte-cell *rteCellDef=\"let parameterAttribute\">{{parameterAttribute.Description}}</rte-cell>\r\n                </ng-container>\r\n\r\n                <ng-container rteColumnDef=\"Value\">\r\n                  <rte-header-cell *rteHeaderCellDef>Valor</rte-header-cell>\r\n                  <rte-cell *rteCellDef=\"let parameterAttribute\">{{parameterAttribute.Value}}</rte-cell>\r\n                </ng-container>\r\n\r\n                <rte-header-row *rteHeaderRowDef=\"attributesDisplayedColumns\"></rte-header-row>\r\n                <rte-row *rteRowDef=\"let row; columns: attributesDisplayedColumns;\" class=\"example-detail-row\"></rte-row>\r\n              </table>\r\n            </div>\r\n          </td>\r\n        </ng-container>\r\n\r\n        <rte-header-row *rteHeaderRowDef=\"displayedColumns\"></rte-header-row>\r\n        <rte-row *rteRowDef=\"let row; columns: displayedColumns;\" \r\n                 (click)=\"selectRow(row);\" [class.example-expanded-row]=\"expandedElement === row\"\r\n                 (dblclick)=\"openDialog('edit')\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"\r\n                 [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted, selected: toolbarObject.selectionModel.isSelected(row)}\">\r\n        </rte-row>\r\n        <tr rte-row *rteRowDef=\"let row; columns: ['expandedDetail']\" class=\"example-detail-row\"></tr>\r\n      </table>\r\n    </div>\r\n  </mat-expansion-panel>\r\n</div>",
                    animations: [
                        trigger('detailExpand', [
                            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
                            state('expanded', style({ height: '*' })),
                            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
                        ]),
                    ],
                    styles: [".rte-table-details{padding-bottom:15px!important}table{width:100%!important}.rte-parameter-card{padding-top:0!important}.card-header-parameters{margin-left:-15px;margin-right:-15px;padding:0}tr.example-detail-row{height:0}tr.example-element-row:not(.example-expanded-row):hover{background:#f5f5f5}tr.example-element-row:not(.example-expanded-row):active{background:#efefef}.example-element-row td{border-bottom-width:0}.example-element-detail{overflow:hidden;display:flex!important}.rte-cell:nth-child(1),.rte-header-cell:nth-child(1){flex:0 0 7%;justify-content:start}.center-cell,.center-header-cell{justify-content:center}"]
                }] }
    ];
    /** @nocollapse */
    ParameterDetailsComponent.ctorParameters = function () { return [
        { type: MatDialog },
        { type: RTEAlertService },
        { type: RteParameterService }
    ]; };
    ParameterDetailsComponent.propDecorators = {
        toolbarObject: [{ type: Input }],
        isBrowserOrEditMode: [{ type: Input }]
    };
    return ParameterDetailsComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParameterFormComponent = /** @class */ (function () {
    function ParameterFormComponent(rteAlertService) {
        this.rteAlertService = rteAlertService;
    }
    /**
     * @return {?}
     */
    ParameterFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} afterSave
     * @return {?}
     */
    ParameterFormComponent.prototype.customizeAfterSave = /**
     * @param {?} afterSave
     * @return {?}
     */
    function (afterSave) {
        if (afterSave.success === true) {
            this.rteAlertService.success('Parâmetro salvo com sucesso', 'Sucesso');
        }
    };
    /**
     * @param {?} option
     * @return {?}
     */
    ParameterFormComponent.prototype.customizeAfterDelete = /**
     * @param {?} option
     * @return {?}
     */
    function (option) {
        if (option === true) {
            this.rteAlertService.success('Parâmetro excluído com sucesso', 'Sucesso');
        }
    };
    /**
     * @return {?}
     */
    ParameterFormComponent.prototype.showErrorMessage = /**
     * @return {?}
     */
    function () {
        return this.toolbarObject.currentStatus === RteToolbarStatusEnum.Creating
            || this.toolbarObject.currentStatus === RteToolbarStatusEnum.Editing;
    };
    /**
     * @return {?}
     */
    ParameterFormComponent.prototype.getValidation = /**
     * @return {?}
     */
    function () {
        return this.getParameterErrorMessage();
    };
    /**
     * @return {?}
     */
    ParameterFormComponent.prototype.getParameterErrorMessage = /**
     * @return {?}
     */
    function () {
        return !this.toolbarObject.current.Description ? 'Informe o nome do parâmetro' : '';
    };
    /**
     * @return {?}
     */
    ParameterFormComponent.prototype.disableRemoveButton = /**
     * @return {?}
     */
    function () {
        if (this.parameterItem.showButton && this.parameterAttribute.showButton) {
            this.parameterItem.showButton.remove = false;
            this.parameterAttribute.showButton.remove = false;
        }
    };
    /**
     * @param {?} enable
     * @return {?}
     */
    ParameterFormComponent.prototype.enableOrDisableAllButtons = /**
     * @param {?} enable
     * @return {?}
     */
    function (enable) {
        if (this.parameterItem.showButton && this.parameterAttribute.showButton) {
            this.parameterItem.showButton.add = enable;
            this.parameterItem.showButton.edit = enable;
            this.parameterItem.showButton.remove = enable;
            this.parameterAttribute.showButton.add = enable;
            this.parameterAttribute.showButton.edit = enable;
            this.parameterAttribute.showButton.remove = enable;
        }
    };
    /**
     * @return {?}
     */
    ParameterFormComponent.prototype.enableEditableButtons = /**
     * @return {?}
     */
    function () {
        if (this.parameterItem.showButton && this.parameterAttribute.showButton) {
            this.parameterItem.showButton.add = true;
            this.parameterItem.showButton.edit = true;
            this.parameterAttribute.showButton.add = true;
            this.parameterAttribute.showButton.edit = true;
        }
    };
    ParameterFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-parameter-form',
                    template: "<div class=\"wrapper\">\r\n  <rte-card>\r\n      <mat-card-content>\r\n        <form #formFilterRules=\"ngForm\" autocomplete=\"off\">\r\n          <div class=\"row-form\">\r\n            <div class=\"column-form\" [hidden]=\"toolbarObject.currentStatus === toolbarObject.possibleStatus.Creating\">\r\n              <rte-form-field class=\"example-full-width\">\r\n                <input \r\n                  rteInput \r\n                  placeholder=\"C\u00F3digo\"\r\n                  name=\"Code\"\r\n                  [(ngModel)]=\"toolbarObject.current.Id\"\r\n                  readonly>\r\n              </rte-form-field>\r\n            </div>\r\n\r\n            <div class=\"column-form\">\r\n              <rte-form-field class=\"example-full-width\">\r\n                <input \r\n                  rteInput \r\n                  placeholder=\"Par\u00E2metro\"\r\n                  name=\"Parameter\"\r\n                  [(ngModel)]=\"toolbarObject.current.Description\"\r\n                  required>\r\n                <mat-error>\r\n                  {{getParameterErrorMessage()}}\r\n                </mat-error>\r\n              </rte-form-field>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"row-form\">\r\n            <div class=\"column-form\">\r\n              <rte-form-field class=\"example-full-width\">\r\n                <textarea \r\n                  placeholder=\"Descri\u00E7\u00E3o\" \r\n                  type=\"text\" \r\n                  rteInput \r\n                  rows=\"2\" \r\n                  name=\"Description\"\r\n                  [(ngModel)]=\"toolbarObject.current.Comment\">\r\n                </textarea>\r\n              </rte-form-field>\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </mat-card-content>\r\n  </rte-card>\r\n</div>\r\n\r\n<rte-app-parameter-details #parameterItem [toolbarObject]=\"toolbarObject\"></rte-app-parameter-details>\r\n<rte-app-parameter-attributes #parameterAttribute [toolbarObject]=\"toolbarObject\"></rte-app-parameter-attributes>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ParameterFormComponent.ctorParameters = function () { return [
        { type: RTEAlertService }
    ]; };
    ParameterFormComponent.propDecorators = {
        toolbarObject: [{ type: Input }],
        parameterAttribute: [{ type: ViewChild, args: ['parameterAttribute', { read: ParameterAttributesComponent },] }],
        parameterItem: [{ type: ViewChild, args: ['parameterItem', { read: ParameterDetailsComponent },] }]
    };
    return ParameterFormComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParameterComponent = /** @class */ (function () {
    function ParameterComponent(service, rteAlertService) {
        this.service = service;
        this.rteAlertService = rteAlertService;
        this.toolbarObject = new RteToolbarViewModel();
        this.toolbarObject = new RteToolbarViewModel();
    }
    /**
     * @return {?}
     */
    ParameterComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.toolbarObject.current = new Parameter();
        this.toolbarObject.searchObject = new Parameter();
    };
    /**
     * @param {?} beforeSave
     * @return {?}
     */
    ParameterComponent.prototype.validateBeforeSave = /**
     * @param {?} beforeSave
     * @return {?}
     */
    function (beforeSave) {
        /** @type {?} */
        var validation = this.parameterForm.getValidation();
        if (validation) {
            beforeSave.cancelSave = true;
            this.rteAlertService.warning('Preencha todos os campos', validation);
        }
    };
    /**
     * @return {?}
     */
    ParameterComponent.prototype.customizeAfterInsertMode = /**
     * @return {?}
     */
    function () {
        if (this.toolbarObject.readonlyInsertMode) {
            this.toolbarObject.current = new Parameter();
            this.parameterForm.enableOrDisableAllButtons(true);
        }
    };
    /**
     * @return {?}
     */
    ParameterComponent.prototype.customizeAfterEditMode = /**
     * @return {?}
     */
    function () {
        this.parameterForm.enableEditableButtons();
    };
    /**
     * @return {?}
     */
    ParameterComponent.prototype.customizeAfterGet = /**
     * @return {?}
     */
    function () {
        this.parameterForm.enableOrDisableAllButtons(false);
    };
    /**
     * @return {?}
     */
    ParameterComponent.prototype.customizeAfterClear = /**
     * @return {?}
     */
    function () {
        this.parameterForm.enableOrDisableAllButtons(false);
    };
    /**
     * @return {?}
     */
    ParameterComponent.prototype.customizeAfterCancelEdit = /**
     * @return {?}
     */
    function () {
        this.parameterForm.enableOrDisableAllButtons(false);
    };
    /**
     * @return {?}
     */
    ParameterComponent.prototype.customizeAfterCancelOperation = /**
     * @return {?}
     */
    function () {
        this.parameterForm.enableOrDisableAllButtons(false);
    };
    ParameterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-parameter',
                    template: "<rte-toolbar [toolbarObject]=\"toolbarObject\" \r\n             [service]=\"service\"\r\n             [KeyDownElementArea]=\"form\"\r\n             (validateBeforeSave)=\"validateBeforeSave($event)\"\r\n             (customizeAfterSave)=\"parameterForm.customizeAfterSave($event)\"\r\n             (customizeAfterDelete)=\"parameterForm.customizeAfterDelete($event)\"\r\n             (customizeAfterInsertMode)=\"customizeAfterInsertMode()\"\r\n             (customizeAfterEditMode)=\"customizeAfterEditMode()\"\r\n             (customizeAfterGet)=\"customizeAfterGet()\"\r\n             (customizeAfterClear)=\"customizeAfterClear()\"\r\n             (customizeAfterCancelEdit)=\"customizeAfterCancelEdit()\"\r\n             (customizeAfterCancelOperation)=\"customizeAfterCancelOperation()\">\r\n\r\n</rte-toolbar>\r\n<div class=\"wrapper\">   \r\n  <rte-app-title></rte-app-title>\r\n</div>\r\n\r\n<div #form>\r\n  <rte-app-parameter-search [toolbarObject]=\"toolbarObject\" *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n  </rte-app-parameter-search>\r\n\r\n  <rte-app-parameter-table [toolbarObject]=\"toolbarObject\" *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n  </rte-app-parameter-table>\r\n  \r\n  <rte-app-parameter-form #parameterForm [toolbarObject]=\"toolbarObject\" [hidden]=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n  </rte-app-parameter-form>\r\n\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ParameterComponent.ctorParameters = function () { return [
        { type: RteParameterService },
        { type: RTEAlertService }
    ]; };
    ParameterComponent.propDecorators = {
        parameterForm: [{ type: ViewChild, args: ['parameterForm', { read: ParameterFormComponent },] }]
    };
    return ParameterComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParameterSearchComponent = /** @class */ (function () {
    function ParameterSearchComponent() {
    }
    /**
     * @return {?}
     */
    ParameterSearchComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    ParameterSearchComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-parameter-search',
                    template: "<div class=\"wrapper\">\r\n  <rte-card>\r\n    <mat-card-content>\r\n      <form #formFilterRules=\"ngForm\" autocomplete=\"off\">\r\n        <div class=\"row-form\">\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"C\u00F3digo\"\r\n                name=\"Code\"\r\n                [(ngModel)]=\"toolbarObject.searchObject.Id\">\r\n            </rte-form-field>\r\n          </div>\r\n\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"Par\u00E2metro\"\r\n                name=\"Parameter\"\r\n                [(ngModel)]=\"toolbarObject.searchObject.Description\">\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </mat-card-content>\r\n  </rte-card>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ParameterSearchComponent.ctorParameters = function () { return []; };
    ParameterSearchComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return ParameterSearchComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParameterTableComponent = /** @class */ (function () {
    function ParameterTableComponent() {
        this.displayedColumns = ['id', 'description', 'comment'];
    }
    /**
     * @return {?}
     */
    ParameterTableComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    ParameterTableComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-parameter-table',
                    template: "<div class=\"wrapper\">\r\n  <rte-card>\r\n    <mat-card-content>\r\n      <div class=\"mat-elevation-z4\">\r\n        <rte-table [dataSource]=\"toolbarObject.dataSource\"\r\n                    *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n          <ng-container rteColumnDef=\"id\">\r\n            <rte-header-cell *rteHeaderCellDef>C\u00F3digo</rte-header-cell>\r\n            <rte-cell *rteCellDef=\"let parameter\">{{parameter.Id}}</rte-cell>\r\n          </ng-container>\r\n\r\n          <ng-container rteColumnDef=\"description\">\r\n            <rte-header-cell *rteHeaderCellDef>Par\u00E2metro</rte-header-cell>\r\n            <rte-cell *rteCellDef=\"let parameter\">{{parameter.Description}}</rte-cell>\r\n          </ng-container>\r\n\r\n          <ng-container rteColumnDef=\"comment\">\r\n            <rte-header-cell *rteHeaderCellDef>Descri\u00E7\u00E3o</rte-header-cell>\r\n            <rte-cell *rteCellDef=\"let parameter\" style=\"text-overflow: ellipsis; width: 100px\">{{parameter.Comment}}</rte-cell>\r\n          </ng-container>\r\n\r\n          <rte-header-row *rteHeaderRowDef=\"displayedColumns\"></rte-header-row>\r\n          <rte-row *rteRowDef=\"let row; columns: displayedColumns;\" (click)=\"toolbarObject.setCurrent(row)\"\r\n                  (dblclick)=\"toolbarObject.viewMode(row)\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"\r\n                  [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted, selected: toolbarObject.selectionModel.isSelected(row)}\">\r\n          </rte-row>\r\n        </rte-table>\r\n      </div>\r\n    </mat-card-content>\r\n  </rte-card>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ParameterTableComponent.ctorParameters = function () { return []; };
    ParameterTableComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return ParameterTableComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ViewModeDirective = /** @class */ (function () {
    function ViewModeDirective(tpl) {
        this.tpl = tpl;
    }
    ViewModeDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[viewMode]'
                },] }
    ];
    /** @nocollapse */
    ViewModeDirective.ctorParameters = function () { return [
        { type: TemplateRef }
    ]; };
    return ViewModeDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EditModeDirective = /** @class */ (function () {
    function EditModeDirective(tpl) {
        this.tpl = tpl;
    }
    EditModeDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[editMode]'
                },] }
    ];
    /** @nocollapse */
    EditModeDirective.ctorParameters = function () { return [
        { type: TemplateRef }
    ]; };
    return EditModeDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EditableTableComponent = /** @class */ (function () {
    function EditableTableComponent(host) {
        this.host = host;
        this.update = new EventEmitter();
        this.editMode = new Subject();
        this.editModeImp = this.editMode.asObservable();
        this.mode = 'view';
    }
    /**
     * @return {?}
     */
    EditableTableComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.viewModeHandler();
        this.editModeHandler();
    };
    /**
     * @return {?}
     */
    EditableTableComponent.prototype.toViewMode = /**
     * @return {?}
     */
    function () {
        this.update.next();
        this.mode = 'view';
    };
    Object.defineProperty(EditableTableComponent.prototype, "element", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return this.host.nativeElement;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @private
     * @return {?}
     */
    EditableTableComponent.prototype.viewModeHandler = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        fromEvent(this.element, 'dblclick').pipe(untilDestroyed(this)).subscribe(function () {
            _this.mode = 'edit';
            _this.editMode.next(true);
        });
    };
    /**
     * @private
     * @return {?}
     */
    EditableTableComponent.prototype.editModeHandler = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var clickOutside$ = fromEvent(document, 'click').pipe(filter(function (_a) {
            var target = _a.target;
            return _this.element.contains(target) === false;
        }), take(1));
        this.editModeImp.pipe(switchMapTo(clickOutside$), untilDestroyed(this)).subscribe(function (event) { return _this.toViewMode(); });
    };
    Object.defineProperty(EditableTableComponent.prototype, "currentView", {
        get: /**
         * @return {?}
         */
        function () {
            return this.mode === 'view' ? this.viewModeTpl.tpl : this.editModeTpl.tpl;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    EditableTableComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
    };
    EditableTableComponent.decorators = [
        { type: Component, args: [{
                    selector: 'editable',
                    template: "\n    <ng-container *ngTemplateOutlet=\"currentView\"></ng-container>\n  ",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    EditableTableComponent.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    EditableTableComponent.propDecorators = {
        viewModeTpl: [{ type: ContentChild, args: [ViewModeDirective,] }],
        editModeTpl: [{ type: ContentChild, args: [EditModeDirective,] }],
        update: [{ type: Output }]
    };
    return EditableTableComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EditableOnEnterDirective = /** @class */ (function () {
    function EditableOnEnterDirective(editable) {
        this.editable = editable;
    }
    /**
     * @return {?}
     */
    EditableOnEnterDirective.prototype.onEnter = /**
     * @return {?}
     */
    function () {
        this.editable.toViewMode();
    };
    EditableOnEnterDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[editableOnEnter]'
                },] }
    ];
    /** @nocollapse */
    EditableOnEnterDirective.ctorParameters = function () { return [
        { type: EditableTableComponent }
    ]; };
    EditableOnEnterDirective.propDecorators = {
        onEnter: [{ type: HostListener, args: ['keyup.enter',] }]
    };
    return EditableOnEnterDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FocusableDirective = /** @class */ (function () {
    function FocusableDirective(host) {
        this.host = host;
    }
    /**
     * @return {?}
     */
    FocusableDirective.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.host.nativeElement.focus();
    };
    FocusableDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[focusable]'
                },] }
    ];
    /** @nocollapse */
    FocusableDirective.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    return FocusableDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteParameterModule = /** @class */ (function () {
    function RteParameterModule() {
    }
    /**
     * @param {?} environment
     * @return {?}
     */
    RteParameterModule.forRoot = /**
     * @param {?} environment
     * @return {?}
     */
    function (environment) {
        return {
            ngModule: RteParameterModule,
            providers: [
                RteParameterService,
                {
                    provide: 'environment',
                    useValue: environment
                }
            ]
        };
    };
    RteParameterModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        RteToolbarModule,
                        RteAppTitleModule,
                        RteMaterialModule,
                        MatRippleModule,
                        MatCheckboxModule,
                        MatSelectModule,
                        MatOptionModule,
                        MatListModule,
                        MatTableModule,
                        MatIconModule,
                        MatAutocompleteModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatProgressSpinnerModule,
                        MatToolbarModule,
                        MatDialogModule,
                        MatCardModule,
                        CdkTableModule,
                        MatDividerModule,
                        FormsModule,
                        RteToolbarMinorModule,
                        MatExpansionModule
                    ],
                    declarations: [
                        ParameterComponent,
                        ParameterFormComponent,
                        ParameterSearchComponent,
                        ParameterDetailsComponent,
                        ParameterAttributesComponent,
                        ParameterTableComponent,
                        AttributesDialogComponent,
                        DetailsDialogComponent,
                        EditableTableComponent,
                        ViewModeDirective,
                        EditModeDirective,
                        EditableOnEnterDirective,
                        FocusableDirective
                    ],
                    entryComponents: [AttributesDialogComponent, DetailsDialogComponent]
                },] }
    ];
    return RteParameterModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AttributeFormComponent = /** @class */ (function () {
    function AttributeFormComponent(rteAlertService) {
        this.rteAlertService = rteAlertService;
    }
    /**
     * @return {?}
     */
    AttributeFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} afterSave
     * @return {?}
     */
    AttributeFormComponent.prototype.customizeAfterSave = /**
     * @param {?} afterSave
     * @return {?}
     */
    function (afterSave) {
        if (afterSave.success === true) {
            this.rteAlertService.success('Grupo salvo com sucesso', 'Sucesso');
        }
    };
    /**
     * @param {?} option
     * @return {?}
     */
    AttributeFormComponent.prototype.customizeAfterDelete = /**
     * @param {?} option
     * @return {?}
     */
    function (option) {
        if (option === true) {
            this.rteAlertService.success('Grupo excluído com sucesso', 'Sucesso');
        }
    };
    /**
     * @return {?}
     */
    AttributeFormComponent.prototype.getDescriptionMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.Description)
            ? 'O campo Descrição deve ser informado.' : '';
    };
    /**
     * @return {?}
     */
    AttributeFormComponent.prototype.getKeyMessage = /**
     * @return {?}
     */
    function () {
        return this.showErrorMessage()
            && !(this.toolbarObject.current.Key)
            ? 'O campo Chave deve ser informado.' : '';
    };
    /**
     * @return {?}
     */
    AttributeFormComponent.prototype.showErrorMessage = /**
     * @return {?}
     */
    function () {
        return this.toolbarObject.currentStatus === RteToolbarStatusEnum.Creating
            || this.toolbarObject.currentStatus === RteToolbarStatusEnum.Editing;
    };
    /**
     * @return {?}
     */
    AttributeFormComponent.prototype.getValidation = /**
     * @return {?}
     */
    function () {
        return (this.getDescriptionMessage() ||
            this.getKeyMessage());
    };
    AttributeFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-attribute-form',
                    template: "<div class=\"wrapper\">\r\n  <rte-card>\r\n    <mat-card-content>\r\n      <form #formFilterRules=\"ngForm\" autocomplete=\"off\">\r\n        <div class=\"row-form\">\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"C\u00F3digo\"\r\n                name=\"Codigo\"\r\n                type=\"number\"\r\n                [(ngModel)]=\"toolbarObject.current.Id\"\r\n                readonly\r\n                [required]=\"toolbarObject.currentStatus === toolbarObject.possibleStatus.Editing\">\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row-form\">\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"Descri\u00E7\u00E3o\"\r\n                name=\"Description\"\r\n                type=\"text\"\r\n                [(ngModel)]=\"toolbarObject.current.Description\" \r\n                [readonly]=\"toolbarObject.readonlyBrowserMode\"\r\n                required>\r\n                <mat-error>{{getDescriptionMessage()}}</mat-error>\r\n            </rte-form-field>\r\n          </div>\r\n\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"Chave\"\r\n                name=\"Key\"\r\n                type=\"text\"\r\n                [(ngModel)]=\"toolbarObject.current.Key\" \r\n                [readonly]=\"toolbarObject.readonlyBrowserMode\"\r\n                required>\r\n                <mat-error>{{getKeyMessage()}}</mat-error>\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </mat-card-content>\r\n  </rte-card>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    AttributeFormComponent.ctorParameters = function () { return [
        { type: RTEAlertService }
    ]; };
    AttributeFormComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return AttributeFormComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AttributeTableComponent = /** @class */ (function () {
    function AttributeTableComponent() {
        this.displayedColumns = ['id', 'description', 'key'];
    }
    /**
     * @return {?}
     */
    AttributeTableComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    AttributeTableComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-attribute-table',
                    template: "<div class=\"wrapper\">\r\n  <rte-card>\r\n      <mat-card-content>\r\n          <div class=\"mat-elevation-z4\">\r\n            <rte-table [dataSource]=\"toolbarObject.dataSource\"\r\n                        *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n              <ng-container rteColumnDef=\"id\">\r\n                <rte-header-cell *rteHeaderCellDef>C\u00F3digo</rte-header-cell>\r\n                <rte-cell *rteCellDef=\"let attribute\">{{attribute.Id}}</rte-cell>\r\n              </ng-container>\r\n\r\n              <ng-container rteColumnDef=\"description\">\r\n                <rte-header-cell *rteHeaderCellDef>Descri\u00E7\u00E3o</rte-header-cell>\r\n                <rte-cell *rteCellDef=\"let attribute\">{{attribute.Description}}</rte-cell>\r\n              </ng-container>\r\n\r\n              <ng-container rteColumnDef=\"key\">\r\n                <rte-header-cell *rteHeaderCellDef>Chave</rte-header-cell>\r\n                <rte-cell *rteCellDef=\"let attribute\">{{attribute.Key}}</rte-cell>\r\n              </ng-container>\r\n\r\n              <rte-header-row *rteHeaderRowDef=\"displayedColumns\"></rte-header-row>\r\n              <rte-row *rteRowDef=\"let row; columns: displayedColumns;\" (click)=\"toolbarObject.setCurrent(row)\"\r\n                      (dblclick)=\"toolbarObject.viewMode(row)\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"\r\n                      [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted, selected: toolbarObject.selectionModel.isSelected(row)}\">\r\n              </rte-row>\r\n            </rte-table>\r\n          </div>\r\n      </mat-card-content>\r\n  </rte-card>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    AttributeTableComponent.ctorParameters = function () { return []; };
    AttributeTableComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return AttributeTableComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AttributeSearchComponent = /** @class */ (function () {
    function AttributeSearchComponent() {
    }
    /**
     * @return {?}
     */
    AttributeSearchComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    AttributeSearchComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-attribute-search',
                    template: "<div class=\"wrapper\">\r\n  <rte-card>\r\n    <mat-card-content>\r\n      <form #formFilterRules=\"ngForm\" autocomplete=\"off\">\r\n        <div class=\"row-form\">\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"C\u00F3digo\"\r\n                name=\"Codigo\"\r\n                type=\"number\"\r\n                [(ngModel)]=\"toolbarObject.searchObject.Id\">\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row-form\">\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"Descri\u00E7\u00E3o\"\r\n                name=\"Description\"\r\n                type=\"text\"\r\n                [(ngModel)]=\"toolbarObject.searchObject.Description\">\r\n            </rte-form-field>\r\n          </div>\r\n\r\n          <div class=\"column-form\">\r\n            <rte-form-field class=\"example-full-width\">\r\n              <input \r\n                rteInput \r\n                placeholder=\"Chave\"\r\n                name=\"Key\"\r\n                type=\"text\"\r\n                [(ngModel)]=\"toolbarObject.searchObject.Key\" >\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </mat-card-content>\r\n  </rte-card>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    AttributeSearchComponent.ctorParameters = function () { return []; };
    AttributeSearchComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return AttributeSearchComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Attribute = /** @class */ (function () {
    function Attribute() {
    }
    return Attribute;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} name
 * @param {?} value
 * @param {?} params
 * @return {?}
 */
function appendHttpParams(name, value, params) {
    return params.append(name, !value ? '' : value);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteAttributeService = /** @class */ (function () {
    function RteAttributeService(http, environment) {
        this.http = http;
        this.environment = environment;
    }
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    RteAttributeService.prototype.clear = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        objectCurrent.Id = 0;
        objectCurrent.Description = null;
        objectCurrent.Key = null;
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    RteAttributeService.prototype.save = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        if (objectCurrent.Id > 0) {
            return this.http.put(this.environment.apiCore + 'webapi/attribute', objectCurrent);
        }
        else {
            return this.http.post(this.environment.apiCore + 'webapi/attribute', objectCurrent);
        }
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    RteAttributeService.prototype.delete = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        return this.http.delete(this.environment.apiCore + 'webapi/attribute/' + objectCurrent.Id);
    };
    /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    RteAttributeService.prototype.get = /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    function (objectCurrent, page, pageSize) {
        page++;
        /** @type {?} */
        var params = new HttpParams()
            .set('page', page.toString())
            .set('amountByPage', pageSize.toString());
        if (objectCurrent) {
            params = appendHttpParams('Id', objectCurrent.Id, params);
            params = appendHttpParams('Description', objectCurrent.Description, params);
            params = appendHttpParams('Key', objectCurrent.Key, params);
        }
        return this.http.get(this.environment.apiCore + 'webapi/attribute/getbyfilters', { params: params });
    };
    RteAttributeService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    RteAttributeService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['environment',] }] }
    ]; };
    /** @nocollapse */ RteAttributeService.ngInjectableDef = defineInjectable({ factory: function RteAttributeService_Factory() { return new RteAttributeService(inject(HttpClient), inject("environment")); }, token: RteAttributeService, providedIn: "root" });
    return RteAttributeService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AttributeComponent = /** @class */ (function () {
    function AttributeComponent(service, rteAlertService) {
        this.service = service;
        this.rteAlertService = rteAlertService;
        this.toolbarObject = new RteToolbarViewModel();
        this.toolbarObject = new RteToolbarViewModel();
    }
    /**
     * @return {?}
     */
    AttributeComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.toolbarObject.current = new Attribute();
        this.toolbarObject.searchObject = new Attribute();
    };
    /**
     * @param {?} beforeSave
     * @return {?}
     */
    AttributeComponent.prototype.validateBeforeSave = /**
     * @param {?} beforeSave
     * @return {?}
     */
    function (beforeSave) {
        /** @type {?} */
        var validation = this.attributeForm.getValidation();
        if (validation) {
            beforeSave.cancelSave = true;
            this.rteAlertService.warning('Preencha todos os campos', validation);
        }
    };
    AttributeComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-attribute',
                    template: "<rte-toolbar [toolbarObject]=\"toolbarObject\" \r\n             [service]=\"service\"\r\n             [KeyDownElementArea]=\"form\"\r\n             (validateBeforeSave)=\"validateBeforeSave($event)\"\r\n             (customizeAfterSave)=\"attributeForm.customizeAfterSave($event)\"\r\n             (customizeAfterDelete)=\"attributeForm.customizeAfterDelete($event)\">\r\n\r\n</rte-toolbar>\r\n<div class=\"wrapper\">   \r\n  <rte-app-title></rte-app-title>\r\n</div>\r\n\r\n<div #form>\r\n  <rte-app-attribute-search [toolbarObject]=\"toolbarObject\" *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n  </rte-app-attribute-search>\r\n\r\n  <rte-app-attribute-table [toolbarObject]=\"toolbarObject\" *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n  </rte-app-attribute-table>\r\n\r\n  <rte-app-attribute-form #attributeForm [toolbarObject]=\"toolbarObject\" [hidden]=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n  </rte-app-attribute-form>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    AttributeComponent.ctorParameters = function () { return [
        { type: RteAttributeService },
        { type: RTEAlertService }
    ]; };
    AttributeComponent.propDecorators = {
        attributeForm: [{ type: ViewChild, args: ['attributeForm', { read: AttributeFormComponent },] }]
    };
    return AttributeComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteAttributeModule = /** @class */ (function () {
    function RteAttributeModule() {
    }
    /**
     * @param {?} environment
     * @return {?}
     */
    RteAttributeModule.forRoot = /**
     * @param {?} environment
     * @return {?}
     */
    function (environment) {
        return {
            ngModule: RteAttributeModule,
            providers: [
                RteAttributeService,
                {
                    provide: 'environment',
                    useValue: environment
                }
            ]
        };
    };
    RteAttributeModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        RteToolbarModule,
                        RteAppTitleModule,
                        RteMaterialModule,
                        MatRippleModule,
                        MatCheckboxModule,
                        MatSelectModule,
                        MatOptionModule,
                        MatListModule,
                        MatTableModule,
                        MatIconModule,
                        MatAutocompleteModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatProgressSpinnerModule,
                        MatToolbarModule,
                        MatDialogModule,
                        MatCardModule,
                        CdkTableModule,
                        MatDividerModule,
                        FormsModule
                    ],
                    declarations: [AttributeFormComponent, AttributeTableComponent, AttributeSearchComponent, AttributeComponent]
                },] }
    ];
    return RteAttributeModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteIntegrationSystemSearchComponent = /** @class */ (function () {
    function RteIntegrationSystemSearchComponent() {
    }
    /**
     * @return {?}
     */
    RteIntegrationSystemSearchComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    RteIntegrationSystemSearchComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-rte-integration-system-search',
                    template: "<div class=\"wrapper\">\r\n  <rte-card>\r\n    <mat-card-content>\r\n      <form #formFilterRules=\"ngForm\" autocomplete=\"off\">\r\n        <div class=\"row-form\">\r\n          <div class=\"column-form\">\r\n            <rte-form-field>\r\n              <input rteInput placeholder=\"C\u00F3digo\" name=\"Id\" [(ngModel)]=\"toolbarObject.searchObject.Id\">\r\n            </rte-form-field>\r\n          </div>\r\n\r\n          <div class=\"column-form\">\r\n            <rte-form-field>\r\n              <input rteInput placeholder=\"Descri\u00E7\u00E3o\" name=\"Description\"\r\n                [(ngModel)]=\"toolbarObject.searchObject.Description\" maxlength=\"65\">\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n        <div class=\"row-form\">\r\n          <div class=\"column-form\">\r\n            <rte-form-field>\r\n              <rte-select placeholder=\"Sistema\" [(ngModel)]=\"toolbarObject.searchObject.System.Id\" name=\"system\"\r\n                required>\r\n                <rte-option *ngFor=\"let item of systemList\" [value]=\"item.Id\">\r\n                  {{ item.Description }}\r\n                </rte-option>\r\n              </rte-select>\r\n            </rte-form-field>\r\n          </div>\r\n          <div class=\"column-form\">\r\n            <rte-form-field>\r\n              <input rteInput placeholder=\"Valor\" name=\"Value\" [(ngModel)]=\"toolbarObject.searchObject.Value\"\r\n                maxlength=\"5\">\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </mat-card-content>\r\n  </rte-card>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    RteIntegrationSystemSearchComponent.ctorParameters = function () { return []; };
    RteIntegrationSystemSearchComponent.propDecorators = {
        toolbarObject: [{ type: Input }],
        systemList: [{ type: Input }]
    };
    return RteIntegrationSystemSearchComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteIntegrationSystemFormComponent = /** @class */ (function () {
    function RteIntegrationSystemFormComponent() {
    }
    /**
     * @return {?}
     */
    RteIntegrationSystemFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    RteIntegrationSystemFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-rte-integration-system-form',
                    template: "<div class=\"wrapper\">\r\n  <rte-card>\r\n    <mat-card-content>\r\n      <form #formFilterRules=\"ngForm\" autocomplete=\"off\">\r\n        <div class=\"row-form\">\r\n          <div class=\"column-form\">\r\n            <rte-form-field>\r\n              <input rteInput placeholder=\"C\u00F3digo\" name=\"Id\" [(ngModel)]=\"toolbarObject.current.Id\" readonly>\r\n            </rte-form-field>\r\n          </div>\r\n\r\n          <div class=\"column-form\">\r\n            <rte-form-field>\r\n              <input rteInput placeholder=\"Descri\u00E7\u00E3o\" name=\"Description\" required\r\n                [(ngModel)]=\"toolbarObject.current.Description\" [disabled]=\"toolbarObject.readonlyBrowserMode\"\r\n                maxlength=\"65\">\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n        <div class=\"row-form\">\r\n          <div class=\"column-form\">\r\n            <rte-form-field>\r\n              <rte-select placeholder=\"Sistema\" [(ngModel)]=\"toolbarObject.current.System.Id\" name=\"systemId\"\r\n                [disabled]=\"toolbarObject.readonlyBrowserMode\" required>\r\n                <rte-option *ngFor=\"let item of systemList\" [value]=\"item.Id\" required>\r\n                  {{ item.Description }}\r\n                </rte-option>\r\n              </rte-select>\r\n            </rte-form-field>\r\n          </div>\r\n          <div class=\"column-form\">\r\n            <rte-form-field>\r\n              <input rteInput placeholder=\"Valor\" name=\"Value\" [disabled]=\"toolbarObject.readonlyBrowserMode\" required\r\n                [(ngModel)]=\"toolbarObject.current.Value\" maxlength=\"5\">\r\n            </rte-form-field>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </mat-card-content>\r\n  </rte-card>\r\n</div>\r\n\r\n<rte-app-rte-integration-company-table [toolbarObject]=\"toolbarObject\"></rte-app-rte-integration-company-table>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    RteIntegrationSystemFormComponent.ctorParameters = function () { return []; };
    RteIntegrationSystemFormComponent.propDecorators = {
        toolbarObject: [{ type: Input }],
        systemList: [{ type: Input }]
    };
    return RteIntegrationSystemFormComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteIntegrationSystemTableComponent = /** @class */ (function () {
    function RteIntegrationSystemTableComponent() {
        this.displayedColumns = ['id', 'description'];
    }
    /**
     * @return {?}
     */
    RteIntegrationSystemTableComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    RteIntegrationSystemTableComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-rte-integration-system-table',
                    template: "<div class=\"wrapper\">\r\n    <rte-card>\r\n        <mat-card-content>\r\n            <div class=\"mat-elevation-z4\">\r\n              <rte-table [dataSource]=\"toolbarObject.dataSource\"\r\n                          *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n                <ng-container rteColumnDef=\"id\">\r\n                  <rte-header-cell *rteHeaderCellDef>C\u00F3digo</rte-header-cell>\r\n                  <rte-cell *rteCellDef=\"let IntegrationSystem\">{{IntegrationSystem.Id}}</rte-cell>\r\n                </ng-container>\r\n  \r\n                <ng-container rteColumnDef=\"description\">\r\n                  <rte-header-cell *rteHeaderCellDef>Descri\u00E7\u00E3o</rte-header-cell>\r\n                  <rte-cell *rteCellDef=\"let IntegrationSystem\">{{IntegrationSystem.Description}}</rte-cell>\r\n                </ng-container>\r\n  \r\n                <rte-header-row *rteHeaderRowDef=\"displayedColumns\"></rte-header-row>\r\n                <rte-row *rteRowDef=\"let row; columns: displayedColumns;\" (click)=\"toolbarObject.setCurrent(row)\"\r\n                        (dblclick)=\"toolbarObject.viewMode(row)\" (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"\r\n                        [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted, selected: toolbarObject.selectionModel.isSelected(row)}\">\r\n                </rte-row>\r\n              </rte-table>\r\n            </div>\r\n        </mat-card-content>\r\n    </rte-card>\r\n  </div>\r\n  ",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    RteIntegrationSystemTableComponent.ctorParameters = function () { return []; };
    RteIntegrationSystemTableComponent.propDecorators = {
        toolbarObject: [{ type: Input }]
    };
    return RteIntegrationSystemTableComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IntegrationSystem = /** @class */ (function () {
    function IntegrationSystem() {
        this.System = new System$1();
        this.IntegrationCompanyInfos = [];
    }
    return IntegrationSystem;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteIntegrationSystemService = /** @class */ (function () {
    function RteIntegrationSystemService(http, environment) {
        this.http = http;
        this.environment = environment;
    }
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    RteIntegrationSystemService.prototype.clear = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        objectCurrent.Id = null;
        objectCurrent.Description = '';
        objectCurrent.Value = '';
        objectCurrent.System.Id = null;
        objectCurrent.System.Description = '';
        objectCurrent.IntegrationCompanyInfos = [];
        objectCurrent.Revision = 1;
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    RteIntegrationSystemService.prototype.save = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        if (objectCurrent.Id > 0) {
            return this.http.put(this.environment.apiCore + 'webapi/integration', objectCurrent);
        }
        else {
            return this.http.post(this.environment.apiCore + 'webapi/integration', objectCurrent);
        }
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    RteIntegrationSystemService.prototype.delete = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        return this.http.delete(this.environment.apiCore +
            'webapi/integration/' +
            objectCurrent.Id);
    };
    /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    RteIntegrationSystemService.prototype.get = /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    function (objectCurrent, page, pageSize) {
        page++;
        /** @type {?} */
        var params = new HttpParams()
            .set('page', page.toString())
            .set('amountByPage', pageSize.toString());
        if (objectCurrent) {
            params = this.appendHttpParams('Id', objectCurrent.Id, params);
            params = this.appendHttpParams('Description', objectCurrent.Description, params);
            params = this.appendHttpParams('Value', objectCurrent.Value, params);
        }
        return this.http.get(this.environment.apiCore + 'webapi/integration/getbyfilters', { params: params });
    };
    /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    RteIntegrationSystemService.prototype.appendHttpParams = /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    function (name, value, params) {
        return params.append(name, !value ? '' : value);
    };
    RteIntegrationSystemService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    RteIntegrationSystemService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['environment',] }] }
    ]; };
    /** @nocollapse */ RteIntegrationSystemService.ngInjectableDef = defineInjectable({ factory: function RteIntegrationSystemService_Factory() { return new RteIntegrationSystemService(inject(HttpClient), inject("environment")); }, token: RteIntegrationSystemService, providedIn: "root" });
    return RteIntegrationSystemService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteIntegrationSystemComponent = /** @class */ (function () {
    function RteIntegrationSystemComponent(service, rteAlertService, systemService) {
        this.service = service;
        this.rteAlertService = rteAlertService;
        this.systemService = systemService;
        this.toolbarObject = new RteToolbarViewModel();
    }
    /**
     * @return {?}
     */
    RteIntegrationSystemComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.toolbarObject.current = new IntegrationSystem();
                        this.toolbarObject.searchObject = new IntegrationSystem();
                        _a = this;
                        return [4 /*yield*/, this.systemService.getAll().toPromise()];
                    case 1:
                        _a.systemList = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} option
     * @return {?}
     */
    RteIntegrationSystemComponent.prototype.customizeAfterInsertMode = /**
     * @param {?} option
     * @return {?}
     */
    function (option) {
        if (option) {
            this.toolbarObject.current.System = new System$1();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    RteIntegrationSystemComponent.prototype.customizeAfterCancelOperation = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.toolbarObject.searchObject = new IntegrationSystem();
    };
    RteIntegrationSystemComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-rte-integration-system',
                    template: "<rte-toolbar [toolbarObject]=\"toolbarObject\" \r\n             [service]=\"service\"\r\n             [KeyDownElementArea]=\"form\"\r\n             (customizeAfterInsertMode)=\"customizeAfterInsertMode($event)\"\r\n             (customizeAfterCancelOperation)=\"customizeAfterCancelOperation($event)\"\r\n>\r\n\r\n</rte-toolbar>\r\n<div class=\"wrapper\">   \r\n  <rte-app-title></rte-app-title>\r\n</div>\r\n\r\n<div #form>\r\n  <rte-app-rte-integration-system-search [toolbarObject]=\"toolbarObject\" [systemList]=\"systemList\" *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n  </rte-app-rte-integration-system-search>\r\n\r\n  <rte-app-rte-integration-system-table [toolbarObject]=\"toolbarObject\" *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n  </rte-app-rte-integration-system-table>\r\n\r\n  <rte-app-rte-integration-system-form #integrationSystemForm [toolbarObject]=\"toolbarObject\" [systemList]=\"systemList\" [hidden]=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching\">\r\n  </rte-app-rte-integration-system-form>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    RteIntegrationSystemComponent.ctorParameters = function () { return [
        { type: RteIntegrationSystemService },
        { type: RTEAlertService },
        { type: SystemService }
    ]; };
    return RteIntegrationSystemComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IntegrationSystemCompany = /** @class */ (function () {
    function IntegrationSystemCompany() {
    }
    return IntegrationSystemCompany;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteIntegrationCompanyModalComponent = /** @class */ (function () {
    function RteIntegrationCompanyModalComponent(dialog, data, _ngZone, rteAlert) {
        this.dialog = dialog;
        this._ngZone = _ngZone;
        this.rteAlert = rteAlert;
        this.toolbarObjectParent = data.toolbarObject;
        this.currentStatus = data.status;
        this.toolbarObject = new RteLocalDataToolbarViewModel();
        /** @type {?} */
        var integrationCompanyInfos = _.cloneDeep(this.toolbarObjectParent.current.IntegrationCompanyInfos);
        this.toolbarObject.dataSource = new RteToolbarDataSource(integrationCompanyInfos);
        if (data.currentRow) {
            /** @type {?} */
            var current = _.head(_.filter(this.toolbarObject.dataSource.data, function (obj) {
                return obj.Id === data.currentRow.Id;
            }));
            this.toolbarObject.current = (current) ? current : new IntegrationSystemCompany();
        }
        this.companies = data.companies;
        this.providers = data.providers;
    }
    /**
     * @param {?} validItem
     * @return {?}
     */
    RteIntegrationCompanyModalComponent.prototype.validateItemEvent = /**
     * @param {?} validItem
     * @return {?}
     */
    function (validItem) {
        validItem.cancelConfirm = false;
    };
    /**
     * @param {?} localDataSourceResult
     * @return {?}
     */
    RteIntegrationCompanyModalComponent.prototype.closeEvent = /**
     * @param {?} localDataSourceResult
     * @return {?}
     */
    function (localDataSourceResult) {
        this.toolbarObjectParent.current.IntegrationCompanyInfos = localDataSourceResult.newData;
    };
    /**
     * @return {?}
     */
    RteIntegrationCompanyModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    RteIntegrationCompanyModalComponent.prototype.triggerResize = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this._ngZone.onStable.pipe(take(1))
            .subscribe(function () { return _this.autosize.resizeToFitContent(true); });
    };
    RteIntegrationCompanyModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-rte-integration-company-modal',
                    template: "<rte-local-data-toolbar rte-dialog-title [toolbarObject]=\"toolbarObject\" (validateItemEvent)=\"validateItemEvent($event)\"\r\n    (closeEvent)=\"closeEvent($event)\"></rte-local-data-toolbar>\r\n<form #ObjectForm=\"ngForm\" autocomplete=\"off\">\r\n    <div class=\"row-form\">\r\n        <div class=\"column-form\">\r\n            <rte-form-field>\r\n                <rte-select placeholder=\"Empresa\" [(ngModel)]=\"toolbarObject.current.CompanyId\" name=\"Company\" required>\r\n                    <rte-option *ngFor=\"let item of companies\" [value]=\"item.Id\">\r\n                        {{ item.Description }}\r\n                    </rte-option>\r\n                </rte-select>\r\n            </rte-form-field>\r\n        </div>\r\n        <div class=\"column-form\">\r\n            <rte-form-field>\r\n                <rte-select placeholder=\"Provedor\" [(ngModel)]=\"toolbarObject.current.ProviderEnumValue\"\r\n                    name=\"ProviderEnumValue\" required>\r\n                    <rte-option *ngFor=\"let item of providers\" [value]=\"item.BusinessValue\">\r\n                        {{ item.Description }}\r\n                    </rte-option>\r\n                </rte-select>\r\n            </rte-form-field>\r\n        </div>\r\n    </div>\r\n    <div class=\"row-form\">\r\n        <div class=\"column-form\">\r\n            <rte-form-field>\r\n                <textarea rteInput disable-uppercase placeholder=\"Value\" name=\"Value\" [(ngModel)]=\"toolbarObject.current.Value\"\r\n                    cdkTextareaAutosize #autosize=\"cdkTextareaAutosize\" cdkAutosizeMinRows=\"1\"\r\n                    cdkAutosizeMaxRows=\"5\"></textarea>\r\n            </rte-form-field>\r\n        </div>\r\n    </div>\r\n\r\n</form>\r\n<rte-app-rte-integration-company-modal-table [toolbarObject]=\"toolbarObject\" [companies]=\"companies\" [providers]=\"providers\" >\r\n</rte-app-rte-integration-company-modal-table>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    RteIntegrationCompanyModalComponent.ctorParameters = function () { return [
        { type: RteDialog },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] },
        { type: NgZone },
        { type: RTEAlertService }
    ]; };
    RteIntegrationCompanyModalComponent.propDecorators = {
        autosize: [{ type: ViewChild, args: ['autosize',] }]
    };
    return RteIntegrationCompanyModalComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteIntegrationCompanyTableComponent = /** @class */ (function () {
    function RteIntegrationCompanyTableComponent(dialog, companyService, enumService) {
        this.dialog = dialog;
        this.companyService = companyService;
        this.enumService = enumService;
        this.displayedColumns = ['Id', 'CompanyId', 'ProviderEnumValue'];
        this.selectionModel = new SelectionModel(true, []);
    }
    /**
     * @return {?}
     */
    RteIntegrationCompanyTableComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.companyService.getAllCompanies().toPromise()];
                    case 1:
                        _a.companies = _c.sent();
                        _b = this;
                        return [4 /*yield*/, this.enumService.getCollection('IntegrationProviderEnum').toPromise()];
                    case 2:
                        _b.providers = _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} newRow
     * @return {?}
     */
    RteIntegrationCompanyTableComponent.prototype.setCurrentRow = /**
     * @param {?} newRow
     * @return {?}
     */
    function (newRow) {
        this.currentRow = newRow;
        if (this.selectionModel.isSelected(newRow) === false) {
            this.selectionModel.toggle(newRow);
        }
    };
    /**
     * @param {?} element
     * @return {?}
     */
    RteIntegrationCompanyTableComponent.prototype.add = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        this.openDialogMode(element, 3);
        this.currentRow = new Object();
    };
    /**
     * @param {?} element
     * @return {?}
     */
    RteIntegrationCompanyTableComponent.prototype.edit = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        if (this.selectionModel.selected && this.selectionModel.selected.length > 0) {
            this.currentRow = this.selectionModel.selected[0];
        }
        else {
            this.currentRow = new Object();
        }
        this.openDialogMode(element, 4);
    };
    /**
     * @param {?} row
     * @param {?} status
     * @return {?}
     */
    RteIntegrationCompanyTableComponent.prototype.openDialogMode = /**
     * @param {?} row
     * @param {?} status
     * @return {?}
     */
    function (row, status) {
        if (this.toolbarObject.currentStatus !== this.toolbarObject.possibleStatus.Viewing) {
            this.openDialog(RteIntegrationCompanyModalComponent, status);
        }
    };
    /**
     * @param {?} dialogref
     * @param {?} status
     * @return {?}
     */
    RteIntegrationCompanyTableComponent.prototype.openDialog = /**
     * @param {?} dialogref
     * @param {?} status
     * @return {?}
     */
    function (dialogref, status) {
        /** @type {?} */
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '1000px';
        dialogConfig.disableClose = true;
        dialogConfig.data = {
            status: status,
            currentRow: (status === 4 ? this.currentRow : new IntegrationSystemCompany()),
            toolbarObject: this.toolbarObject,
            companies: this.companies,
            providers: this.providers
        };
        /** @type {?} */
        var currentDialog = this.dialog.customOpen(dialogref, dialogConfig);
    };
    /**
     * @param {?} companyId
     * @return {?}
     */
    RteIntegrationCompanyTableComponent.prototype.getCompanyDescription = /**
     * @param {?} companyId
     * @return {?}
     */
    function (companyId) {
        /** @type {?} */
        var currentCompany = _.head(_.filter(this.companies, function (company) {
            return company.Id === companyId;
        }));
        return currentCompany ? currentCompany.Description : '';
    };
    /**
     * @param {?} providerId
     * @return {?}
     */
    RteIntegrationCompanyTableComponent.prototype.getProviderDescription = /**
     * @param {?} providerId
     * @return {?}
     */
    function (providerId) {
        /** @type {?} */
        var currentProvider = _.head(_.filter(this.providers, function (provider) {
            return provider.BusinessValue === providerId;
        }));
        return currentProvider ? currentProvider.Description : '';
    };
    RteIntegrationCompanyTableComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-rte-integration-company-table',
                    template: "<div class=\"wrapper\">\r\n  <rte-card>\r\n    <mat-card-title>\r\n      <rte-toolbar-minor *ngIf=\"toolbarObject.currentStatus == toolbarObject.possibleStatus.Creating ||\r\n          toolbarObject.currentStatus == toolbarObject.possibleStatus.Editing\" #toolbarObjects\r\n        (addEvent)=\"add(toolbarObject.current)\" (editEvent)=\"edit(toolbarObject.current)\"></rte-toolbar-minor>\r\n    </mat-card-title>\r\n    <mat-card-content>\r\n      <div class=\"mat-elevation-z4\">\r\n        <rte-table [dataSource]=\"toolbarObject.current.IntegrationCompanyInfos\">\r\n          <ng-container rteColumnDef=\"Id\">\r\n            <rte-header-cell *rteHeaderCellDef>Id</rte-header-cell>\r\n            <rte-cell *rteCellDef=\"let object\">{{object.Id}}</rte-cell>\r\n          </ng-container>\r\n\r\n          <ng-container rteColumnDef=\"CompanyId\">\r\n            <rte-header-cell *rteHeaderCellDef>Empresa</rte-header-cell>\r\n            <rte-cell *rteCellDef=\"let object\">{{getCompanyDescription(object.CompanyId)}}</rte-cell>\r\n          </ng-container>\r\n\r\n          <ng-container rteColumnDef=\"ProviderEnumValue\">\r\n            <rte-header-cell *rteHeaderCellDef>Provider</rte-header-cell>\r\n            <rte-cell *rteCellDef=\"let object\">{{getProviderDescription(object.ProviderEnumValue)}}</rte-cell>\r\n          </ng-container>\r\n\r\n          <rte-header-row *rteHeaderRowDef=\"displayedColumns\"></rte-header-row>\r\n          <rte-row *rteRowDef=\"let row; columns: displayedColumns;\" (click)=\"setCurrentRow(row)\"\r\n            (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"\r\n            [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted, selected: selectionModel.isSelected(row)}\">\r\n          </rte-row>\r\n        </rte-table>\r\n        <rte-paginator [pageSize]=\"10\" [pageSizeOptions]=\"[5, 10, 20]\" showFirstLastButtons>\r\n        </rte-paginator>\r\n      </div>\r\n    </mat-card-content>\r\n  </rte-card>\r\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    RteIntegrationCompanyTableComponent.ctorParameters = function () { return [
        { type: RteDialog },
        { type: RteCompanyService },
        { type: EnumListService }
    ]; };
    RteIntegrationCompanyTableComponent.propDecorators = {
        toolbarObject: [{ type: Input }],
        sort: [{ type: ViewChild, args: [MatSort,] }],
        paginator: [{ type: ViewChild, args: [MatPaginator,] }]
    };
    return RteIntegrationCompanyTableComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteIntegrationCompanyModalTableComponent = /** @class */ (function () {
    function RteIntegrationCompanyModalTableComponent() {
        this.displayedColumns = ['Id', 'CompanyId', 'ProviderEnumValue'];
    }
    /**
     * @return {?}
     */
    RteIntegrationCompanyModalTableComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} companyId
     * @return {?}
     */
    RteIntegrationCompanyModalTableComponent.prototype.getCompanyDescription = /**
     * @param {?} companyId
     * @return {?}
     */
    function (companyId) {
        /** @type {?} */
        var currentCompany = _.head(_.filter(this.companies, function (company) {
            return company.Id === companyId;
        }));
        return currentCompany ? currentCompany.Description : '';
    };
    /**
     * @param {?} providerId
     * @return {?}
     */
    RteIntegrationCompanyModalTableComponent.prototype.getProviderDescription = /**
     * @param {?} providerId
     * @return {?}
     */
    function (providerId) {
        /** @type {?} */
        var currentProvider = _.head(_.filter(this.providers, function (provider) {
            return provider.BusinessValue === providerId;
        }));
        return currentProvider ? currentProvider.Description : '';
    };
    RteIntegrationCompanyModalTableComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-rte-integration-company-modal-table',
                    template: "<rte-card>\r\n  <mat-card-content>\r\n    <rte-table [dataSource]=\"toolbarObject.getCleanDataSource()\">\r\n      <ng-container rteColumnDef=\"Id\">\r\n        <rte-header-cell *rteHeaderCellDef>Id</rte-header-cell>\r\n        <rte-cell *rteCellDef=\"let object\">{{object.Id}}</rte-cell>\r\n      </ng-container>\r\n\r\n      <ng-container rteColumnDef=\"CompanyId\">\r\n        <rte-header-cell *rteHeaderCellDef>CompanyId</rte-header-cell>\r\n        <rte-cell *rteCellDef=\"let object\">{{getCompanyDescription(object.CompanyId)}}</rte-cell>\r\n      </ng-container>\r\n\r\n      <ng-container rteColumnDef=\"ProviderEnumValue\">\r\n        <rte-header-cell *rteHeaderCellDef>ProviderEnumValue</rte-header-cell>\r\n        <rte-cell *rteCellDef=\"let object\">{{getProviderDescription(object.ProviderEnumValue)}}</rte-cell>\r\n      </ng-container>\r\n\r\n      <rte-header-row *rteHeaderRowDef=\"displayedColumns\"></rte-header-row>\r\n      <rte-row *rteRowDef=\"let row; columns: displayedColumns;\" (click)=\"toolbarObject.setCurrent(row)\"\r\n        (mouseover)=\"row.hovered = true\" (mouseout)=\"row.hovered = false\"\r\n        [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted, selected: toolbarObject.selectionModel.isSelected(row)}\">\r\n      </rte-row>\r\n    </rte-table>\r\n  </mat-card-content>\r\n</rte-card>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    RteIntegrationCompanyModalTableComponent.ctorParameters = function () { return []; };
    RteIntegrationCompanyModalTableComponent.propDecorators = {
        toolbarObject: [{ type: Input }],
        companies: [{ type: Input }],
        providers: [{ type: Input }]
    };
    return RteIntegrationCompanyModalTableComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteIntegrationSystemModule = /** @class */ (function () {
    function RteIntegrationSystemModule() {
    }
    /**
     * @param {?} environment
     * @return {?}
     */
    RteIntegrationSystemModule.forRoot = /**
     * @param {?} environment
     * @return {?}
     */
    function (environment) {
        return {
            ngModule: RteIntegrationSystemModule,
            providers: [
                RteIntegrationSystemService,
                {
                    provide: 'environment',
                    useValue: environment
                }
            ]
        };
    };
    RteIntegrationSystemModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        RteToolbarModule,
                        RteAppTitleModule,
                        RteMaterialModule,
                        RteToolbarMinorModule,
                        MatRippleModule,
                        MatCheckboxModule,
                        MatSelectModule,
                        MatOptionModule,
                        MatListModule,
                        MatTableModule,
                        MatIconModule,
                        MatAutocompleteModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatProgressSpinnerModule,
                        MatToolbarModule,
                        MatDialogModule,
                        MatCardModule,
                        CdkTableModule,
                        MatDividerModule,
                        FormsModule,
                        RteLibraryModule
                    ],
                    declarations: [
                        RteIntegrationSystemComponent,
                        RteIntegrationSystemSearchComponent,
                        RteIntegrationSystemFormComponent,
                        RteIntegrationSystemTableComponent,
                        RteIntegrationCompanyTableComponent,
                        RteIntegrationCompanyModalComponent,
                        RteIntegrationCompanyModalTableComponent
                    ],
                    exports: [RteIntegrationSystemComponent],
                    entryComponents: [RteIntegrationCompanyModalComponent]
                },] }
    ];
    return RteIntegrationSystemModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { RteCoreAppService, RteCoreAppComponent, RteCoreAppModule, RteLoginModule, DialogPasswordComponent, RteUserModule, UserComponent, UserActionsComponent, RteSearchApplicationModule, SearchApplicationComponent, RteAssemblyRegisterModule, AssemblyRegisterComponent, MyErrorStateMatcher$1 as MyErrorStateMatcher, RteObjectModule, ObjectComponent, ObjectModel, ObjectService, RteSystemModule, SystemComponent, Menu, MenuComponent, RTE_MENU_SERVICE_DATA, RteMenuModule, NavbarComponent, RteSmtpModule, SmtpComponent, RteCompanyGroupModule, CompanyGroupComponent, RteCompanyModule, CompanyComponent, RteObjectGroupModule, ObjectGroupComponent, RteMenuInputModule, MenuInputComponent, RteParameterModule, ParameterComponent, RteAttributeModule, AttributeComponent, RteIntegrationSystemModule, RteIntegrationSystemComponent, MaterialModule as ɵbh, AssemblyService as ɵe, AttributeFormComponent as ɵcd, AttributeSearchComponent as ɵcf, AttributeTableComponent as ɵce, RteAttributeService as ɵcg, CompanyGroupFormComponent as ɵq, CompanyGroupGridComponent as ɵt, CompanyGroupSearchComponent as ɵs, RteCompanyGroupService as ɵr, CompanyFormComponent as ɵu, CompanyColorComponent as ɵw, CompanyImageComponent as ɵv, CompanyGridComponent as ɵy, CompanySearchComponent as ɵz, RteCompanyService as ɵx, RteIntegrationCompanyModalTableComponent as ɵcn, RteIntegrationCompanyModalComponent as ɵcm, RteIntegrationCompanyTableComponent as ɵcl, RteIntegrationSystemFormComponent as ɵcj, RteIntegrationSystemSearchComponent as ɵci, RteIntegrationSystemTableComponent as ɵck, RteIntegrationSystemService as ɵch, LoginService as ɵb, LoginComponent as ɵa, MenuInputFormComponent as ɵbl, MenuInputSearchComponent as ɵbo, MenuInputTableComponent as ɵbm, LanguageService as ɵbp, MenuInputService as ɵbn, ModalGridComponent as ɵbg, ModalObjectRegisterComponent as ɵbf, ObjectGroupFormGridComponent as ɵbe, ObjectGroupFormComponent as ɵba, ObjectGroupGridComponent as ɵbc, ObjectGroupSearchComponent as ɵbd, ObjectGroupService as ɵbb, RteObjectLovModalComponent as ɵbk, RteObjectLovComponent as ɵbj, RteObjectLovModule as ɵbi, ObjectFormComponent as ɵf, ObjectSearchComponent as ɵg, ObjectTableComponent as ɵh, AttributesDialogComponent as ɵbw, ParameterAttributesComponent as ɵbr, DetailsDialogComponent as ɵbx, EditModeDirective as ɵca, EditableOnEnterDirective as ɵcb, FocusableDirective as ɵcc, ViewModeDirective as ɵbz, EditableTableComponent as ɵby, ParameterDetailsComponent as ɵbs, ParameterFormComponent as ɵbq, ParameterSearchComponent as ɵbu, ParameterTableComponent as ɵbv, RteParameterService as ɵbt, SmtpFormComponent as ɵm, SmtpGridComponent as ɵo, SmtpSearchComponent as ɵp, SmtpService as ɵn, SystemFormComponent as ɵi, SystemGridComponent as ɵl, SystemSearchComponent as ɵj, UserService as ɵc, UserformComponent as ɵd, SystemService as ɵk };

//# sourceMappingURL=rte-core-app.js.map